webpackJsonp([114276838955818,60335399758886],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(380);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _layout = __webpack_require__(340);
	
	Object.defineProperty(exports, 'Box', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Box;
	  }
	});
	Object.defineProperty(exports, 'Flex', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Flex;
	  }
	});
	Object.defineProperty(exports, 'Block', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Block;
	  }
	});
	Object.defineProperty(exports, 'Inline', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Inline;
	  }
	});
	Object.defineProperty(exports, 'InlineFlex', {
	  enumerable: true,
	  get: function get() {
	    return _layout.InlineFlex;
	  }
	});
	Object.defineProperty(exports, 'A', {
	  enumerable: true,
	  get: function get() {
	    return _layout.A;
	  }
	});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var emotion = __webpack_require__(94);
	var createEmotionStyled = _interopDefault(__webpack_require__(134));
	
	var index = createEmotionStyled(emotion, React);
	
	exports['default'] = index;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _text = __webpack_require__(355);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(201);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _icon = __webpack_require__(336);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperties = __webpack_require__(382);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _freeze = __webpack_require__(383);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (strings, raw) {
	  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
	    raw: {
	      value: (0, _freeze2.default)(raw)
	    }
	  }));
	};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57),
	    getRawTag = __webpack_require__(581),
	    objectToString = __webpack_require__(609);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }
	
	var _function = __webpack_require__(708);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _react = __webpack_require__(1);
	
	var PureComponent = (function (_Component) {
	  function PureComponent() {
	    _classCallCheck(this, PureComponent);
	
	    if (_Component != null) {
	      _Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(PureComponent, _Component);
	
	  return PureComponent;
	})(_react.Component);
	
	exports['default'] = PureComponent;
	
	PureComponent.prototype.shouldComponentUpdate = _function2['default'];
	module.exports = exports['default'];

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterStyleProps = exports.omitStyles = exports.pickStyles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _omitBy2 = __webpack_require__(633);
	
	var _omitBy3 = _interopRequireDefault(_omitBy2);
	
	var _pickBy2 = __webpack_require__(267);
	
	var _pickBy3 = _interopRequireDefault(_pickBy2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isNumber2 = __webpack_require__(627);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	exports.cleanProps = cleanProps;
	exports.parseStyle = parseStyle;
	exports.parseStyleProps = parseStyleProps;
	exports.stylePropTransform = stylePropTransform;
	exports.spacing = spacing;
	
	var _styleWhitelist = __webpack_require__(365);
	
	var _styleWhitelist2 = _interopRequireDefault(_styleWhitelist);
	
	var _propWhitelist = __webpack_require__(364);
	
	var _propWhitelist2 = _interopRequireDefault(_propWhitelist);
	
	var _array = __webpack_require__(362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SPACING_REGEX = /^(padding|margin)(Top|Right|Bottom|Left)?$/;
	
	
	var SPACING_MAP = {
	  none: '0',
	  'extra-small': 2,
	  small: 4,
	  medium: 8,
	  large: 16,
	  'extra-large': 24
	};
	
	/**
	 * Removes props that haven’t been whitelisted, to ensure
	 * that non-valid props don’t pollute the DOM
	 */
	function cleanProps(originalProps) {
	  var cleanedProps = Object.keys(originalProps).filter(function (key) {
	    return _propWhitelist2.default.test(key);
	  }).reduce(function (obj, key) {
	    var obj2 = (0, _extends3.default)({}, obj);
	    obj2[key] = originalProps[key];
	    return obj2;
	  }, {});
	
	  return cleanedProps;
	}
	
	/** 
	 * Flexbox style overrides for Safari 8
	 * Safari 8 detection is performed in advance
	 */
	var VENDOR_STYLERS = typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Safari/') !== -1 && window.navigator.userAgent.indexOf('Version/8') !== -1 ? {
	  display: function display(key, value) {
	    return {
	      key: key,
	      value: (value.indexOf('flex') > -1 ? '-webkit-' : '') + value
	    };
	  },
	  alignContent: function alignContent(key, value) {
	    return { key: 'WebkitAlignContent', value: value };
	  },
	  alignItems: function alignItems(key, value) {
	    return { key: 'WebkitAlignItems', value: value };
	  },
	  alignSelf: function alignSelf(key, value) {
	    return { key: 'WebkitAlignSelf', value: value };
	  },
	  justifyContent: function justifyContent(key, value) {
	    return { key: 'WebkitJustifyContent', value: value };
	  },
	  order: function order(key, value) {
	    return { key: 'WebkitOrder', value: value };
	  },
	  flexDirection: function flexDirection(key, value) {
	    return { key: 'WebkitFlexDirection', value: value };
	  },
	  flexWrap: function flexWrap(key, value) {
	    return { key: 'WebkitFlexWrap', value: value };
	  },
	  flexFlow: function flexFlow(key, value) {
	    return { key: 'WebkitFlexFlow', value: value };
	  },
	  flex: function flex(key, value) {
	    return { key: 'WebkitFlex', value: value };
	  },
	  flexBasis: function flexBasis(key, value) {
	    return { key: 'WebkitFlexBasis', value: value };
	  },
	  flexShrink: function flexShrink(key, value) {
	    return { key: 'WebkitFlexShrink', value: value };
	  },
	  flexGrow: function flexGrow(key, value) {
	    return { key: 'WebkitFlexGrow', value: value };
	  }
	} : {};
	
	/** Parse a specific style */
	function parseStyle(name, value) {
	  if (SPACING_REGEX.test(name)) {
	    return (0, _array.returnArray)(value).map(function (v) {
	      if ((0, _isNumber3.default)(v)) {
	        return String(v) + 'px';
	        // $FlowFixMe
	      } else if ((0, _isString3.default)(v) && SPACING_MAP[v]) {
	        return SPACING_MAP[v] + 'px';
	      }
	      return v;
	    }).join(' ');
	  }
	
	  return value;
	}
	
	/** Pull out styles from props */
	function parseStyleProps(originalProps) {
	  var props = {};
	  var style = originalProps.style || {};
	
	  for (var key in originalProps) {
	    if ({}.hasOwnProperty.call(originalProps, key)) {
	      if (_styleWhitelist2.default[key]) {
	        var parsedStyleValue = parseStyle(key, originalProps[key]);
	        if (!!VENDOR_STYLERS[key]) {
	          var pair = VENDOR_STYLERS[key](key, parsedStyleValue);
	          style[pair.key] = pair.value;
	        } else {
	          style[key] = parsedStyleValue;
	        }
	      } else if (key !== 'style') {
	        props[key] = originalProps[key];
	      }
	    }
	  }
	
	  return { props: props, style: style };
	}
	
	function stylePropTransform(originalProps) {
	  var props = {};
	
	  Object.keys(originalProps).map(function (prop) {
	    if (_styleWhitelist2.default[prop]) {
	      props[prop] = parseStyle(prop, originalProps[prop]);
	      return props[prop];
	    }
	    return false;
	  });
	
	  return props;
	}
	
	/** Filter keys on an object to those from our STYLE_WHITELIST */
	var pickStyles = exports.pickStyles = function pickStyles(obj
	// $FlowFixMe
	) {
	  return (0, _pickBy3.default)(obj, function (v, key) {
	    return _styleWhitelist2.default[key];
	  });
	};
	
	var omitStyles = exports.omitStyles = function omitStyles(obj
	// $FlowFixMe
	) {
	  return (0, _omitBy3.default)(obj, function (v, key) {
	    return _styleWhitelist2.default[key];
	  });
	};
	
	/**
	 * Transforms margin and padding props in to real pixel values.
	 * We use this rather than the built in Emotion transformers
	 * to transform our custom scale values ('small', 'medium' etc.)
	 */
	function spacing(originalProps) {
	  var props = {};
	  Object.keys(originalProps).filter(function (prop) {
	    return SPACING_REGEX.test(prop);
	  }).map(function (prop) {
	    props[prop] = (0, _array.returnArray)(originalProps[prop]).map(function (val) {
	      return (0, _isNumber3.default)(val) ? String(val) + 'px' : // $FlowFixMe
	      (0, _isString3.default)(val) && SPACING_MAP[val] ? SPACING_MAP[val] + 'px' : val;
	    }).join(' ');
	
	    return props[prop];
	  });
	
	  return props;
	}
	
	/**
	 * Filters style props to be passed back to emotion as
	 * a CSS object. Emotion takes care of the rest.
	 *
	 * We also remove spacing props, as these are transformed
	 * in a seperate function (see 'spacing' function below)
	 */
	var filterStyleProps = exports.filterStyleProps = function filterStyleProps(originalProps) {
	  var filteredProps = Object.keys(originalProps).filter(function (key) {
	    return _styleWhitelist2.default[key];
	  }).filter(function (key) {
	    return !SPACING_REGEX.test(key);
	  }).reduce(function (obj, key) {
	    var obj2 = obj;
	    obj2[key] = originalProps[key];
	    return obj2;
	  }, {});
	  return filteredProps;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(201);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(98),
	    baseAssignValue = __webpack_require__(100);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(545),
	    getValue = __webpack_require__(582);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(29);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(13),
	    isKey = __webpack_require__(154),
	    stringToPath = __webpack_require__(619),
	    toString = __webpack_require__(637);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(159);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(156),
	    isLength = __webpack_require__(157);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isArray = __webpack_require__(13),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(239),
	    baseKeys = __webpack_require__(547),
	    isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _heading = __webpack_require__(332);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_heading).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function hashString(str) {
	  return murmurhash2_32_gc(str, str.length).toString(36);
	}
	
	function murmurhash2_32_gc(str, seed) {
	  var l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return h >>> 0;
	}
	
	var pa = function fa(ha) {
	  function V(b, c, d, k, l) {
	    for (var a = 0, f = 0, n = 0, e = 0, h, q, m, v = 0, A = 0, B = 0, x = 0, C = 0, p = 0, G = 0, r = 0, N = q = 0, L = 0, t = 0, D = d.length, F = D - 1, g = "", u = "", S = "", M = "", H; r < D;) {
	      m = d.charCodeAt(r);
	      r === F && 0 !== f + e + n + a && (0 !== f && (m = 47 === f ? 10 : 47), e = n = a = 0, D++, F++);
	
	      if (0 === f + e + n + a) {
	        if (r === F && (0 < q && (g = g.replace(P, "")), 0 < g.trim().length)) {
	          switch (m) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              g += d.charAt(r);
	          }
	
	          m = 59;
	        }
	
	        if (1 === N) switch (m) {
	          case 123:
	          case 125:
	          case 59:
	          case 34:
	          case 39:
	          case 40:
	          case 41:
	          case 44:
	            N = 0;
	
	          case 9:
	          case 13:
	          case 10:
	          case 32:
	            break;
	
	          default:
	            for (N = 0, t = r, h = m, r--, m = 59; t < D;) {
	              switch (d.charCodeAt(++t)) {
	                case 10:
	                case 13:
	                case 59:
	                  r++, m = h;
	
	                case 58:
	                case 123:
	                  t = D;
	              }
	            }
	
	        }
	
	        switch (m) {
	          case 123:
	            g = g.trim();
	            h = g.charCodeAt(0);
	            x = 1;
	
	            for (t = ++r; r < D;) {
	              m = d.charCodeAt(r);
	
	              switch (m) {
	                case 123:
	                  x++;
	                  break;
	
	                case 125:
	                  x--;
	              }
	
	              if (0 === x) break;
	              r++;
	            }
	
	            p = d.substring(t, r);
	            0 === h && (h = (g = g.replace(qa, "").trim()).charCodeAt(0));
	
	            switch (h) {
	              case 64:
	                0 < q && (g = g.replace(P, ""));
	                q = g.charCodeAt(1);
	
	                switch (q) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    h = c;
	                    break;
	
	                  default:
	                    h = W;
	                }
	
	                p = V(c, h, p, q, l + 1);
	                t = p.length;
	                0 < X && 0 === t && (t = g.length);
	                0 < E && (h = ia(W, g, L), H = O(3, p, h, c, I, y, t, q, l), g = h.join(""), void 0 !== H && 0 === (t = (p = H.trim()).length) && (q = 0, p = ""));
	                if (0 < t) switch (q) {
	                  case 115:
	                    g = g.replace(ra, sa);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    p = g + "{" + p + "}";
	                    break;
	
	                  case 107:
	                    g = g.replace(ta, "$1 $2" + (0 < Q ? T : ""));
	                    p = g + "{" + p + "}";
	                    p = 1 === w || 2 === w && U("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
	                    break;
	
	                  default:
	                    p = g + p, 112 === k && (p = (u += p, ""));
	                } else p = "";
	                break;
	
	              default:
	                p = V(c, ia(c, g, L), p, k, l + 1);
	            }
	
	            S += p;
	            p = L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	            break;
	
	          case 125:
	          case 59:
	            g = (0 < q ? g.replace(P, "") : g).trim();
	            if (1 < (t = g.length)) switch (0 === G && (h = g.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (t = (g = g.replace(" ", ":")).length), 0 < E && void 0 !== (H = O(1, g, c, b, I, y, u.length, k, l)) && 0 === (t = (g = H.trim()).length) && (g = "\x00\x00"), h = g.charCodeAt(0), q = g.charCodeAt(1), h + q) {
	              case 0:
	                break;
	
	              case 169:
	              case 163:
	                M += g + d.charAt(r);
	                break;
	
	              default:
	                58 !== g.charCodeAt(t - 1) && (u += ja(g, h, q, g.charCodeAt(2)));
	            }
	            L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	        }
	      }
	
	      switch (m) {
	        case 13:
	        case 10:
	          if (0 === f + e + n + a + ka) switch (B) {
	            case 41:
	            case 39:
	            case 34:
	            case 64:
	            case 126:
	            case 62:
	            case 42:
	            case 43:
	            case 47:
	            case 45:
	            case 58:
	            case 44:
	            case 59:
	            case 123:
	            case 125:
	              break;
	
	            default:
	              0 < G && (N = 1);
	          }
	          47 === f ? f = 0 : 0 === z + C && (q = 1, g += "\x00");
	          0 < E * la && O(0, g, c, b, I, y, u.length, k, l);
	          y = 1;
	          I++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === f + e + n + a) {
	            y++;
	            break;
	          }
	
	        default:
	          y++;
	          h = d.charAt(r);
	
	          switch (m) {
	            case 9:
	            case 32:
	              if (0 === e + a + f) switch (v) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  h = "";
	                  break;
	
	                default:
	                  32 !== m && (h = " ");
	              }
	              break;
	
	            case 0:
	              h = "\\0";
	              break;
	
	            case 12:
	              h = "\\f";
	              break;
	
	            case 11:
	              h = "\\v";
	              break;
	
	            case 38:
	              0 === e + f + a && 0 < z && (q = L = 1, h = "\f" + h);
	              break;
	
	            case 108:
	              if (0 === e + f + a + J && 0 < G) switch (r - G) {
	                case 2:
	                  112 === v && 58 === d.charCodeAt(r - 3) && (J = v);
	
	                case 8:
	                  111 === A && (J = A);
	              }
	              break;
	
	            case 58:
	              0 === e + f + a && (G = r);
	              break;
	
	            case 44:
	              0 === f + n + e + a && (q = 1, h += "\r");
	              break;
	
	            case 34:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 39:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 91:
	              0 === e + f + n && a++;
	              break;
	
	            case 93:
	              0 === e + f + n && a--;
	              break;
	
	            case 41:
	              0 === e + f + a && n--;
	              break;
	
	            case 40:
	              if (0 === e + f + a) {
	                if (0 === C) switch (2 * v + 3 * A) {
	                  case 533:
	                    break;
	
	                  default:
	                    x = 0, C = 1;
	                }
	                n++;
	              }
	
	              break;
	
	            case 64:
	              0 === f + n + e + a + G + p && (p = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < e + a + n)) switch (f) {
	                case 0:
	                  switch (2 * m + 3 * d.charCodeAt(r + 1)) {
	                    case 235:
	                      f = 47;
	                      break;
	
	                    case 220:
	                      t = r, f = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === m && 42 === v && (33 === d.charCodeAt(t + 2) && (u += d.substring(t, r + 1)), h = "", f = 0);
	              }
	          }
	
	          if (0 === f) {
	            if (0 === z + e + a + p && 107 !== k && 59 !== m) switch (m) {
	              case 44:
	              case 126:
	              case 62:
	              case 43:
	              case 41:
	              case 40:
	                if (0 === C) {
	                  switch (v) {
	                    case 9:
	                    case 32:
	                    case 10:
	                    case 13:
	                      h += "\x00";
	                      break;
	
	                    default:
	                      h = "\x00" + h + (44 === m ? "" : "\x00");
	                  }
	
	                  q = 1;
	                } else switch (m) {
	                  case 40:
	                    C = ++x;
	                    break;
	
	                  case 41:
	                    0 === (C = --x) && (q = 1, h += "\x00");
	                }
	
	                break;
	
	              case 9:
	              case 32:
	                switch (v) {
	                  case 0:
	                  case 123:
	                  case 125:
	                  case 59:
	                  case 44:
	                  case 12:
	                  case 9:
	                  case 32:
	                  case 10:
	                  case 13:
	                    break;
	
	                  default:
	                    0 === C && (q = 1, h += "\x00");
	                }
	
	            }
	            g += h;
	            32 !== m && 9 !== m && (B = m);
	          }
	
	      }
	
	      A = v;
	      v = m;
	      r++;
	    }
	
	    t = u.length;
	    0 < X && 0 === t && 0 === S.length && 0 === c[0].length === !1 && (109 !== k || 1 === c.length && (0 < z ? K : R) === c[0]) && (t = c.join(",").length + 2);
	
	    if (0 < t) {
	      if (0 === z && 107 !== k) {
	        d = 0;
	        a = c.length;
	
	        for (f = Array(a); d < a; ++d) {
	          v = c[d].split(ua);
	          A = "";
	          B = 0;
	
	          for (D = v.length; B < D; ++B) {
	            if (!(0 === (x = (e = v[B]).length) && 1 < D)) {
	              r = A.charCodeAt(A.length - 1);
	              L = e.charCodeAt(0);
	              n = "";
	              if (0 !== B) switch (r) {
	                case 42:
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 40:
	                  break;
	
	                default:
	                  n = " ";
	              }
	
	              switch (L) {
	                case 38:
	                  e = n + K;
	
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 41:
	                case 40:
	                  break;
	
	                case 91:
	                  e = n + e + K;
	                  break;
	
	                case 58:
	                  switch (2 * e.charCodeAt(1) + 3 * e.charCodeAt(2)) {
	                    case 530:
	                      if (0 < Y) {
	                        e = n + e.substring(8, x - 1);
	                        break;
	                      }
	
	                    default:
	                      if (1 > B || 1 > v[B - 1].length) e = n + K + e;
	                  }
	
	                  break;
	
	                case 44:
	                  n = "";
	
	                default:
	                  e = 1 < x && 0 < e.indexOf(":") ? n + e.replace(va, "$1" + K + "$2") : n + e + K;
	              }
	
	              A += e;
	            }
	          }
	
	          f[d] = A.replace(P, "").trim();
	        }
	
	        c = f;
	      }
	
	      h = c;
	      if (0 < E && (H = O(2, u, h, b, I, y, t, k, l), void 0 !== H && 0 === (u = H).length)) return M + u + S;
	      u = h.join(",") + "{" + u + "}";
	
	      if (0 !== w * J) {
	        2 !== w || U(u, 2) || (J = 0);
	
	        switch (J) {
	          case 111:
	            u = u.replace(wa, ":-moz-$1") + u;
	            break;
	
	          case 112:
	            u = u.replace(Z, "::-webkit-input-$1") + u.replace(Z, "::-moz-$1") + u.replace(Z, ":-ms-input-$1") + u;
	        }
	
	        J = 0;
	      }
	    }
	
	    return M + u + S;
	  }
	
	  function ia(b, c, d) {
	    var k = c.trim().split(xa);
	    c = k;
	    var l = k.length,
	        a = b.length;
	
	    switch (a) {
	      case 0:
	      case 1:
	        var f = 0;
	
	        for (b = 0 === a ? "" : b[0] + " "; f < l; ++f) {
	          c[f] = ma(b, c[f], d, a).trim();
	        }
	
	        break;
	
	      default:
	        var n = f = 0;
	
	        for (c = []; f < l; ++f) {
	          for (var e = 0; e < a; ++e) {
	            c[n++] = ma(b[e] + " ", k[f], d, a).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function ma(b, c, d, k) {
	    var l = c.charCodeAt(0);
	    33 > l && (l = (c = c.trim()).charCodeAt(0));
	
	    switch (l) {
	      case 38:
	        switch (z + k) {
	          case 0:
	          case 1:
	            if (0 === b.trim().length) break;
	
	          default:
	            return c.replace(M, "$1" + b.trim());
	        }
	
	        break;
	
	      case 58:
	        switch (c.charCodeAt(1)) {
	          case 103:
	            if (0 < Y && 0 < z) return c.replace(ya, "$1").replace(M, "$1" + R);
	            break;
	
	          default:
	            return b.trim() + c;
	        }
	
	      default:
	        if (0 < d * z && 0 < c.indexOf("\f")) return c.replace(M, (58 === b.charCodeAt(0) ? "" : "$1") + b.trim());
	    }
	
	    return b + c;
	  }
	
	  function ja(b, c, d, k) {
	    var l = 0,
	        a = b + ";";
	    c = 2 * c + 3 * d + 4 * k;
	
	    if (944 === c) {
	      l = a.length;
	      b = a.indexOf(":", 9) + 1;
	      d = a.substring(0, b).trim();
	      k = a.substring(b, l - 1).trim();
	
	      switch (a.charCodeAt(9) * Q) {
	        case 0:
	          break;
	
	        case 45:
	          if (110 !== a.charCodeAt(10)) break;
	
	        default:
	          for (a = k.split((k = "", za)), b = c = 0, l = a.length; c < l; b = 0, ++c) {
	            for (var f = a[c], n = f.split(Aa); f = n[b];) {
	              var e = f.charCodeAt(0);
	              if (1 === Q && (64 < e && 90 > e || 96 < e && 123 > e || 95 === e || 45 === e && 45 !== f.charCodeAt(1))) switch (isNaN(parseFloat(f)) + (-1 !== f.indexOf("("))) {
	                case 1:
	                  switch (f) {
	                    case "infinite":
	                    case "alternate":
	                    case "backwards":
	                    case "running":
	                    case "normal":
	                    case "forwards":
	                    case "both":
	                    case "none":
	                    case "linear":
	                    case "ease":
	                    case "ease-in":
	                    case "ease-out":
	                    case "ease-in-out":
	                    case "paused":
	                    case "reverse":
	                    case "alternate-reverse":
	                    case "inherit":
	                    case "initial":
	                    case "unset":
	                    case "step-start":
	                    case "step-end":
	                      break;
	
	                    default:
	                      f += T;
	                  }
	
	              }
	              n[b++] = f;
	            }
	
	            k += (0 === c ? "" : ",") + n.join(" ");
	          }
	
	      }
	
	      k = d + k + ";";
	      return 1 === w || 2 === w && U(k, 1) ? "-webkit-" + k + k : k;
	    }
	
	    if (0 === w || 2 === w && !U(a, 1)) return a;
	
	    switch (c) {
	      case 1015:
	        return 45 === a.charCodeAt(9) ? "-webkit-" + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return "-webkit-" + a + a;
	
	      case 978:
	        return "-webkit-" + a + "-moz-" + a + a;
	
	      case 1019:
	      case 983:
	        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
	
	      case 883:
	        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
	
	          case 98:
	            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
	        }
	        return "-webkit-" + a + "-ms-" + a + a;
	
	      case 964:
	        return "-webkit-" + a + "-ms-flex-" + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
	        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
	
	      case 1005:
	        return Ba.test(a) ? a.replace(na, ":-webkit-") + a.replace(na, ":-moz-") + a : a;
	
	      case 1E3:
	        b = a.substring(13).trim();
	        l = b.indexOf("-") + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(l)) {
	          case 226:
	            b = a.replace(aa, "tb");
	            break;
	
	          case 232:
	            b = a.replace(aa, "tb-rl");
	            break;
	
	          case 220:
	            b = a.replace(aa, "lr");
	            break;
	
	          default:
	            return a;
	        }
	
	        return "-webkit-" + a + "-ms-" + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf("sticky", 9)) break;
	
	      case 975:
	        l = (a = b).length - 10;
	        b = (33 === a.charCodeAt(l) ? a.substring(0, l) : a).substring(b.indexOf(":", 7) + 1).trim();
	
	        switch (c = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, "-webkit-" + b) + ";" + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, "-webkit-" + (102 < c ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
	        }
	
	        return a + ";";
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-flex-item-" + a.replace(Ca, "") + a;
	
	          default:
	            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "") + a;
	        }
	        break;
	
	      case 953:
	        if (0 < (l = a.indexOf("-content", 9)) && 109 === a.charCodeAt(l - 3) && 45 !== a.charCodeAt(l - 4)) return b = a.substring(l - 3), "width:-webkit-" + b + "width:-moz-" + b + "width:" + b;
	        break;
	
	      case 962:
	        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + k && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(Da, "$1-webkit-$2") + a;
	    }
	
	    return a;
	  }
	
	  function U(b, c) {
	    var d = b.indexOf(1 === c ? ":" : "{"),
	        k = b.substring(0, 3 !== c ? d : 10);
	    d = b.substring(d + 1, b.length - 1);
	    return ba(2 !== c ? k : k.replace(Ea, "$1"), d, c);
	  }
	
	  function sa(b, c) {
	    var d = ja(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return d !== c + ";" ? d.replace(Fa, " or ($1)").substring(4) : "(" + c + ")";
	  }
	
	  function O(b, c, d, k, l, a, f, n, e) {
	    for (var h = 0, q = c, m; h < E; ++h) {
	      switch (m = ca[h].call(F, b, q, d, k, l, a, f, n, e)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          q = m;
	      }
	    }
	
	    switch (q) {
	      case void 0:
	      case !1:
	      case !0:
	      case null:
	      case c:
	        break;
	
	      default:
	        return q;
	    }
	  }
	
	  function da(b) {
	    switch (b) {
	      case void 0:
	      case null:
	        E = ca.length = 0;
	        break;
	
	      default:
	        switch (b.constructor) {
	          case Array:
	            for (var c = 0, d = b.length; c < d; ++c) {
	              da(b[c]);
	            }
	
	            break;
	
	          case Function:
	            ca[E++] = b;
	            break;
	
	          case Boolean:
	            la = !!b | 0;
	        }
	
	    }
	
	    return da;
	  }
	
	  function ea(b) {
	    for (var c in b) {
	      var d = b[c];
	
	      switch (c) {
	        case "keyframe":
	          Q = d | 0;
	          break;
	
	        case "global":
	          Y = d | 0;
	          break;
	
	        case "cascade":
	          z = d | 0;
	          break;
	
	        case "compress":
	          oa = d | 0;
	          break;
	
	        case "semicolon":
	          ka = d | 0;
	          break;
	
	        case "preserve":
	          X = d | 0;
	          break;
	
	        case "prefix":
	          ba = null, d ? "function" !== typeof d ? w = 1 : (w = 2, ba = d) : w = 0;
	      }
	    }
	
	    return ea;
	  }
	
	  function F(b, c) {
	    if (void 0 !== this && this.constructor === F) return fa(b);
	    var d = b,
	        k = d.charCodeAt(0);
	    33 > k && (k = (d = d.trim()).charCodeAt(0));
	    0 < Q && (T = d.replace(Ga, 91 === k ? "" : "-"));
	    k = 1;
	    1 === z ? R = d : K = d;
	    d = [R];
	
	    if (0 < E) {
	      var l = O(-1, c, d, d, I, y, 0, 0, 0);
	      void 0 !== l && "string" === typeof l && (c = l);
	    }
	
	    var a = V(W, d, c, 0, 0);
	    0 < E && (l = O(-2, a, d, d, I, y, a.length, 0, 0), void 0 !== l && "string" !== typeof (a = l) && (k = 0));
	    K = R = T = "";
	    J = 0;
	    y = I = 1;
	    return 0 === oa * k ? a : a.replace(P, "").replace(Ha, "").replace(Ia, "$1").replace(Ja, "$1").replace(Ka, " ");
	  }
	
	  var qa = /^\0+/g,
	      P = /[\0\r\f]/g,
	      na = /: */g,
	      Ba = /zoo|gra/,
	      Da = /([,: ])(transform)/g,
	      za = /,+\s*(?![^(]*[)])/g,
	      Aa = / +\s*(?![^(]*[)])/g,
	      ua = / *[\0] */g,
	      xa = /,\r+?/g,
	      M = /([\t\r\n ])*\f?&/g,
	      ya = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
	      Ga = /\W+/g,
	      ta = /@(k\w+)\s*(\S*)\s*/,
	      Z = /::(place)/g,
	      wa = /:(read-only)/g,
	      Ha = /\s+(?=[{\];=:>])/g,
	      Ia = /([[}=:>])\s+/g,
	      Ja = /(\{[^{]+?);(?=\})/g,
	      Ka = /\s{2,}/g,
	      va = /([^\(])(:+) */g,
	      aa = /[svh]\w+-[tblr]{2}/,
	      ra = /\(\s*(.*)\s*\)/g,
	      Fa = /([^]*?);/g,
	      Ca = /-self|flex-/g,
	      Ea = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      y = 1,
	      I = 1,
	      J = 0,
	      z = 1,
	      w = 1,
	      Y = 1,
	      oa = 0,
	      ka = 0,
	      X = 0,
	      W = [],
	      ca = [],
	      E = 0,
	      ba = null,
	      la = 0,
	      Q = 1,
	      T = "",
	      K = "",
	      R = "";
	  F.use = da;
	  F.set = ea;
	  void 0 !== ha && ea(ha);
	  return F;
	};
	
	var memoize = function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	};
	var STYLES_KEY = '__emotion_styles';
	var unitless = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineClamp: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.memoize = memoize;
	exports.STYLES_KEY = STYLES_KEY;
	exports.unitless = unitless;
	exports.hashString = hashString;
	exports.Stylis = pa;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldLabel = __webpack_require__(314);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldLabel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(388);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _mapValues2 = __webpack_require__(629);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _merge2 = __webpack_require__(631);
	
	var _merge3 = _interopRequireDefault(_merge2);
	
	var _isPlainObject2 = __webpack_require__(158);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _forEach2 = __webpack_require__(264);
	
	var _forEach3 = _interopRequireDefault(_forEach2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Ensure consistent value format */
	function toProps(value) {
	  return (0, _isPlainObject3.default)(value) ? value : { value: value };
	}
	
	/**
	 * Basic Enum constructor to provide some consistency to how we
	 * define enums with associated properties
	 */
	
	var Enum = function () {
	  function Enum(spec) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Enum);
	    this.properties = {};
	    this.values = [];
	
	    (0, _forEach3.default)(spec, function (value, keyOrIndex) {
	      var properties = toProps(value);
	      if (_this.properties[properties.value]) {
	        throw new Error('Duplicate values (' + JSON.stringify(value) + ') found in enum spec. ');
	      }
	      var key = (0, _isArray3.default)(spec) ? value : keyOrIndex;
	      _this[key] = properties.value;
	      _this.values.push(properties.value);
	      _this.properties[properties.value] = (0, _extends3.default)({}, properties);
	    });
	  }
	
	  (0, _createClass3.default)(Enum, [{
	    key: Symbol.iterator,
	    value: /*#__PURE__*/_regenerator2.default.mark(function value() {
	      return _regenerator2.default.wrap(function value$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              return _context.delegateYield(this.values, 't0', 1);
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, value, this);
	    })
	
	    /** https://github.com/Alexoner/react-redux-universal-hot-example/commit/8f357cccdaffbbcb51e46e6df5235dfd214db4e1 */
	
	  }, {
	    key: '__EMPTY_METHOD_WHICH_FIXES_BABEL_V8_BUG__',
	    value: function __EMPTY_METHOD_WHICH_FIXES_BABEL_V8_BUG__() {}
	
	    /**
	     * Create an enum with values from difference source
	     * - Useful for creating property objects from external schemas
	     */
	
	  }], [{
	    key: 'withValues',
	    value: function withValues(values, spec) {
	      return new Enum((0, _merge3.default)({}, (0, _mapValues3.default)(values, toProps), spec));
	    }
	  }]);
	  return Enum;
	}();
	
	exports.default = Enum;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(135));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context);
	var flush = _createEmotion.flush;
	var hydrate = _createEmotion.hydrate;
	var cx = _createEmotion.cx;
	var merge = _createEmotion.merge;
	var getRegisteredStyles = _createEmotion.getRegisteredStyles;
	var injectGlobal = _createEmotion.injectGlobal;
	var keyframes = _createEmotion.keyframes;
	var css = _createEmotion.css;
	var sheet = _createEmotion.sheet;
	var caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(595),
	    listCacheDelete = __webpack_require__(596),
	    listCacheGet = __webpack_require__(597),
	    listCacheHas = __webpack_require__(598),
	    listCacheSet = __webpack_require__(599);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    stackClear = __webpack_require__(614),
	    stackDelete = __webpack_require__(615),
	    stackGet = __webpack_require__(616),
	    stackHas = __webpack_require__(617),
	    stackSet = __webpack_require__(618);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(100),
	    eq = __webpack_require__(75);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(75);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(249);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(58),
	    toKey = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(593);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(542),
	    isObjectLike = __webpack_require__(30);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(29),
	    stubFalse = __webpack_require__(635);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(239),
	    baseKeysIn = __webpack_require__(548),
	    isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _theme = __webpack_require__(358);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_theme).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(74);
	var PropTypes = _interopDefault(__webpack_require__(4));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var testOmitPropsOnStringTag = emotionUtils.memoize(function (key) {
	  return reactPropsRegex.test(key);
	});
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var omitAssign = function omitAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function _componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function _componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	function _get(target, property) {
	  switch (property) {
	    // react-hot-loader tries to access this stuff
	    case '__proto__':
	    case 'name':
	    case 'prototype':
	    case 'displayName':
	      {
	        return target[property];
	      }
	
	    default:
	      {
	        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	      }
	  }
	}
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	    var omitFn = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	
	    function _value() {
	      if (false) {
	        throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	      }
	
	      return "." + stableClassName;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag[emotionUtils.STYLES_KEY] !== undefined ? tag[emotionUtils.STYLES_KEY].slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      function _render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = omitAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return view.createElement(baseTag, omitAssign(omitFn, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	        _proto.componentWillMount = _componentWillMount;
	        _proto.componentWillUnmount = _componentWillUnmount;
	        _proto.render = _render;
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	      Styled.contextTypes = contextTypes;
	      Styled[emotionUtils.STYLES_KEY] = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: _value
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        omitAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, args);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: _get
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(74);
	var stylisRuleSheet = _interopDefault(__webpack_require__(186));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = emotionUtils.memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (emotionUtils.unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	function _StyleSheet(options) {
	  this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	  this.tags = [];
	  this.ctr = 0;
	  this.opts = options;
	}
	
	function _inject() {
	  if (this.injected) {
	    throw new Error('already injected!');
	  }
	
	  this.tags[0] = makeStyleTag(this.opts);
	  this.injected = true;
	}
	
	function _speedy(bool) {
	  if (this.ctr !== 0) {
	    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	    throw new Error("cannot change speedy now");
	  }
	
	  this.isSpeedy = !!bool;
	}
	
	function _insert(rule, sourceMap) {
	  // this is the ultrafast version, works across browsers
	  if (this.isSpeedy) {
	    var tag = this.tags[this.tags.length - 1];
	    var sheet = sheetForTag(tag);
	
	    try {
	      sheet.insertRule(rule, sheet.cssRules.length);
	    } catch (e) {
	      if (false) {
	        console.warn('illegal rule', rule); // eslint-disable-line no-console
	      }
	    }
	  } else {
	    var _tag = makeStyleTag(this.opts);
	
	    this.tags.push(_tag);
	
	    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	  }
	
	  this.ctr++;
	
	  if (this.ctr % 65000 === 0) {
	    this.tags.push(makeStyleTag(this.opts));
	  }
	}
	
	function _ref(tag) {
	  return tag.parentNode.removeChild(tag);
	}
	
	function _flush() {
	  // $FlowFixMe
	  this.tags.forEach(_ref);
	  this.tags = [];
	  this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	  this.injected = false;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  var _proto = _StyleSheet.prototype;
	  _proto.inject = _inject;
	  _proto.speedy = _speedy;
	  _proto.insert = _insert;
	  _proto.flush = _flush;
	  return _StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  } // $FlowFixMe
	
	
	  var caches = context.__SECRET_EMOTION__;
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	
	  if (caches === undefined) {
	    var stylisOptions = {
	      keyframe: false,
	      global: false,
	      prefix: options.prefix === undefined ? true : options.prefix,
	      semicolon: true
	    };
	
	    if (false) {
	      stylisOptions.compress = false;
	    }
	
	    context.__SECRET_EMOTION__ = caches = {
	      registered: {},
	      inserted: {},
	      sheet: new StyleSheet(options),
	      stylis: new emotionUtils.Stylis(stylisOptions),
	      nonce: options.nonce,
	      key: key
	    };
	    caches.stylis.use(options.stylisPlugins)(insertionPlugin); // 🚀
	
	    if (isBrowser) {
	      caches.sheet.inject();
	    }
	  }
	
	  var stylis = caches.stylis;
	  var sheet = caches.sheet;
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation[emotionUtils.STYLES_KEY] !== undefined) {
	          return interpolation.toString();
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    function _ref(interpolation) {
	      string += handleInterpolation.call(this, interpolation, false);
	    }
	
	    function _ref2(key) {
	      if (typeof obj[key] !== 'object') {
	        if (caches.registered[obj[key]] !== undefined) {
	          string += key + "{" + caches.registered[obj[key]] + "}";
	        } else {
	          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	        }
	      } else {
	        string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	      }
	    }
	
	    if (Array.isArray(obj)) {
	      obj.forEach(_ref, this);
	    } else {
	      Object.keys(obj).forEach(_ref2, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = emotionUtils.hashString(styles + identifierName) + identifierName;
	    return styles;
	  };
	
	  if (false) {
	    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      var result = sourceMapRegEx.exec(styles);
	      currentSourceMap = result ? result[0] : '';
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = styles;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  function _ref3(node) {
	    // $FlowFixMe
	    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	  }
	
	  if (isBrowser) {
	    var chunks = Array.from(document.querySelectorAll("[data-emotion-" + key + "]"));
	    chunks.forEach(_ref3);
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  return emotion;
	}
	
	module.exports = createEmotion;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(138);
	var isArguments = __webpack_require__(137);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"id":"src/pages/index.md absPath of file >>> MarkdownRemark","html":"<p>At Kalo we aim to be the source of truth for all of your company’s information about freelancers, and make interactions with them seamless. We know that your team may be using other project management tools, and as such, we want to make it as easy as possible to use Kalo with these 3rd party tools, minimising the amount of duplicate work. </p>\n<p>The Kalo API is a way to build integration between Kalo and any other system or applications you are using to onboard, manage, and pay your freelancers.</p>\n<p>To start, you’ll need to create a Kalo app (“Kalo app” is a link to the kalo app management page).</p>\n<p>Head over to the <a href=\"./overview\">API Overview</a> page for more details on the resources you can access via the Kalo API.</p>","fields":{"slug":"/"},"frontmatter":{"title":"Getting started"}}},{"node":{"id":"src/pages/resources/freelancers.md absPath of file >>> MarkdownRemark","html":"<h1>Fields</h1>\n<p>Freelancers are the individual who work on the tasks defined in a project.\nFreelancer resources currently expose the following fields:</p>\n<ul>\n<li>id</li>\n<li>name</li>\n<li>email</li>\n<li>telephone</li>\n<li>country</li>\n<li>city</li>\n<li>area code</li>\n<li>currency</li>\n<li>next_available</li>\n<li>custom_data</li>\n<li>daily_rate</li>\n<li>hourly_rate</li>\n<li>instagram</li>\n<li>linkedin</li>\n<li>twitter</li>\n<li>website</li>\n<li>youtube</li>\n</ul>\n<p>The value of custom_data varries as a result of the set of onboarding templates assigned to the specific freelancer. These are a set of key and value data pairs provided by the customer which may include any type of unstructured data useful to the onboarding and management of the freelancer for example type of equipment, location availability, and banking preferences. The data will be returned as a collection of keys / values grouped by template name. </p>\n<h1>Endpoints</h1>\n<h2>GET /freelancers/</h2>\n<p>List all the available freelancers for the given team. The result is a paginated list of freelancers.</p>\n<h2>GET /freelancers/&#x3C;uuid:id>/</h2>\n<p>Retrienve a freelancer given the corresponding ID.</p>","fields":{"slug":"/resources/freelancers/"},"frontmatter":{"title":"Freelancers"}}},{"node":{"id":"src/pages/overview.md absPath of file >>> MarkdownRemark","html":"<h2>Kalo API</h2>\n<p>The base URL of the Kalo API is <code>https://api.kalohq.com/</code>, and exposes projects, tasks, invoices and freelancers at:</p>\n<ul>\n<li><a href=\"https://api.kalohq.com/projects/\">https://api.kalohq.com/projects/</a></li>\n<li><a href=\"https://api.kalohq.com/tasks/\">https://api.kalohq.com/tasks/</a></li>\n<li><a href=\"https://api.kalohq.com/freelancers/\">https://api.kalohq.com/freelancers/</a></li>\n<li><a href=\"https://api.kalohq.com/invoices/\">https://api.kalohq.com/invoices/</a></li>\n</ul>\n<h2>Creating Kalo Apps</h2>\n<p>In order to use the Kalo API, you’ll first need to create a Kalo app, going to the <a href=\"https://developers.kalohq.com/apps/create\">kalo app management page</a>.\nYou can think of a Kalo app as an integration point binto the Kalo platform.</p>\n<p>A Kalo app allows you to define one or more Kalo app keys.\nKalo apps and kalo apps keys can only be created by admin users, and keys will have admin rights on the team resources, so they should not be shared with others.</p>\n<h2>REST API</h2>\n<p>The Kalo API is a RESTful json API, and follows <a href=\"http://jsonapi.org\">the json api specification</a>.\nEach request needs to be authenticated using the authentication key previously generated, using the <code>X-Kalo-Api-Key</code> authentication header, which would look like this:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"><code>X-Kalo-Api-Key: ea4fa026c1874a4fb40d1c4880d97bb4</code></pre>\n      </div>\n<p>For write http requests you also need to pass the content type, so in that case the header would look like:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"><code>X-Kalo-Api-Key: ea4fa026c1874a4fb40d1c4880d97bb4\nContent-Type: application/json</code></pre>\n      </div>\n<p>The general status codes you can expect from the API are the following:</p>\n<ul>\n<li>\n<p><strong>200: ok</strong></p>\n<p>The request was successful.\n<em>PATCH</em> and <em>GET</em> requests will return 200 on success, with information about the fetched/patched\nobjects in the response body.</p>\n</li>\n<li>\n<p><strong>201: created</strong></p>\n<p>Resource successfully created, only POST <em>requests</em> will return this status code.</p>\n</li>\n<li>\n<p><strong>400: bad request</strong></p>\n<p>Something wrong with the data passed in, for example missing required fields, mismatching\nfield types and other similar issues. The response body in this case should help detecting\nwhat the issue is.</p>\n</li>\n<li>\n<p><strong>401: unauthorized</strong></p>\n<p>Most likely a wrong authentication key.</p>\n</li>\n<li>\n<p><strong>403: forbidden</strong></p>\n<p>The authentication succeeded but you are trying to access data you are not allowed to access\nwith that key.</p>\n</li>\n<li>\n<p><strong>404: not found</strong></p>\n<p>The page does not exists or some of the resources that were trying to be accessed during\nthe request do not exist in the database.</p>\n<!-- in theory this could also happen when you access something you do not have access -->\n<!-- to given how the filtering works. For example filtering by team and a certain id -->\n<!-- even if the given object would exist with that id if it's not part of that team -->\n<!-- we will still return 404 -->\n</li>\n<li>\n<p><strong>500: server error</strong></p>\n<p>Most likely a bug in the Kalo API code, or something wrong in the request which should\nactually return a 400 but it's not handled correctly.\nThese gets all logged to our tracking system and we will have enough context to be\nable to reproduce the problem.</p>\n<!-- Should we add something else here about 502/503 or that's not really necessary? -->\n</li>\n</ul>\n<h2>Request types</h2>\n<p>Allowed requests to the API can be split into these categories:</p>\n<table>\n<thead>\n<tr>\n<th>URL</th>\n<th>Method</th>\n<th>Operation</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td><code>/$resource/$id/</code></td>\n<td><code>GET</code></td>\n<td>Fetch a single resource</td>\n</tr>\n<tr>\n<td><code>/$resource/</code></td>\n<td><code>GET</code></td>\n<td>Fetch all the resources (paginating the result)</td>\n</tr>\n<tr>\n<td><code>/$resource/$id/</code></td>\n<td><code>PATCH</code></td>\n<td>Modify an existing resource</td>\n</tr>\n<tr>\n<td><code>/$resource/</code></td>\n<td><code>POST</code></td>\n<td>Create a new resource</td>\n</tr>\n</tbody>\n</table>\n<h2>Pagination</h2>\n<p>All the requests of the type <code>GET /$resource/</code> are <strong>paginated</strong>,\nwhich is a standard practice to avoid fetching too much data all at\nonce.</p>\n<p>The current limit of resources fetched per call is currently <code>30</code>,\nso it means that for example to fetch 100 resources you need to do\n4 API calls, returning in order <code>30 + 30 + 30 + 10 == 100</code> resources.</p>\n<p>Pagination is controlled by passing two query arguments:</p>\n<ul>\n<li><code>page[offset]</code>: which indicates how many resources to skip</li>\n<li><code>page[limit]</code>:  which indicates the number of resources to get (max 30 as\nmentioned above)</li>\n</ul>\n<p>To see an example, assume we have 100 projects and we need to get all\nof them, the API calls will be something like:</p>\n<ol>\n<li><code>GET /projects/</code> => resources 0-30</li>\n<li><code>GET /projects/?page[offset]=30</code> => resources 30-60</li>\n<li><code>GET /projects/?page[offset]=60</code> => resources 60-90</li>\n<li><code>GET /projects/?page[offset]=90</code> => resources 90-100</li>\n</ol>\n<p>To help the client understanding when all the resources are fetched\neach API response you will find two attributes <code>total</code> and <code>offset</code>.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-none\"><code>{'meta': {'total': #tot-number-of-resources, 'offset': #offset-used}}</code></pre>\n      </div>\n<p>With this information an easy way to fetch all the available resources would be:</p>\n<ul>\n<li>keep track of the total from the first call.</li>\n<li>keep track of the number of resources already fetched.</li>\n<li>when the number of resources fetched <code>==</code> total, then all resources\nwere fetched correctly.</li>\n</ul>","fields":{"slug":"/overview/"},"frontmatter":{"title":"Overview"}}},{"node":{"id":"src/pages/resources/invoices.md absPath of file >>> MarkdownRemark","html":"<h1>Fields</h1>\n<p>Invoices are created either automatically or on-demand as a result of a freelancer completing a task. The Invoice resource currently exposes the following fields:</p>\n<ul>\n<li>id</li>\n<li>amount</li>\n<li>currency</li>\n<li>status</li>\n<li>reference</li>\n<li>vat</li>\n<li>created_at</li>\n<li>team</li>\n<li>freelancer</li>\n<li>task</li>\n</ul>\n<h1>Endpoints</h1>\n<h2>GET /invoices/</h2>\n<p>List all the available invoices.</p>","fields":{"slug":"/resources/invoices/"},"frontmatter":{"title":"Invoices"}}},{"node":{"id":"src/pages/resources/projects.md absPath of file >>> MarkdownRemark","html":"<h2>Fields</h2>\n<p>Projects allow you to group your team’s work.\nProject resources currently expose the following fields:</p>\n<ul>\n<li>id</li>\n<li>title</li>\n<li>description</li>\n<li>start_date</li>\n<li>end_date</li>\n<li>workgroup</li>\n</ul>\n<h2>Endpoint</h2>\n<h3>GET /projects/</h3>\n<p>Get all projects.</p>\n<h3>GET /projects/&#x3C;uuid:id>/</h3>\n<p>Get a single project by ID.</p>\n<h3>GET /projects/&#x3C;uuid:id>/tasks/</h3>\n<p>List all the available tasks for a specific project</p>\n<h3>GET /projects/&#x3C;uuid:id>/tasks/&#x3C;uuid:id>/</h3>\n<p>Get a single task by ID for a specific project</p>\n<h3>POST /projects/</h3>\n<p>Creates a new project, as shown in this example:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-json\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"project\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"attributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"title\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Project title\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"description\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Project description\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"start_date\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-08-14\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"end_date\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-08-20\"</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>If you want to create a new project inside a certain workgroup you need to pass the right workgroup_id, for example:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-json\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"project\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"attributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"title\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Project with workgroup\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"description\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Project with workgroup\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"start_date\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-08-14\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"end_date\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"2017-08-20\"</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"relationships\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"workgroup\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span><span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"workgroup\"</span><span class=\"token punctuation\">,</span> <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token number\">100</span><span class=\"token punctuation\">}</span>\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>","fields":{"slug":"/resources/projects/"},"frontmatter":{"title":"Projects"}}},{"node":{"id":"src/pages/resources/tasks.md absPath of file >>> MarkdownRemark","html":"<h2>Fields</h2>\n<p>Tasks are individual units of work that belong to projects, and are assigned to freelancers.</p>\n<p>Task resources currently expose the following fields:</p>\n<ul>\n<li>id</li>\n<li>freelancer</li>\n<li>managers</li>\n<li>summary</li>\n<li>description</li>\n<li>rate</li>\n<li>rate_type (one of \"fixed\", \"daily\", \"hourly\")</li>\n<li>status (one of \"ongoing\", \"completed\")</li>\n<li>project</li>\n</ul>\n<h2>Endpoints</h2>\n<h3>GET /tasks/</h3>\n<p>List all the available tasks.</p>\n<h3>GET /tasks/&#x3C;uuid:id>/</h3>\n<p>Fetch a task given by its UUID.</p>\n<h3>POST /tasks/</h3>\n<p>Creates a new task, see this example request, where you have to\nreplace the right <code>project uuid</code> and the right <code>manager id</code>.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-json\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"task\"</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"attributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"description\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Sample task created\"</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"summary\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"Sample task\"</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n    <span class=\"token property\">\"relationships\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n      <span class=\"token property\">\"project\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n          <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"project\"</span><span class=\"token punctuation\">,</span>\n          <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"608172ce-27ab-4dfe-82d9-9bd6e28c2366\"</span>\n        <span class=\"token punctuation\">}</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token property\">\"managers\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">[</span>\n          <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"user\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"id\"</span><span class=\"token operator\">:</span> <span class=\"token number\">100</span>\n          <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">]</span>\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<h3>PATCH /tasks/&#x3C;uuid:id>/</h3>\n<p>Modify a task sending partial information about the fields to change.</p>\n<p>This is used for both:</p>\n<ul>\n<li>\n<p>change task attributes</p>\n</li>\n<li>\n<p>change the task state, where the supported possible states are (at the moment)</p>\n<ul>\n<li>ONGOING</li>\n<li>COMPLETED</li>\n</ul>\n</li>\n</ul>\n<p>So for example suppose we have a task which is currently pending, and\nwe want to make it switch to ongoing, we just have to patch the task\npassig the new status we want.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-json\"><code>    <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"task\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"attributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                <span class=\"token property\">\"status\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"ongoing\"</span>\n            <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>If instead we want to change some attributes (like summary for\nexample) we will still use <code>patch</code> in the same way but passing the\nattribute we want to change with the right value in.</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-json\"><code>    <span class=\"token punctuation\">{</span>\n        <span class=\"token property\">\"data\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n            <span class=\"token property\">\"type\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"task\"</span><span class=\"token punctuation\">,</span>\n            <span class=\"token property\">\"attributes\"</span><span class=\"token operator\">:</span> <span class=\"token punctuation\">{</span>\n                <span class=\"token property\">\"summary\"</span><span class=\"token operator\">:</span> <span class=\"token string\">\"New summary\"</span>\n            <span class=\"token punctuation\">}</span>\n        <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>These two changes can also be merged of course (so changing state and\nsome attributes at the same time).</p>","fields":{"slug":"/resources/tasks/"},"frontmatter":{"title":"Tasks"}}}]}},"layoutContext":{}}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(29);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(600),
	    mapCacheDelete = __webpack_require__(601),
	    mapCacheGet = __webpack_require__(602),
	    mapCacheHas = __webpack_require__(603),
	    mapCacheSet = __webpack_require__(604);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(543),
	    isObjectLike = __webpack_require__(30);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(549),
	    baseMatchesProperty = __webpack_require__(550),
	    identity = __webpack_require__(106),
	    isArray = __webpack_require__(13),
	    property = __webpack_require__(634);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(237);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(244),
	    getSymbolsIn = __webpack_require__(253),
	    keysIn = __webpack_require__(109);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(259);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(533),
	    stubArray = __webpack_require__(268);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(13),
	    isSymbol = __webpack_require__(159);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && baseGetTag(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isObject = __webpack_require__(23);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    getPrototype = __webpack_require__(152),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(546),
	    baseUnary = __webpack_require__(562),
	    nodeUtil = __webpack_require__(608);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(727);


/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(184);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(136);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(180);
	
	var _HelmetConstants = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(139);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(185);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, at, depth) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							insertRule(content)
						break
					// selector
					case 2:
						if (at === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (at) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + delimiter
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(310);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(311);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkbox).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldHint = __webpack_require__(313);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldHint).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldValidation = __webpack_require__(317);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldValidation).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldValidations = __webpack_require__(318);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldValidations).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _h = __webpack_require__(329);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loadingSpinner = __webpack_require__(341);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingSpinner).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paperMenu = __webpack_require__(343);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paperMenu).default;
	  }
	});
	
	var _paperMenuItem = __webpack_require__(342);
	
	Object.defineProperty(exports, 'PaperMenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paperMenuItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paper = __webpack_require__(345);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paper).default;
	  }
	});
	
	var _paperToolbar = __webpack_require__(344);
	
	Object.defineProperty(exports, 'PaperToolbar', {
	  enumerable: true,
	  get: function get() {
	    return _paperToolbar.PaperToolbar;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sticky = __webpack_require__(354);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sticky).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SIZE_MAP = exports.WEIGHT_MAP = exports.TEXT_SIZE = undefined;
	
	var _enum = __webpack_require__(83);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_SIZE = exports.TEXT_SIZE = new _enum2.default({
	  TINY: {
	    value: 'tiny'
	  },
	  EXTRA_SMALL: {
	    value: 'extra-small'
	  },
	  SMALL: {
	    value: 'small'
	  },
	  MEDIUM: {
	    value: 'medium'
	  },
	  LARGE: {
	    value: 'large'
	  },
	  EXTRA_LARGE: {
	    value: 'extra-large'
	  }
	}); // deprecated
	
	var WEIGHT_MAP = exports.WEIGHT_MAP = {
	  light: 300,
	  normal: 400,
	  medium: 500,
	  'semi-bold': 600
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  'extra-extra-small': 10,
	  'extra-small': 12,
	  small: 14,
	  medium: 16,
	  large: 18,
	  'extra-large': 24,
	  'extra-extra-large': 32,
	  'extra-extra-extra-large': 32
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDocumentScroll = getDocumentScroll;
	exports.getFixedOffset = getFixedOffset;
	exports.removeNode = removeNode;
	exports.outerHeight = outerHeight;
	exports.outerWidth = outerWidth;
	exports.getSelectionRange = getSelectionRange;
	exports.shiftSelectionColumns = shiftSelectionColumns;
	exports.setSelectionRange = setSelectionRange;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.addClass = addClass;
	exports.getParentBoundingClientRect = getParentBoundingClientRect;
	exports.createEvent = createEvent;
	/**
	 * Gets the current scroll position of the document element
	 * http://stackoverflow.com/questions/3464876/javascript-get-window-x-y-position-for-scroll
	 * @returns {{top: number, left: number}}
	 */
	function getDocumentScroll() {
	  var doc = document.documentElement;
	  var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
	  var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	  return { top: top, left: left };
	}
	
	/**
	 * Calculate the fully absolute (to body top/left) position of an element
	 * @param el
	 * @returns {{top: number, left: number}}
	 */
	function getFixedOffset(el) {
	  var rect = !!el ? el.getBoundingClientRect() : { top: 0, left: 0 };
	  var scroll = getDocumentScroll();
	  return {
	    top: rect.top + scroll.top,
	    left: rect.left + scroll.left
	  };
	}
	
	/**
	 * Remove a given element from the DOM
	 * @param {Element} el
	 */
	function removeNode(el) {
	  if (el && el.parentNode) {
	    el.parentNode.removeChild(el);
	  }
	}
	
	function outerHeight(el) {
	  var style = window.getComputedStyle(el);
	  return (el.offsetHeight || 0) + parseInt(style.marginTop || 0, 10) + parseInt(style.marginBottom || 0, 10);
	}
	
	function outerWidth(el) {
	  var style = window.getComputedStyle(el);
	  return (el.offsetWidth || 0) + parseInt(style.marginLeft || 0, 10) + parseInt(style.marginRight || 0, 10);
	}
	
	/**
	 * Return the selection range from an element as start & end row/column vectors
	 * NOTE: Rows and columns are 1-indexed
	 *
	 * @param el
	 * @returns {[[startRow, startColumn], [endRow, endColumn], [startIndex, endIndex]}
	 */
	function getSelectionRange(el) {
	  var value = el.value;
	
	  // Calculate selction start position
	  var rowstoStart = value.substr(0, el.selectionStart).split('\n');
	  var startRow = rowstoStart.length;
	  var startColumn = rowstoStart[rowstoStart.length - 1].length + 1;
	
	  // Calculate selection end position
	  var rowsToEnd = value.substr(0, el.selectionEnd).split('\n');
	  var endRow = rowsToEnd.length;
	  var endColumn = rowsToEnd[rowsToEnd.length - 1].length + 1;
	
	  // Return as vector range array
	  return [[startRow, startColumn], [endRow, endColumn], [el.selectionStart, el.selectionEnd]];
	}
	
	/**
	 * Shift columns of given selection range by delta
	 */
	function shiftSelectionColumns(selectionRange, delta) {
	  return [[selectionRange[0][0], selectionRange[0][1] + delta], [selectionRange[1][0], selectionRange[1][1] + delta], [selectionRange[2][0] + delta, selectionRange[2][1] + delta]];
	}
	
	/**
	 * Takes a selection range array (as seen above in getSelectionRange)
	 * and sets it on an input or textarea element
	 */
	function setSelectionRange(el, selectionRange) {
	  el.setSelectionRange(selectionRange[2][0], selectionRange[2][1]);
	}
	
	/**
	 * Get the browsers scrollbar width
	 * http://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
	 */
	function getScrollbarWidth() {
	  var outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  // force scrollbars
	  outer.style.overflow = 'scroll';
	
	  // add innerdiv
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	
	  // remove divs
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll;
	}
	
	function addClass(el, className) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    el.className = el.className + ' ' + className; // eslint-disable-line no-param-reassign
	  }
	}
	
	function getParentBoundingClientRect(elem) {
	  var htmlElem = elem instanceof HTMLElement ? elem : elem.parentElement; // eslint-disable-line no-undef
	  return htmlElem.offsetParent.getBoundingClientRect();
	}
	
	function createEvent(name) {
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  try {
	    return new window.CustomEvent(name, { detail: data });
	  } catch (e) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent(name, true, true, data);
	    return event;
	  }
	}

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(40);
	var core = __webpack_require__(18);
	var fails = __webpack_require__(50);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(29);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(560),
	    isArguments = __webpack_require__(107),
	    isArray = __webpack_require__(13),
	    isBuffer = __webpack_require__(108),
	    isIndex = __webpack_require__(103),
	    isTypedArray = __webpack_require__(160);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(100),
	    eq = __webpack_require__(75);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(575);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(242),
	    keys = __webpack_require__(62);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(147),
	    isArray = __webpack_require__(13);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(29);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(150);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(556),
	    isIterateeCall = __webpack_require__(592);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(528),
	    arraySome = __webpack_require__(534),
	    cacheHas = __webpack_require__(564);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(244),
	    getSymbols = __webpack_require__(153),
	    keys = __webpack_require__(62);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(147),
	    getPrototype = __webpack_require__(152),
	    getSymbols = __webpack_require__(153),
	    stubArray = __webpack_require__(268);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(524),
	    Map = __webpack_require__(144),
	    Promise = __webpack_require__(526),
	    Set = __webpack_require__(527),
	    WeakMap = __webpack_require__(529),
	    baseGetTag = __webpack_require__(33),
	    toSource = __webpack_require__(263);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(538),
	    getPrototype = __webpack_require__(152),
	    isPrototype = __webpack_require__(104);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(532);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(558),
	    shortOut = __webpack_require__(613);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(238),
	    baseEach = __webpack_require__(539),
	    castFunction = __webpack_require__(565),
	    isArray = __webpack_require__(13);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(146),
	    baseClone = __webpack_require__(537),
	    baseUnset = __webpack_require__(563),
	    castPath = __webpack_require__(58),
	    copyObject = __webpack_require__(46),
	    customOmitClone = __webpack_require__(576),
	    flatRest = __webpack_require__(579),
	    getAllKeysIn = __webpack_require__(151);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(146),
	    baseIteratee = __webpack_require__(149),
	    basePickBy = __webpack_require__(553),
	    getAllKeysIn = __webpack_require__(151);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FocusTrap = function (_React$Component) {
	  _inherits(FocusTrap, _React$Component);
	
	  function FocusTrap() {
	    _classCallCheck(this, FocusTrap);
	
	    return _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).apply(this, arguments));
	  }
	
	  _createClass(FocusTrap, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({ tabIndex: '-1' }, props),
	        children
	      );
	    }
	  }]);
	
	  return FocusTrap;
	}(_react2.default.Component);
	
	FocusTrap.propTypes = {
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  component: _propTypes2.default.any,
	  children: _propTypes2.default.node
	};
	FocusTrap.defaultProps = {
	  component: 'div'
	};
	exports.default = FocusTrap;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HotKeyMapMixin;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _assign = __webpack_require__(620);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _isEqual = __webpack_require__(265);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HotKeyMapMixin() {
	  var hotKeyMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  return {
	
	    contextTypes: {
	      hotKeyMap: _propTypes2.default.object
	    },
	
	    childContextTypes: {
	      hotKeyMap: _propTypes2.default.object
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        hotKeyMap: this.__hotKeyMap__
	      };
	    },
	    componentWillMount: function componentWillMount() {
	      this.updateMap();
	    },
	    updateMap: function updateMap() {
	      var newMap = this.buildMap();
	
	      if (!(0, _isEqual2.default)(newMap, this.__hotKeyMap__)) {
	        this.__hotKeyMap__ = newMap;
	        return true;
	      }
	
	      return false;
	    },
	    buildMap: function buildMap() {
	      var parentMap = this.context.hotKeyMap || {};
	      var thisMap = this.props.keyMap || {};
	
	      return (0, _assign2.default)({}, parentMap, hotKeyMap, thisMap);
	    },
	    getMap: function getMap() {
	      return this.__hotKeyMap__;
	    }
	  };
	}

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: ', ';\n  background-color: ', ';\n'], ['\n  border-radius: ', ';\n  background-color: ', ';\n']);
	
	exports.default = Alert;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _layout = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TYPE_COLOR_MAP = {
	  info: 'blue',
	  error: 'pink',
	  warning: 'orange',
	  confirmation: 'green'
	};
	
	var TYPE_ICON_MAP = {
	  info: 'info_outline',
	  error: 'highlight_off',
	  warning: 'error_outline',
	  confirmation: 'check_circle'
	};
	
	var StyledAlert = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Box)(_templateObject, function (props) {
	  return props.theme.layout.borderRadius;
	}, function (props) {
	  return props.theme.alerts[props.type];
	});
	
	function Alert(props) {
	  var children = props.children,
	      showIcon = props.showIcon,
	      _props$type = props.type,
	      type = _props$type === undefined ? 'info' : _props$type,
	      _props$justifyContent = props.justifyContent,
	      justifyContent = _props$justifyContent === undefined ? 'center' : _props$justifyContent,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'showIcon', 'type', 'justifyContent']);
	
	
	  return React.createElement(
	    StyledAlert,
	    (0, _extends3.default)({
	      padding: ['medium', 'large'],
	      flexDirection: 'row',
	      alignItems: 'center',
	      justifyContent: justifyContent,
	      role: 'alert',
	      type: type
	    }, otherProps),
	    showIcon ? React.createElement(
	      _icon2.default,
	      { color: TYPE_COLOR_MAP[type], marginRight: 8 },
	      TYPE_ICON_MAP[type]
	    ) : null,
	    React.createElement(
	      _text2.default,
	      { color: TYPE_COLOR_MAP[type], size: 'small', multiline: true },
	      children
	    )
	  );
	}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AlertPopover;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _layout = __webpack_require__(9);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(162);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function AlertPopover(props) {
	  var children = props.children,
	      _props$topOffset = props.topOffset,
	      topOffset = _props$topOffset === undefined ? 0 : _props$topOffset,
	      _props$zIndex = props.zIndex,
	      zIndex = _props$zIndex === undefined ? 999 : _props$zIndex;
	
	
	  return React.createElement(
	    _reactAddonsCssTransitionGroup2.default,
	    {
	      transitionName: 't-slide-from-right',
	      transitionAppear: true,
	      transitionAppearTimeout: 300,
	      transitionEnterTimeout: 300,
	      transitionLeaveTimeout: 300,
	      component: _layout.Box,
	      position: 'fixed',
	      right: 32,
	      top: topOffset + 16,
	      maxWidth: 400,
	      alignItems: 'flex-end',
	      zIndex: zIndex
	    },
	    React.Children.map(children, function (child) {
	      return child ? React.createElement(
	        _layout.Box,
	        { marginBottom: 8 },
	        React.cloneElement(child, { justifyContent: 'left' })
	      ) : null;
	    })
	  );
	}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alert = __webpack_require__(303);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_alert).default;
	  }
	});
	
	var _alertPopover = __webpack_require__(304);
	
	Object.defineProperty(exports, 'AlertPopover', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_alertPopover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _paperMenu = __webpack_require__(194);
	
	var _paperMenu2 = _interopRequireDefault(_paperMenu);
	
	var _checkbox = __webpack_require__(188);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _layout = __webpack_require__(9);
	
	var _button = __webpack_require__(187);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _buttonDropdown = __webpack_require__(464);
	
	var _buttonDropdown2 = _interopRequireDefault(_buttonDropdown);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonDropdown = function (_PureComponent) {
	  (0, _inherits3.default)(ButtonDropdown, _PureComponent);
	
	  function ButtonDropdown(props) {
	    (0, _classCallCheck3.default)(this, ButtonDropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonDropdown.__proto__ || Object.getPrototypeOf(ButtonDropdown)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	
	    _this.onToggle = _this.onToggle.bind(_this);
	    _this.wrapperRef = _this.onToggle.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ButtonDropdown, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('click', this.onClose);
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return window.addEventListener('click', _this2.onClose);
	      }, 300);
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      window.removeEventListener('click', this.onClose);
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'onToggle',
	    value: function onToggle() {
	      if (this.state.open) {
	        this.close();
	      } else {
	        this.open();
	      }
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          _props$selectItems = _props.selectItems,
	          selectItems = _props$selectItems === undefined ? [] : _props$selectItems,
	          checkboxProps = _props.checkboxProps,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'selectItems', 'checkboxProps']);
	
	
	      return React.createElement(
	        _button2.default,
	        (0, _extends3.default)({
	          active: this.state.open,
	          onClick: !disabled ? this.onToggle : null,
	          disabled: disabled
	        }, otherProps),
	        checkboxProps ? React.createElement(_checkbox2.default, (0, _extends3.default)({ size: 'large', disabled: disabled }, checkboxProps)) : null,
	        children ? React.createElement(
	          _layout.Box,
	          { marginLeft: checkboxProps ? 12 : 0 },
	          children
	        ) : null,
	        selectItems.length ? React.createElement(
	          _icon2.default,
	          { marginLeft: 8, marginRight: -8, size: 20 },
	          'keyboard_arrow_down'
	        ) : null,
	        selectItems.length ? React.createElement(
	          'div',
	          { className: _buttonDropdown2.default.menu },
	          React.createElement(
	            _paperMenu2.default,
	            { open: this.state.open, origin: 'top', width: '100%' },
	            selectItems.map(function (item) {
	              return React.createElement(
	                _paperMenu.PaperMenuItem,
	                (0, _extends3.default)({
	                  disabled: item.disabled,
	                  key: item.title,
	                  component: item.component,
	                  minWidth: item.minWidth
	                }, item.componentProps, {
	                  onClick: !item.disabled ? function () {
	                    if (item.onClick) item.onClick();
	                    _this3.onToggle();
	                  } : null
	                }),
	                item.title
	              );
	            })
	          )
	        ) : null
	      );
	    }
	  }]);
	  return ButtonDropdown;
	}(_component2.default);
	
	exports.default = ButtonDropdown;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buttonDropdown = __webpack_require__(306);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buttonDropdown).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = ButtonGroup;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _layout = __webpack_require__(9);
	
	var _buttonGroup = __webpack_require__(465);
	
	var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A basic container for grouped buttons
	 * - Clones children to ensure Button components received a 'grouped' prop
	 */
	
	function ButtonGroup(props) {
	  var _cx;
	
	  var children = props.children,
	      _props$wide = props.wide,
	      wide = _props$wide === undefined ? true : _props$wide,
	      bordered = props.bordered,
	      flex = props.flex,
	      spacing = props.spacing,
	      reverse = props.reverse,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'wide', 'bordered', 'flex', 'spacing', 'reverse']);
	
	
	  return React.createElement(
	    _layout.Flex,
	    (0, _extends3.default)({
	      alignItems: 'center',
	      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _buttonGroup2.default.wide, wide), (0, _defineProperty3.default)(_cx, _buttonGroup2.default.bordered, bordered), (0, _defineProperty3.default)(_cx, _buttonGroup2.default.reverse, reverse), _cx))
	    }, otherProps),
	    children ? React.Children.map(children, function (child) {
	      return child ? React.cloneElement(child, {
	        grouped: !spacing,
	        spacing: !!spacing,
	        reverse: reverse,
	        flex: flex
	      }) : null;
	    }) : null
	  );
	}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buttonGroup = __webpack_require__(308);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buttonGroup).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isBoolean2 = __webpack_require__(155);
	
	var _isBoolean3 = _interopRequireDefault(_isBoolean2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _layout = __webpack_require__(9);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _loadingSpinner = __webpack_require__(193);
	
	var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);
	
	var _button = __webpack_require__(466);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON_SIZE = {
	  small: '14',
	  medium: '18',
	  large: '24'
	};
	
	function renderIcon(icon, border, size) {
	  var _cx, _cx2;
	
	  if (!icon) return null;
	
	  return (0, _isString3.default)(icon) ? _react2.default.createElement(
	    'span',
	    {
	      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _button2.default.icon, true), (0, _defineProperty3.default)(_cx, _button2.default.border, border), _cx))
	    },
	    _react2.default.createElement(
	      _icon2.default,
	      { size: !!size ? size : '18' },
	      icon
	    )
	  ) : _react2.default.createElement(
	    'span',
	    {
	      className: (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, _button2.default.icon, true), (0, _defineProperty3.default)(_cx2, _button2.default.border, border), _cx2))
	    },
	    icon
	  );
	}
	
	var Button = function (_PureComponent) {
	  (0, _inherits3.default)(Button, _PureComponent);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));
	
	    _this.state = {
	      loaded: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.__loadedTimeout__) {
	        clearTimeout(this.__loadedTimeout__);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.loading && !nextProps.loading) {
	        this.setState({ loaded: true });
	        clearTimeout(this.__loadedTimeout__);
	        this.__loadedTimeout__ = setTimeout(function () {
	          if (_this2.state.loaded) {
	            _this2.setState({ loaded: false });
	          }
	        }, this.props.loadedTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx3, _cx4, _cx5;
	
	      var _props = this.props,
	          children = _props.children,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          reverse = _props.reverse,
	          iconBorder = _props.iconBorder,
	          loneIcon = _props.loneIcon,
	          theme = _props.theme,
	          grouped = _props.grouped,
	          spacing = _props.spacing,
	          size = _props.size,
	          active = _props.active,
	          wide = _props.wide,
	          onClick = _props.onClick,
	          loading = _props.loading,
	          success = _props.success,
	          message = _props.message,
	          name = _props.name,
	          flex = _props.flex,
	          type = _props.type,
	          role = _props.role,
	          Component = _props.component,
	          className = _props.className,
	          middle = _props.middle,
	          style = _props.style,
	          mayGetLong = _props.mayGetLong,
	          subdued = _props.subdued,
	          _IGNORED = _props.loadedTimeout,
	          __IGNORED = _props.readonly,
	          ___IGNORED = _props.editable,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'icon', 'reverse', 'iconBorder', 'loneIcon', 'theme', 'grouped', 'spacing', 'size', 'active', 'wide', 'onClick', 'loading', 'success', 'message', 'name', 'flex', 'type', 'role', 'component', 'className', 'middle', 'style', 'mayGetLong', 'subdued', 'loadedTimeout', 'readonly', 'editable']);
	      var loaded = this.state.loaded;
	
	
	      var Tag = this.props.to || this.props.href ? 'span' : 'button';
	
	      var iconElement = renderIcon(icon, (0, _isBoolean3.default)(iconBorder) ? iconBorder : !!icon && !!children, ICON_SIZE[size]);
	
	      var handleClick = function handleClick(event) {
	        // Prevent form submit events propagating if button is mid-request
	        if (loading || disabled) {
	          event.preventDefault();
	          return;
	        }
	        if (onClick) {
	          onClick(event);
	        }
	      };
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({
	          style: style,
	          className: (0, _classnames2.default)((_cx3 = {}, (0, _defineProperty3.default)(_cx3, _button2.default.root, true), (0, _defineProperty3.default)(_cx3, _button2.default.grouped, !!grouped), (0, _defineProperty3.default)(_cx3, _button2.default.spacing, !!spacing), (0, _defineProperty3.default)(_cx3, _button2.default.wide, wide), (0, _defineProperty3.default)(_cx3, _button2.default.middle, middle), (0, _defineProperty3.default)(_cx3, _button2.default.loading, loading), (0, _defineProperty3.default)(_cx3, _button2.default.success, success), (0, _defineProperty3.default)(_cx3, _button2.default.loaded, loaded), (0, _defineProperty3.default)(_cx3, _button2.default.flex, flex), (0, _defineProperty3.default)(_cx3, _button2.default.reverse, reverse), _cx3), className),
	          onClick: handleClick
	        }, otherProps),
	        _react2.default.createElement(
	          Tag,
	          {
	            role: role,
	            name: name,
	            type: type,
	            className: (0, _classnames2.default)((_cx4 = {}, (0, _defineProperty3.default)(_cx4, _button2.default.button, true), (0, _defineProperty3.default)(_cx4, _button2.default.disabled, success ? false : disabled || loading), (0, _defineProperty3.default)(_cx4, _button2.default[theme], !!theme), (0, _defineProperty3.default)(_cx4, _button2.default.active, !!active), (0, _defineProperty3.default)(_cx4, _button2.default.subdued, !!subdued), (0, _defineProperty3.default)(_cx4, _button2.default[size], true), (0, _defineProperty3.default)(_cx4, _button2.default.loneIcon, loneIcon), _cx4))
	          },
	          _react2.default.createElement(
	            _layout.Flex,
	            {
	              alignItems: 'center',
	              justifyContent: 'center',
	              className: _button2.default.placeholder
	            },
	            iconElement,
	            children
	          ),
	          _react2.default.createElement(
	            _layout.Flex,
	            {
	              alignItems: 'center',
	              justifyContent: 'center',
	              name: 'message',
	              className: (0, _classnames2.default)((_cx5 = {}, (0, _defineProperty3.default)(_cx5, _button2.default.message, true), (0, _defineProperty3.default)(_cx5, _button2.default.mayGetLong, mayGetLong), _cx5)),
	              title: mayGetLong ? children : undefined
	            },
	            iconElement,
	            children
	          ),
	          _react2.default.createElement(
	            _layout.Flex,
	            {
	              alignItems: 'center',
	              justifyContent: 'center',
	              className: _button2.default.successMessage
	            },
	            iconElement,
	            message
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _button2.default.loadingSpinner },
	            _react2.default.createElement(_loadingSpinner2.default, { size: 'small' })
	          )
	        )
	      );
	    }
	  }]);
	  return Button;
	}(_component2.default);
	
	Button.propTypes = {
	  children: _propTypes2.default.any,
	  message: _propTypes2.default.string,
	  role: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  icon: _propTypes2.default.any,
	  iconBorder: _propTypes2.default.bool,
	  loneIcon: _propTypes2.default.bool,
	  wide: _propTypes2.default.bool,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  theme: _propTypes2.default.oneOf(['primary', 'secondary', 'tertiary', 'disabled', 'delete', 'deny', 'confirm']),
	  grouped: _propTypes2.default.bool,
	  spacing: _propTypes2.default.bool,
	  flex: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  success: _propTypes2.default.bool,
	  middle: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  loadedTimeout: _propTypes2.default.number,
	  component: _propTypes2.default.any,
	  name: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  mayGetLong: _propTypes2.default.bool,
	  subdued: _propTypes2.default.bool
	};
	Button.defaultProps = {
	  role: 'button',
	  size: 'large',
	  theme: 'primary',
	  iconBorder: false,
	  wide: false,
	  loading: false,
	  loneIcon: false,
	  loadedTimeout: 600,
	  component: _layout.Box
	};
	exports.default = Button;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = Checkbox;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _layout = __webpack_require__(9);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _constants = __webpack_require__(312);
	
	var _constants2 = __webpack_require__(197);
	
	var _checkbox = __webpack_require__(467);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Checkbox(props) {
	  var _cx, _cx2;
	
	  var _props$checked = props.checked,
	      checked = _props$checked === undefined ? false : _props$checked,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === undefined ? false : _props$disabled,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === undefined ? false : _props$indeterminate,
	      _props$size = props.size,
	      size = _props$size === undefined ? 'medium' : _props$size,
	      readonly = props.readonly,
	      label = props.label,
	      onClick = props.onClick,
	      name = props.name,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['checked', 'disabled', 'indeterminate', 'size', 'readonly', 'label', 'onClick', 'name']);
	
	
	  return _react2.default.createElement(
	    _layout.Flex,
	    {
	      alignItems: 'center',
	      justifyContent: 'flex-start',
	      onClick: readonly || disabled ? null : onClick,
	      name: name,
	      role: 'checkbox',
	      'aria-checked': indeterminate ? 'mixed' : checked,
	      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _checkbox2.default.root, true), (0, _defineProperty3.default)(_cx, _checkbox2.default.readonly, readonly), (0, _defineProperty3.default)(_cx, _checkbox2.default.disabled, disabled), _cx))
	    },
	    _react2.default.createElement(_layout.Box, (0, _extends3.default)({
	      position: 'relative',
	      width: _constants.CHECKBOX_SIZES.properties[size].size,
	      height: _constants.CHECKBOX_SIZES.properties[size].size,
	      className: (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, _checkbox2.default.checkbox, true), (0, _defineProperty3.default)(_cx2, _checkbox2.default.checked, checked), (0, _defineProperty3.default)(_cx2, _checkbox2.default.indeterminate, indeterminate), _cx2))
	    }, otherProps)),
	    label ? _react2.default.createElement(
	      _text2.default,
	      {
	        marginLeft: 10,
	        size: size === 'small' ? _constants2.TEXT_SIZE.EXTRA_SMALL : _constants2.TEXT_SIZE.SMALL,
	        color: 'navy600',
	        multiline: true
	      },
	      label
	    ) : null
	  );
	}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHECKBOX_SIZES = undefined;
	
	var _enum = __webpack_require__(83);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHECKBOX_SIZES = exports.CHECKBOX_SIZES = new _enum2.default({
	  SMALL: {
	    value: 'small',
	    size: 12
	  },
	  MEDIUM: {
	    value: 'medium',
	    size: 14
	  },
	  LARGE: {
	    value: 'large',
	    size: 16
	  }
	});

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	exports.default = FieldHint;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(37);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _layout = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FieldHint(props) {
	  var hint = props.hint,
	      icon = props.icon,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['hint', 'icon']);
	
	
	  return _react2.default.createElement(
	    _layout.Inline,
	    (0, _style.pickStyles)(otherProps),
	    _react2.default.createElement(
	      _text2.default,
	      { size: 'extra-small', color: 'navy600', multiline: true },
	      icon ? _react2.default.createElement(
	        _layout.Inline,
	        null,
	        (0, _isString3.default)(icon) ? _react2.default.createElement(
	          _icon2.default,
	          {
	            size: 12,
	            top: 2,
	            marginRight: 5,
	            position: 'relative',
	            verticalAlign: 'baseline'
	          },
	          String(icon)
	        ) : icon
	      ) : null,
	      hint
	    )
	  );
	}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	exports.default = FieldLabel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(37);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _layout = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FieldLabel(props) {
	  var htmlFor = props.htmlFor,
	      children = props.children,
	      icon = props.icon,
	      _props$required = props.required,
	      required = _props$required === undefined ? false : _props$required,
	      _props$locked = props.locked,
	      locked = _props$locked === undefined ? false : _props$locked,
	      title = props.title,
	      width = props.width,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['htmlFor', 'children', 'icon', 'required', 'locked', 'title', 'width']);
	
	  return _react2.default.createElement(
	    _text2.default,
	    (0, _extends3.default)({
	      component: 'label',
	      weight: 'semi-bold',
	      size: 'small',
	      htmlFor: htmlFor,
	      title: title,
	      multiline: true,
	      width: width ? width : null,
	      marginBottom: width ? null : 4
	    }, (0, _style.pickStyles)(otherProps)),
	    children,
	    required ? _react2.default.createElement(
	      _layout.Inline,
	      { paddingLeft: 5, marginTop: -1 },
	      '*'
	    ) : null,
	    locked ? _react2.default.createElement(
	      _layout.Inline,
	      { paddingLeft: 5, marginTop: -1 },
	      _react2.default.createElement(
	        _icon2.default,
	        { size: 12 },
	        'lock'
	      )
	    ) : null,
	    icon ? _react2.default.createElement(
	      _layout.Inline,
	      { paddingLeft: 5, marginTop: -1, verticalAlign: 'text-bottom' },
	      (0, _isString3.default)(icon) ? _react2.default.createElement(
	        _icon2.default,
	        { size: 12, verticalAlign: 'middle' },
	        String(icon)
	      ) : icon
	    ) : null
	  );
	}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SPACING = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = FieldRow;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _style = __webpack_require__(37);
	
	var _layout = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SPACING = exports.DEFAULT_SPACING = 20;
	
	/**
	 * Render fields (children) in a row
	 */
	
	function FieldRow(props) {
	  var children = props.children,
	      _props$gutter = props.gutter,
	      gutter = _props$gutter === undefined ? DEFAULT_SPACING : _props$gutter,
	      className = props.className,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'gutter', 'className']);
	
	
	  return React.createElement(
	    _layout.Box,
	    (0, _extends3.default)({
	      className: className,
	      flexDirection: 'row',
	      alignItems: 'top',
	      marginLeft: -gutter,
	      marginTop: DEFAULT_SPACING
	    }, (0, _style.pickStyles)(otherProps)),
	    React.Children.map(children, function (child) {
	      return child ? React.cloneElement(child, {
	        flex: child.props.flex || 1,
	        marginLeft: 0,
	        paddingLeft: gutter
	      }) : child;
	    })
	  );
	}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldRow = __webpack_require__(315);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldRow).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FieldValidation;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FieldValidation(props) {
	  var validation = props.validation;
	
	
	  return _react2.default.createElement(
	    _text2.default,
	    { color: 'red', size: 'extra-small', weight: 'semi-bold', multiline: true },
	    validation.message
	  );
	}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  text-align: ', ';\n\n  > * {\n    margin-top: 5px;\n  }\n'], ['\n  text-align: ', ';\n\n  > * {\n    margin-top: 5px;\n  }\n']);
	
	exports.default = FieldValidations;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(236);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _fieldValidation = __webpack_require__(190);
	
	var _fieldValidation2 = _interopRequireDefault(_fieldValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledFieldValidation = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject, function (props) {
	  return props.centered ? 'center' : 'left';
	});
	
	function FieldValidations(props) {
	  var validations = props.validations,
	      centered = props.centered;
	
	
	  return _react2.default.createElement(
	    StyledFieldValidation,
	    { centered: centered },
	    validations ? validations.map(function (validation) {
	      return (
	        // $FlowFixMe
	        _react2.default.createElement(_fieldValidation2.default, { validation: validation, key: validation.message })
	      );
	    }) : null
	  );
	}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = Field;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _style = __webpack_require__(37);
	
	var _immutable = __webpack_require__(236);
	
	var _layout = __webpack_require__(9);
	
	var _fieldHint = __webpack_require__(189);
	
	var _fieldHint2 = _interopRequireDefault(_fieldHint);
	
	var _fieldLabel = __webpack_require__(82);
	
	var _fieldLabel2 = _interopRequireDefault(_fieldLabel);
	
	var _fieldValidations = __webpack_require__(191);
	
	var _fieldValidations2 = _interopRequireDefault(_fieldValidations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Basic form field container component
	 */
	function Field(props) {
	  var children = props.children,
	      validations = props.validations,
	      _props$permissions = props.permissions,
	      permissions = _props$permissions === undefined ? [] : _props$permissions,
	      label = props.label,
	      _props$labelProps = props.labelProps,
	      labelProps = _props$labelProps === undefined ? {} : _props$labelProps,
	      htmlFor = props.htmlFor,
	      _props$required = props.required,
	      required = _props$required === undefined ? false : _props$required,
	      _props$locked = props.locked,
	      locked = _props$locked === undefined ? false : _props$locked,
	      _props$centered = props.centered,
	      centered = _props$centered === undefined ? false : _props$centered,
	      icon = props.icon,
	      hint = props.hint,
	      hintIcon = props.hintIcon,
	      onClick = props.onClick,
	      className = props.className,
	      labelAction = props.labelAction,
	      _props$inline = props.inline,
	      inline = _props$inline === undefined ? false : _props$inline,
	      labelWidth = props.labelWidth,
	      onBlur = props.onBlur,
	      _props$controlChildre = props.controlChildren,
	      controlChildren = _props$controlChildre === undefined ? true : _props$controlChildre,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'validations', 'permissions', 'label', 'labelProps', 'htmlFor', 'required', 'locked', 'centered', 'icon', 'hint', 'hintIcon', 'onClick', 'className', 'labelAction', 'inline', 'labelWidth', 'onBlur', 'controlChildren']);
	
	
	  var hintText = permissions.length > 0 ? permissions[0].message : hint;
	
	  var disabled = permissions.length > 0;
	
	  return React.createElement(
	    _layout.Box,
	    (0, _extends3.default)({
	      className: className,
	      onClick: onClick,
	      position: 'relative',
	      flexDirection: 'column',
	      justifyContent: inline ? 'space-between' : 'inherit'
	    }, (0, _style.pickStyles)(otherProps)),
	    React.createElement(
	      _layout.Box,
	      {
	        flexDirection: inline ? 'row' : 'column',
	        justifyContent: labelWidth ? 'flex-start' : 'space-between'
	      },
	      label ? React.createElement(
	        _layout.Box,
	        {
	          flexDirection: 'row',
	          alignItems: 'center',
	          justifyContent: centered ? 'center' : 'space-between'
	        },
	        React.createElement(
	          _fieldLabel2.default,
	          {
	            htmlFor: htmlFor,
	            required: required,
	            locked: locked,
	            icon: icon,
	            labelProps: labelProps,
	            marginBottom: inline ? 0 : 4,
	            marginRight: inline ? 8 : 0,
	            width: labelWidth
	          },
	          label
	        ),
	        labelAction
	      ) : null,
	      !controlChildren ? children : React.Children.map(children, function (child) {
	        return React.cloneElement(child, {
	          onBlur: onBlur,
	          disabled: child.props.disabled === undefined ? disabled : child.props.disabled,
	          editable: child.props.editable === undefined ? !disabled : child.props.editable,
	          readonly: child.props.readonly === undefined ? disabled : child.props.readonly
	        });
	      })
	    ),
	    !!validations ? React.createElement(_fieldValidations2.default, { centered: centered, validations: validations }) : hintText ? React.createElement(_fieldHint2.default, { hint: hintText, icon: hintIcon ? hintIcon : undefined }) : null
	  );
	}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _field = __webpack_require__(319);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_field).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border: 0;\n  border-bottom: ', ';\n  background-color: ', ';\n  cursor: ', ';\n'], ['\n  border: 0;\n  border-bottom: ', ';\n  background-color: ', ';\n  cursor: ', ';\n']);
	
	exports.FieldsetHeader = FieldsetHeader;
	exports.default = Fieldset;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _style = __webpack_require__(37);
	
	var _layout = __webpack_require__(9);
	
	var _fieldLabel = __webpack_require__(82);
	
	var _fieldLabel2 = _interopRequireDefault(_fieldLabel);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FieldsetHeader(props) {
	  var legend = props.legend,
	      description = props.description,
	      meta = props.meta;
	
	
	  return React.createElement(
	    _layout.Box,
	    { marginTop: 20 },
	    legend ? React.createElement(
	      _fieldLabel2.default,
	      null,
	      legend,
	      meta ? React.createElement(
	        _text2.default,
	        {
	          size: 'extra-small',
	          color: 'silver',
	          marginLeft: 10,
	          weight: 'normal',
	          resetTransform: true,
	          display: 'inline'
	        },
	        meta
	      ) : null
	    ) : null,
	    description ? React.createElement(
	      _text2.default,
	      { color: 'navy600', multiline: true },
	      description
	    ) : null
	  );
	}
	
	var StyledFieldset = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Box)(_templateObject, function (props) {
	  return props.bordered ? '1px solid ' + props.theme.colors.grey300 : null;
	}, function (props) {
	  return props.inset ? '' + props.theme.colors.navy300 : null;
	}, function (props) {
	  return props.interactive ? 'pointer' : 'inherit';
	});
	
	function Fieldset(props) {
	  var children = props.children,
	      _props$inset = props.inset,
	      inset = _props$inset === undefined ? false : _props$inset,
	      legend = props.legend,
	      description = props.description,
	      onClick = props.onClick,
	      legendMeta = props.legendMeta,
	      name = props.name,
	      className = props.className,
	      _props$bordered = props.bordered,
	      bordered = _props$bordered === undefined ? true : _props$bordered,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'legend', 'description', 'onClick', 'legendMeta', 'name', 'className', 'bordered']);
	
	
	  return React.createElement(
	    StyledFieldset,
	    (0, _extends3.default)({
	      className: className,
	      bordered: bordered,
	      component: 'fieldset',
	      inset: inset,
	      interactive: !!onClick,
	      onClick: onClick,
	      padding: [20, 50, 40, 50] // top -20 accounts forr vertical spacing
	      , name: name
	    }, (0, _style.pickStyles)(otherProps)),
	    legend ? React.createElement(FieldsetHeader, {
	      meta: legendMeta,
	      legend: legend,
	      description: description
	    }) : null,
	    children
	  );
	}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fieldset = __webpack_require__(321);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldset).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactHotkeys = __webpack_require__(707);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A generic (and mostly semantic) form component.
	 */
	
	var Form = function (_PureComponent) {
	  (0, _inherits3.default)(Form, _PureComponent);
	
	  function Form(props) {
	    (0, _classCallCheck3.default)(this, Form);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	    _this.__handlers__ = {
	      'meta+return': _this.onSubmitHotkey.bind(_this)
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'onSubmitHotkey',
	    value: function onSubmitHotkey(event) {
	      if (this.props.onSubmit) {
	        this.props.onSubmit(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	
	      return React.createElement(
	        _reactHotkeys.HotKeys,
	        (0, _extends3.default)({ component: 'form', handlers: this.__handlers__ }, otherProps),
	        children
	      );
	    }
	  }]);
	  return Form;
	}(_component2.default);
	
	exports.default = Form;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _form = __webpack_require__(323);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_form).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = H1;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _heading = __webpack_require__(69);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function H1(props) {
	  var children = props.children;
	
	
	  return React.createElement(
	    _heading2.default,
	    (0, _extends3.default)({ component: 'h1', weight: 'normal', size: 'extra-large' }, props),
	    children
	  );
	}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _h = __webpack_require__(325);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = H2;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _heading = __webpack_require__(69);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function H2(props) {
	  var children = props.children;
	
	
	  return React.createElement(
	    _heading2.default,
	    (0, _extends3.default)({ component: 'h2', weight: 'semi-bold', size: 'large' }, props),
	    children
	  );
	}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _h = __webpack_require__(327);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = H3;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _heading = __webpack_require__(69);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function H3(props) {
	  var children = props.children;
	
	
	  return React.createElement(
	    _heading2.default,
	    (0, _extends3.default)({ component: 'h3', weight: 'semi-bold', size: 'small' }, props),
	    children
	  );
	}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = H4;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _heading = __webpack_require__(69);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function H4(props) {
	  var children = props.children;
	
	
	  return React.createElement(
	    _heading2.default,
	    (0, _extends3.default)({ component: 'h4', weight: 'normal' }, props),
	    children
	  );
	}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _h = __webpack_require__(330);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = Heading;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _heading = __webpack_require__(468);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Heading(props) {
	  var children = props.children,
	      _props$color = props.color,
	      color = _props$color === undefined ? 'navy700' : _props$color,
	      _props$icon = props.icon,
	      icon = _props$icon === undefined ? false : _props$icon,
	      _props$size = props.size,
	      size = _props$size === undefined ? 'small' : _props$size,
	      iconAfter = props.iconAfter,
	      _props$hover = props.hover,
	      hover = _props$hover === undefined ? false : _props$hover,
	      _props$iconPadding = props.iconPadding,
	      iconPadding = _props$iconPadding === undefined ? 10 : _props$iconPadding,
	      className = props.className,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'color', 'icon', 'size', 'iconAfter', 'hover', 'iconPadding', 'className']);
	
	
	  return React.createElement(
	    _text2.default,
	    (0, _extends3.default)({
	      size: size,
	      interactive: hover === 'interactive',
	      display: 'block',
	      color: color,
	      className: (0, _classnames2.default)(_heading2.default.root, className)
	    }, otherProps),
	    icon ? React.createElement(
	      _icon2.default,
	      {
	        size: size === 'extra-large' ? 24 : 14,
	        color: color,
	        paddingRight: iconPadding
	      },
	      icon
	    ) : null,
	    children,
	    iconAfter ? React.createElement(
	      _icon2.default,
	      {
	        size: size === 'extra-large' ? 24 : 14,
	        color: color,
	        paddingLeft: iconPadding
	      },
	      iconAfter
	    ) : null
	  );
	}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", style: { display: "none" } },
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "access_time", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "account_balance", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "account_balance_wallet", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "add", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "archive", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "arrow_drop_down", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M7 10l5 5 5-5z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "arrow_drop_down_circle", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "arrow_drop_up", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M7 14l5-5 5 5z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "art_track", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "assignment", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "attach_file", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "attach_money", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "autorenew", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "border_color", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96a.996.996 0 0 0 0-1.41L18.37.29a.996.996 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M0 20h24v4H0z", fillOpacity: ".36" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "chat", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "check", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "check_box", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "check_box_outline_blank", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "check_circle", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "chevron_left", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "chevron_right", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "clear", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "close", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "comment", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "create", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "credit_card", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "date_range", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "delete", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "done", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "done_all", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "edit", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "email", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "error_outline", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "exit_to_app", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 0 0-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "extension", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 0 0-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 0 0 0-5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "file_upload", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "folder_shared", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "globe", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M14.384 2.174l-1.908.168-.897-.138-.616.91-1.797.093-1.124-.305-1 .515-2.168.285-1.737.472H3.13C5.367 1.624 8.755 0 12.543 0c1.861 0 3.618.404 5.196 1.103l-.437.062-1.198-.17-.847.532-.592.614.882.174.982.885.304.786.227.736 1.563 1.416.402.129.555-.89 1.964-.176.369-.118A12.373 12.373 0 0 1 24 11.973 12.366 12.366 0 0 1 14.57 24l.224-.818 2.116-1.42.555-1.519 1.461-.683 1.385-2.659-2.141-1.265-1.11-1.266-.654-.077-1.31-.354-1.129-.179-.988.28-.605-.684-.605-.178.05-.91-.73.023-.416.482-.238-1.013.955-.456.984.456h.529l.191-.785L14.565 9.2l2.043-1.037 1.183.152.107-.581-1.466-1.495-.553-1.114h-.808l-.504-.296-1.084-.16-.227 1.293-1.312-.254-.1-.81 1.008-.229.331-1.452 1 .414-.026.617.762.32.509.15.624-.328-.555-.658L14.36 2.62l.023-.446zm-.354 15.929s.578 1.919.579 1.995c0 .075-.578 2.298-.578 2.298l.131 1.496a13.42 13.42 0 0 1-1.579.108C5.633 24 0 18.468 0 11.648c0-2.274.636-4.396 1.727-6.225l.906-.206-.908.707.712.457H3.85l2.099-.367 1.322 2.11v1.971l1.803 2.4h.307v-.846l.694 1.426 2.093.461.945.931.84.247-.84 1.72.916 1.669zm.354-15.929l.272-.024.009-.009-.277-.054-.004.087zm-1.325-1.032l-.716.42.498.303 1.106-.104 1.16-.83-.801-.435-1.247.646zm-3.692.094c-.018.137-.8.61-.8.61l.8.44 1.663-.41-.392-.64-.72.215-.551-.215z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "group", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "help_outline", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "highlight_off", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "info", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "info_outline", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "insert_drive_file", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "instagram", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M21.6 0H2.4C1.08 0 0 1.08 0 2.4v19.2C0 22.92 1.08 24 2.4 24h19.2c1.32 0 2.4-1.08 2.4-2.4V2.4C24 1.08 22.92 0 21.6 0zM12 7.2c2.64 0 4.8 2.16 4.8 4.8 0 2.64-2.16 4.8-4.8 4.8-2.64 0-4.8-2.16-4.8-4.8 0-2.64 2.16-4.8 4.8-4.8zM3 21.6c-.36 0-.6-.24-.6-.6V10.8h2.52c-.12.36-.12.84-.12 1.2 0 3.96 3.24 7.2 7.2 7.2s7.2-3.24 7.2-7.2c0-.36 0-.84-.12-1.2h2.52V21c0 .36-.24.6-.6.6H3zM21.6 5.4c0 .36-.24.6-.6.6h-2.4c-.36 0-.6-.24-.6-.6V3c0-.36.24-.6.6-.6H21c.36 0 .6.24.6.6v2.4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "keyboard_arrow_down", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }),
	      _react2.default.createElement("path", { d: "M0-.75h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "keyboard_arrow_left", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" }),
	      _react2.default.createElement("path", { d: "M0-.5h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "keyboard_arrow_right", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }),
	      _react2.default.createElement("path", { d: "M0-.25h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "keyboard_arrow_up", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "keyboard_return", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "launch", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "link", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "linkedin", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement(
	        "title",
	        null,
	        "LinkedIn"
	      ),
	      _react2.default.createElement("path", { d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "local_offer", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "location_on", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "lock", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "loop", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "mail", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "message", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "mode_edit", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "monetization_on", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "more_vert", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "note_add", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "notifications", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "open_in_new", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "payment", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "people", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "perm_contact_calendar", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "perm_identity", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "person", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "person_outline", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "phone", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "picture_as_pdf", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "playlist_add_check", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement(
	        "defs",
	        null,
	        _react2.default.createElement("path", { d: "M0 0h24v24H0V0z", id: "cva" })
	      ),
	      _react2.default.createElement(
	        "clipPath",
	        { id: "cvb" },
	        _react2.default.createElement("use", { overflow: "visible", xlinkHref: "#cva" })
	      ),
	      _react2.default.createElement("path", { clipPath: "url(#cvb)", d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "present_to_all", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "radio_button_checked", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "receipt", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "remove", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M19 13H5v-2h14v2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "remove_circle", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "search", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "send", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "settings", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "short_text", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement(
	        "defs",
	        null,
	        _react2.default.createElement("path", { d: "M0 0h24v24H0V0z", id: "dea" })
	      ),
	      _react2.default.createElement(
	        "clipPath",
	        { id: "deb" },
	        _react2.default.createElement("use", { overflow: "visible", xlinkHref: "#dea" })
	      ),
	      _react2.default.createElement("path", { clipPath: "url(#deb)", d: "M4 9h16v2H4zm0 4h10v2H4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "star", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "swap_vert", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "tv", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "twitter", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M24 5.2a10.23 10.23 0 0 1-2.828.738c1.017-.58 1.797-1.5 2.165-2.595-.951.538-2.005.928-3.127 1.138A5.034 5.034 0 0 0 16.616 3c-2.72 0-4.924 2.1-4.924 4.69 0 .368.044.726.128 1.07C7.727 8.564 4.1 6.697 1.67 3.859a4.501 4.501 0 0 0-.666 2.358c0 1.627.87 3.063 2.19 3.904a5.091 5.091 0 0 1-2.23-.586v.059c0 2.272 1.697 4.168 3.95 4.6a5.16 5.16 0 0 1-2.224.08c.627 1.863 2.445 3.22 4.6 3.257a10.195 10.195 0 0 1-6.115 2.008c-.398 0-.79-.022-1.175-.065a14.444 14.444 0 0 0 7.548 2.107c9.057 0 14.01-7.147 14.01-13.346 0-.204-.005-.406-.015-.607A9.76 9.76 0 0 0 24 5.2" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "verified_user", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "view_headline", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "view_module", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z" }),
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "view_week", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "warning", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
	      _react2.default.createElement("path", { d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "website", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M14.384 2.174l-1.908.168-.897-.138-.616.91-1.797.093-1.124-.305-1 .515-2.168.285-1.737.472H3.13C5.367 1.624 8.755 0 12.543 0c1.861 0 3.618.404 5.196 1.103l-.437.062-1.198-.17-.847.532-.592.614.882.174.982.885.304.786.227.736 1.563 1.416.402.129.555-.89 1.964-.176.369-.118A12.373 12.373 0 0 1 24 11.973 12.366 12.366 0 0 1 14.57 24l.224-.818 2.116-1.42.555-1.519 1.461-.683 1.385-2.659-2.141-1.265-1.11-1.266-.654-.077-1.31-.354-1.129-.179-.988.28-.605-.684-.605-.178.05-.91-.73.023-.416.482-.238-1.013.955-.456.984.456h.529l.191-.785L14.565 9.2l2.043-1.037 1.183.152.107-.581-1.466-1.495-.553-1.114h-.808l-.504-.296-1.084-.16-.227 1.293-1.312-.254-.1-.81 1.008-.229.331-1.452 1 .414-.026.617.762.32.509.15.624-.328-.555-.658L14.36 2.62l.023-.446zm-.354 15.929s.578 1.919.579 1.995c0 .075-.578 2.298-.578 2.298l.131 1.496a13.42 13.42 0 0 1-1.579.108C5.633 24 0 18.468 0 11.648c0-2.274.636-4.396 1.727-6.225l.906-.206-.908.707.712.457H3.85l2.099-.367 1.322 2.11v1.971l1.803 2.4h.307v-.846l.694 1.426 2.093.461.945.931.84.247-.84 1.72.916 1.669zm.354-15.929l.272-.024.009-.009-.277-.054-.004.087zm-1.325-1.032l-.716.42.498.303 1.106-.104 1.16-.83-.801-.435-1.247.646zm-3.692.094c-.018.137-.8.61-.8.61l.8.44 1.663-.41-.392-.64-.72.215-.551-.215z" })
	    ),
	    _react2.default.createElement(
	      "symbol",
	      { viewBox: "0 0 24 24", id: "youtube", xmlns: "http://www.w3.org/2000/svg" },
	      _react2.default.createElement("path", { d: "M23.987 9.89a28.93 28.93 0 0 0-.114-1.919 18.275 18.275 0 0 0-.288-2.074 3.314 3.314 0 0 0-.93-1.73 2.798 2.798 0 0 0-1.668-.816C19.004 3.117 16.009 3 12 3s-7.004.117-8.987.351a2.768 2.768 0 0 0-1.66.816 3.334 3.334 0 0 0-.925 1.73c-.133.61-.234 1.3-.3 2.074a28.957 28.957 0 0 0-.115 1.92C.004 10.397 0 11.1 0 12c0 .9.004 1.603.014 2.11.008.506.046 1.146.113 1.919.067.773.163 1.465.288 2.074.143.685.453 1.261.931 1.73a2.8 2.8 0 0 0 1.667.815C4.996 20.883 7.991 21 12 21c4.01 0 7.004-.117 8.987-.352a2.769 2.769 0 0 0 1.66-.815 3.335 3.335 0 0 0 .924-1.73c.134-.61.235-1.3.302-2.074.067-.773.105-1.413.114-1.92C23.995 13.603 24 12.9 24 12c0-.9-.004-1.603-.013-2.11zm-7.246 2.87l-6.857 4.5a.738.738 0 0 1-.455.14.892.892 0 0 1-.415-.113c-.295-.168-.442-.431-.442-.787v-9c0-.356.147-.619.442-.787.303-.17.593-.16.87.028l6.857 4.5c.268.159.402.412.402.759 0 .347-.134.6-.402.76z" })
	    )
	  );
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconSymbols = __webpack_require__(333);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_iconSymbols).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ICONS = exports.DEFAULT_COLOR = exports.DEFAULT_SIZE = undefined;
	
	var _enum = __webpack_require__(83);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_SIZE = exports.DEFAULT_SIZE = 16;
	
	var DEFAULT_COLOR = exports.DEFAULT_COLOR = 'currentColor';
	
	var ICONS = exports.ICONS = new _enum2.default({
	  ACCESS_TIME: {
	    value: 'access_time'
	  },
	  ACCOUNT_BALANCE: {
	    value: 'account_balance'
	  },
	  ACCOUNT_BALANCE_WALLET: {
	    value: 'account_balance_wallet'
	  },
	  ADD: {
	    value: 'add'
	  },
	  ARCHIVE: {
	    value: 'archive'
	  },
	  ARROW_DROP_DOWN: {
	    value: 'arrow_drop_down'
	  },
	  ARROW_DROP_DOWN_CIRCLE: {
	    value: 'arrow_drop_down_circle'
	  },
	  ARROW_DROP_UP: {
	    value: 'arrow_drop_up'
	  },
	  ART_TRACK: {
	    value: 'art_track'
	  },
	  ASSIGNMENT: {
	    value: 'assignment'
	  },
	  ATTACH_FILE: {
	    value: 'attach_file'
	  },
	  ATTACH_MONEY: {
	    value: 'attach_money'
	  },
	  AUTORENEW: {
	    value: 'autorenew'
	  },
	  BORDER_COLOR: {
	    value: 'border_color'
	  },
	  CHAT: {
	    value: 'chat'
	  },
	  CHECK: {
	    value: 'check'
	  },
	  CHECK_BOX: {
	    value: 'check_box'
	  },
	  CHECK_BOX_OUTLINE_BLANK: {
	    value: 'check_box_outline_blank'
	  },
	  CHECK_CIRCLE: {
	    value: 'check_circle'
	  },
	  CHEVRON_LEFT: {
	    value: 'chevron_left'
	  },
	  CHEVRON_RIGHT: {
	    value: 'chevron_right'
	  },
	  CLEAR: {
	    value: 'clear'
	  },
	  CLOSE: {
	    value: 'close'
	  },
	  COMMENT: {
	    value: 'comment'
	  },
	  CREATE: {
	    value: 'create'
	  },
	  CREDIT_CARD: {
	    value: 'credit_card'
	  },
	  DATE_RANGE: {
	    value: 'date_range'
	  },
	  DELETE: {
	    value: 'delete'
	  },
	  DONE: {
	    value: 'done'
	  },
	  DONE_ALL: {
	    value: 'done_all'
	  },
	  EDIT: {
	    value: 'edit'
	  },
	  EMAIL: {
	    value: 'email'
	  },
	  ERROR_OUTLINE: {
	    value: 'error_outline'
	  },
	  EXIT_TO_APP: {
	    value: 'exit_to_app'
	  },
	  EXTENSION: {
	    value: 'extension'
	  },
	  FILE_UPLOAD: {
	    value: 'file_upload'
	  },
	  FOLDER_SHARED: {
	    value: 'folder_shared'
	  },
	  GLOBE: {
	    value: 'globe'
	  },
	  GROUP: {
	    value: 'group'
	  },
	  HELP_OUTLINE: {
	    value: 'help_outline'
	  },
	  HIGHLIGHT_OFF: {
	    value: 'highlight_off'
	  },
	  INFO: {
	    value: 'info'
	  },
	  INFO_OUTLINE: {
	    value: 'info_outline'
	  },
	  INSERT_DRIVE_FILE: {
	    value: 'insert_drive_file'
	  },
	  INSTAGRAM: {
	    value: 'instagram'
	  },
	  KEYBOARD_ARROW_DOWN: {
	    value: 'keyboard_arrow_down'
	  },
	  KEYBOARD_ARROW_LEFT: {
	    value: 'keyboard_arrow_left'
	  },
	  KEYBOARD_ARROW_RIGHT: {
	    value: 'keyboard_arrow_right'
	  },
	  KEYBOARD_ARROW_UP: {
	    value: 'keyboard_arrow_up'
	  },
	  KEYBOARD_RETURN: {
	    value: 'keyboard_return'
	  },
	  LAUNCH: {
	    value: 'launch'
	  },
	  LINK: {
	    value: 'link'
	  },
	  LINKEDIN: {
	    value: 'linkedin'
	  },
	  LOCAL_OFFER: {
	    value: 'local_offer'
	  },
	  LOCATION_ON: {
	    value: 'location_on'
	  },
	  LOCK: {
	    value: 'lock'
	  },
	  LOOP: {
	    value: 'loop'
	  },
	  MAIL: {
	    value: 'mail'
	  },
	  MESSAGE: {
	    value: 'message'
	  },
	  MODE_EDIT: {
	    value: 'mode_edit'
	  },
	  MONETIZATION_ON: {
	    value: 'monetization_on'
	  },
	  MORE_VERT: {
	    value: 'more_vert'
	  },
	  NOTE_ADD: {
	    value: 'note_add'
	  },
	  NOTIFICATIONS: {
	    value: 'notifications'
	  },
	  OPEN_IN_NEW: {
	    value: 'open_in_new'
	  },
	  PAYMENT: {
	    value: 'payment'
	  },
	  PEOPLE: {
	    value: 'people'
	  },
	  PERM_CONTACT_CALENDAR: {
	    value: 'perm_contact_calendar'
	  },
	  PERM_IDENTITY: {
	    value: 'perm_identity'
	  },
	  PERSON: {
	    value: 'person'
	  },
	  PERSON_OUTLINE: {
	    value: 'person_outline'
	  },
	  PHONE: {
	    value: 'phone'
	  },
	  PICTURE_AS_PDF: {
	    value: 'picture_as_pdf'
	  },
	  PLAYLIST_ADD_CHECK: {
	    value: 'playlist_add_check'
	  },
	  PRESENT_TO_ALL: {
	    value: 'present_to_all'
	  },
	  RADIO_BUTTON_CHECKED: {
	    value: 'radio_button_checked'
	  },
	  RECEIPT: {
	    value: 'receipt'
	  },
	  REMOVE: {
	    value: 'remove'
	  },
	  REMOVE_CIRCLE: {
	    value: 'remove_circle'
	  },
	  SEARCH: {
	    value: 'search'
	  },
	  SEND: {
	    value: 'send'
	  },
	  SETTINGS: {
	    value: 'settings'
	  },
	  SHORT_TEXT: {
	    value: 'short_text'
	  },
	  STAR: {
	    value: 'star'
	  },
	  SWAP_VERT: {
	    value: 'swap_vert'
	  },
	  TV: {
	    value: 'tv'
	  },
	  TWITTER: {
	    value: 'twitter'
	  },
	  VERIFIED_USER: {
	    value: 'verified_user'
	  },
	  VIEW_HEADLINE: {
	    value: 'view_headline'
	  },
	  VIEW_MODULE: {
	    value: 'view_module'
	  },
	  VIEW_WEEK: {
	    value: 'view_week'
	  },
	  WARNING: {
	    value: 'warning'
	  },
	  WEBSITE: {
	    value: 'website'
	  },
	  YOUTUBE: {
	    value: 'youtube'
	  }
	});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  user-select: none;\n  line-height: 1em;\n  vertical-align: middle;\n  cursor: ', ';\n  font-size: ', ';\n  height: ', ';\n  fill: ', ';\n'], ['\n  user-select: none;\n  line-height: 1em;\n  vertical-align: middle;\n  cursor: ', ';\n  font-size: ', ';\n  height: ', ';\n  fill: ', ';\n']);
	
	exports.default = Icon;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _layout = __webpack_require__(9);
	
	var _theme = __webpack_require__(116);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _constants = __webpack_require__(335);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledIcon = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Inline)(_templateObject, function (props) {
	  return props.interactive ? 'cursor' : 'inherit';
	}, function (props) {
	  return props.size + 'px';
	}, function (props) {
	  return props.size + 'px';
	}, function (props) {
	  return props.theme.colors[props.color];
	});
	
	function Icon(props) {
	  var children = props.children,
	      _props$size = props.size,
	      size = _props$size === undefined ? _constants.DEFAULT_SIZE : _props$size,
	      _props$color = props.color,
	      color = _props$color === undefined ? _constants.DEFAULT_COLOR : _props$color,
	      className = props.className,
	      onClick = props.onClick,
	      _props$theme = props.theme,
	      theme = _props$theme === undefined ? _theme2.default : _props$theme,
	      title = props.title,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'size', 'color', 'className', 'onClick', 'theme', 'title']);
	
	
	  return React.createElement(
	    StyledIcon,
	    (0, _extends3.default)({
	      className: className,
	      component: 'i',
	      interactive: !!onClick,
	      onClick: onClick,
	      theme: theme,
	      size: size,
	      color: color,
	      title: title
	    }, otherProps),
	    React.createElement(
	      'svg',
	      { width: size, height: size, 'aria-hidden': 'true' },
	      React.createElement(
	        'title',
	        null,
	        title ? title : children
	      ),
	      React.createElement('use', { xlinkHref: '#' + children })
	    )
	  );
	}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _h = __webpack_require__(326);
	
	Object.defineProperty(exports, 'H1', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h).default;
	  }
	});
	
	var _h2 = __webpack_require__(328);
	
	Object.defineProperty(exports, 'H2', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h2).default;
	  }
	});
	
	var _h3 = __webpack_require__(192);
	
	Object.defineProperty(exports, 'H3', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h3).default;
	  }
	});
	
	var _h4 = __webpack_require__(331);
	
	Object.defineProperty(exports, 'H4', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_h4).default;
	  }
	});
	
	var _heading = __webpack_require__(69);
	
	Object.defineProperty(exports, 'Heading', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_heading).default;
	  }
	});
	
	var _text = __webpack_require__(21);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});
	
	var _skeleton = __webpack_require__(352);
	
	Object.keys(_skeleton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _skeleton[key];
	    }
	  });
	});
	
	var _layout = __webpack_require__(9);
	
	Object.defineProperty(exports, 'Box', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Box;
	  }
	});
	Object.defineProperty(exports, 'Flex', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Flex;
	  }
	});
	Object.defineProperty(exports, 'Block', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Block;
	  }
	});
	Object.defineProperty(exports, 'Inline', {
	  enumerable: true,
	  get: function get() {
	    return _layout.Inline;
	  }
	});
	Object.defineProperty(exports, 'InlineFlex', {
	  enumerable: true,
	  get: function get() {
	    return _layout.InlineFlex;
	  }
	});
	Object.defineProperty(exports, 'A', {
	  enumerable: true,
	  get: function get() {
	    return _layout.A;
	  }
	});
	
	var _paper = __webpack_require__(195);
	
	Object.defineProperty(exports, 'Paper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paper).default;
	  }
	});
	Object.defineProperty(exports, 'PaperToolbar', {
	  enumerable: true,
	  get: function get() {
	    return _paper.PaperToolbar;
	  }
	});
	
	var _paperMenu = __webpack_require__(194);
	
	Object.defineProperty(exports, 'PaperMenu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_paperMenu).default;
	  }
	});
	Object.defineProperty(exports, 'PaperMenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _paperMenu.PaperMenuItem;
	  }
	});
	
	var _button = __webpack_require__(187);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_button).default;
	  }
	});
	
	var _buttonDropdown = __webpack_require__(307);
	
	Object.defineProperty(exports, 'ButtonDropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buttonDropdown).default;
	  }
	});
	
	var _buttonGroup = __webpack_require__(309);
	
	Object.defineProperty(exports, 'ButtonGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buttonGroup).default;
	  }
	});
	
	var _checkbox = __webpack_require__(188);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkbox).default;
	  }
	});
	
	var _field = __webpack_require__(320);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_field).default;
	  }
	});
	
	var _fieldHint = __webpack_require__(189);
	
	Object.defineProperty(exports, 'FieldHint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldHint).default;
	  }
	});
	
	var _fieldLabel = __webpack_require__(82);
	
	Object.defineProperty(exports, 'FieldLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldLabel).default;
	  }
	});
	
	var _fieldRow = __webpack_require__(316);
	
	Object.defineProperty(exports, 'FieldRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldRow).default;
	  }
	});
	
	var _fieldValidation = __webpack_require__(190);
	
	Object.defineProperty(exports, 'FieldValidation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldValidation).default;
	  }
	});
	
	var _fieldValidations = __webpack_require__(191);
	
	Object.defineProperty(exports, 'FieldValidations', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldValidations).default;
	  }
	});
	
	var _fieldset = __webpack_require__(322);
	
	Object.defineProperty(exports, 'Fieldset', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_fieldset).default;
	  }
	});
	
	var _form = __webpack_require__(324);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_form).default;
	  }
	});
	
	var _input = __webpack_require__(338);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_input).default;
	  }
	});
	
	var _select = __webpack_require__(349);
	
	Object.defineProperty(exports, 'SelectOption', {
	  enumerable: true,
	  get: function get() {
	    return _select.Option;
	  }
	});
	
	var _radio = __webpack_require__(347);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_radio).default;
	  }
	});
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_select).default;
	  }
	});
	
	var _textarea = __webpack_require__(356);
	
	Object.defineProperty(exports, 'Textarea', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textarea).default;
	  }
	});
	
	var _toggleButton = __webpack_require__(359);
	
	Object.defineProperty(exports, 'ToggleButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toggleButton).default;
	  }
	});
	
	var _alert = __webpack_require__(305);
	
	Object.defineProperty(exports, 'Alert', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_alert).default;
	  }
	});
	Object.defineProperty(exports, 'AlertPopover', {
	  enumerable: true,
	  get: function get() {
	    return _alert.AlertPopover;
	  }
	});
	
	var _icon = __webpack_require__(25);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_icon).default;
	  }
	});
	
	var _iconSymbols = __webpack_require__(334);
	
	Object.defineProperty(exports, 'IconSymbols', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_iconSymbols).default;
	  }
	});
	
	var _loadingSpinner = __webpack_require__(193);
	
	Object.defineProperty(exports, 'LoadingSpinner', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_loadingSpinner).default;
	  }
	});
	
	var _sticky = __webpack_require__(196);
	
	Object.defineProperty(exports, 'Sticky', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sticky).default;
	  }
	});
	
	var _theme = __webpack_require__(116);
	
	Object.defineProperty(exports, 'theme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_theme).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Layout
	 */

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _input = __webpack_require__(339);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_input).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InputAddon = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isBoolean2 = __webpack_require__(155);
	
	var _isBoolean3 = _interopRequireDefault(_isBoolean2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  min-width: 40px;\n  height: 40px;\n  flex-flow: column;\n  text-align: center;\n\n  ', ';\n'], ['\n  min-width: 40px;\n  height: 40px;\n  flex-flow: column;\n  text-align: center;\n\n  ', ';\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      color: ', ';\n      border: 1px solid #dfe2e4;\n      padding: 0 16px;\n\n      ', ';\n      ', ';\n    '], ['\n      background-color: ', ';\n      color: ', ';\n      border: 1px solid #dfe2e4;\n      padding: 0 16px;\n\n      ', ';\n      ', ';\n    ']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n          border-right: 0;\n          border-radius: ', ' 0 0\n            ', ';\n        '], ['\n          border-right: 0;\n          border-radius: ', ' 0 0\n            ', ';\n        ']),
	    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n          border-left: 0;\n          border-radius: 0 ', '\n            ', ' 0;\n        '], ['\n          border-left: 0;\n          border-radius: 0 ', '\n            ', ' 0;\n        ']),
	    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 16px;\n  font-weight: ', ';\n  transition: background-color, border-color 160ms linear;\n  user-select: text;\n  width: 100%;\n'], ['\n  font-size: 16px;\n  font-weight: ', ';\n  transition: background-color, border-color 160ms linear;\n  user-select: text;\n  width: 100%;\n']),
	    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  min-width: 0;\n  color: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:-webkit-autofill {\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:read-only {\n    background-color: ', ';\n    border: ', ';\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ' ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  min-width: 0;\n  color: ', ';\n  font-size: ', 'px;\n  height: ', 'px;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:-webkit-autofill {\n    background-color: transparent;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:read-only {\n    background-color: ', ';\n    border: ', ';\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ' ', ';\n\n  ', ';\n']),
	    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: #fff;\n      border-radius: ', ';\n      border: ', ';\n      padding: 4px 8px 4px 16px;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n\n      ', ';\n      ', ';\n    '], ['\n      background-color: #fff;\n      border-radius: ', ';\n      border: ', ';\n      padding: 4px 8px 4px 16px;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n\n      ', ';\n      ', ';\n    ']),
	    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        '], ['\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        ']),
	    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        '], ['\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        ']),
	    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n      background: transparent;\n      border: 0;\n      padding: 4px 0;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:disabled,\n      &:read-only {\n        background-color: transparent;\n        border: 0;\n      }\n    '], ['\n      background: transparent;\n      border: 0;\n      padding: 4px 0;\n\n      &::placeholder {\n        color: ', ';\n      }\n\n      &:disabled,\n      &:read-only {\n        background-color: transparent;\n        border: 0;\n      }\n    ']),
	    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n      border: 1px solid ', ';\n      padding: 7px 10px;\n    '], ['\n      border: 1px solid ', ';\n      padding: 7px 10px;\n    ']),
	    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['\n        border-color: ', '!important;\n      '], ['\n        border-color: ', '!important;\n      ']),
	    _templateObject13 = (0, _taggedTemplateLiteral3.default)(['\n      border-color: ', '!important;\n    '], ['\n      border-color: ', '!important;\n    ']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _react2 = __webpack_require__(363);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _layout = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPANDS_BUFFER = 5;
	
	var INPUT_SIZE_MAP = {
	  small: {
	    fontSize: 14,
	    size: 32
	  },
	  medium: {
	    fontSize: 14,
	    size: 40
	  },
	  large: {
	    fontSize: 16,
	    size: 48
	  }
	};
	
	var getInputFont = function getInputFont(size) {
	  return 'normal ' + INPUT_SIZE_MAP[size].fontSize + 'px WebFaktSoftPro';
	};
	
	var StyledInputAddon = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Flex)(_templateObject, function (props) {
	  return props.inputTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.grey300, props.theme.colors.navy600, props.addonType === 'prefix' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3, props.theme.layout.borderRadiusInput, props.theme.layout.borderRadiusInput), props.addonType === 'suffix' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4, props.theme.layout.borderRadiusInput, props.theme.layout.borderRadiusInput));
	});
	
	var InputAddon = exports.InputAddon = function InputAddon(props) {
	  return React.createElement(
	    StyledInputAddon,
	    {
	      justifyContent: 'center',
	      alignItems: 'center',
	      addonType: props.type,
	      inputTheme: props.inputTheme
	    },
	    (0, _isString3.default)(props.content) ? React.createElement(
	      _text2.default,
	      { size: 'small', color: 'slate', weight: 'semi-bold' },
	      props.content
	    ) : props.content
	  );
	};
	
	var StyledInputContainer = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Flex)(_templateObject5, function (props) {
	  return props.theme.typography.fontWeightNormal;
	});
	
	var StyledInput = /*#__PURE__*/(0, _reactEmotion2.default)('input')(_templateObject6, function (props) {
	  return props.theme.colors.navy700;
	}, function (props) {
	  return INPUT_SIZE_MAP[props.size].fontSize;
	}, function (props) {
	  return INPUT_SIZE_MAP[props.size].size;
	}, function (props) {
	  return props.theme.input.inputDisabledBackground;
	}, function (props) {
	  return props.theme.input.inputDisabledBorder;
	}, function (props) {
	  return props.theme.input.inputDisabledColor;
	}, function (props) {
	  return props.theme.input.inputReadonlyBackground;
	}, function (props) {
	  return props.theme.input.inputReadonlyBorder;
	}, function (props) {
	  return props.theme.input.inputReadonlyColor;
	}, function (props) {
	  return props.inputTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject7, props.theme.input.inputBorderRadius, props.theme.input.inputDefaultBorder, props.theme.colors.grey500, props.theme.input.inputHoverBorder, props.theme.input.inputActiveBorder, props.withAddonPrefix && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject8), props.withAddonSuffix && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject9));
	}, function (props) {
	  return props.inputTheme === 'transparent' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject10, props.theme.colors.navy500);
	}, function (props) {
	  return props.inputTheme === 'well' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject11, props.theme.colors.grey500);
	}, function (props) {
	  return props.valid && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject12, props.theme.colors.green500);
	}, function (props) {
	  return props.invalid && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject13, props.theme.colors.pink500);
	});
	
	var Input = function (_PureComponent) {
	  (0, _inherits3.default)(Input, _PureComponent);
	
	  function Input(props) {
	    (0, _classCallCheck3.default)(this, Input);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.state = { focused: false, changed: false };
	
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'onFocus',
	    value: function onFocus(event) {
	      if (this.props.onFocus) {
	        this.props.onFocus(event);
	
	        this.setState({ focused: true });
	      }
	
	      if (this.props.readonly) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(event) {
	      if (this.props.onBlur) {
	        this.props.onBlur(event);
	      }
	
	      if (this.props.readonly) {
	        event.preventDefault();
	        return;
	      }
	
	      this.setState({ focused: false });
	
	      if (this.state.changed && this.props.onEdited) {
	        this.props.onEdited(event);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(event) {
	      if (this.props.onChange) {
	        this.props.onChange(event);
	      }
	      this.setState({ changed: true });
	    }
	
	    /**
	     * If we are presenting an extendable input field we need to know what width
	     * our input should have, this will depend on the width of the text currently
	     * entered as well as the font. We use canvas to measure this value.
	     */
	
	  }, {
	    key: 'getTextWidth',
	    value: function getTextWidth(text, font) {
	      this.canvas = this.canvas ? this.canvas : document.createElement('canvas');
	      var context = this.canvas.getContext('2d');
	      if (context) {
	        context.font = font;
	        return context.measureText(text).width;
	      }
	      return 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          theme = _props.theme,
	          margin = _props.margin,
	          size = _props.size,
	          fullWidth = _props.fullWidth,
	          defaultValue = _props.defaultValue,
	          value = _props.value,
	          style = _props.style,
	          className = _props.className,
	          expands = _props.expands,
	          focusOnMount = _props.focusOnMount,
	          _IGNORED = _props.onEdited,
	          __IGNORED = _props.editable,
	          placeholder = _props.placeholder,
	          valid = _props.valid,
	          readonly = _props.readonly,
	          name = _props.name,
	          inputRef = _props.inputRef,
	          addonPrefix = _props.addonPrefix,
	          addonSuffix = _props.addonSuffix,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['theme', 'margin', 'size', 'fullWidth', 'defaultValue', 'value', 'style', 'className', 'expands', 'focusOnMount', 'onEdited', 'editable', 'placeholder', 'valid', 'readonly', 'name', 'inputRef', 'addonPrefix', 'addonSuffix']);
	      var focused = this.state.focused;
	
	
	      var _styles = (0, _extends3.default)({}, style, {
	        width: expands ? Math.max(this.getTextWidth(value, getInputFont(size)) + EXPANDS_BUFFER, this.getTextWidth(placeholder, getInputFont(size)) + EXPANDS_BUFFER) : undefined
	      });
	
	      return React.createElement(
	        StyledInputContainer,
	        { marginBottom: margin, className: className },
	        addonPrefix ? React.createElement(InputAddon, { inputTheme: theme, content: addonPrefix, type: 'prefix' }) : null,
	        React.createElement(StyledInput, (0, _extends3.default)({}, otherProps, {
	          /** Emotion Props */
	          inputTheme: theme,
	          expands: expands,
	          valid: (0, _isBoolean3.default)(valid) && valid,
	          invalid: (0, _isBoolean3.default)(valid) && !valid,
	          focused: focused,
	          margin: margin,
	          fullWidth: fullWidth,
	          size: size,
	          withAddonPrefix: !!addonPrefix,
	          withAddonSuffix: !!addonSuffix
	          /** Other Props */
	          , ref: focusOnMount ? _react2.focusOnMount : inputRef,
	          style: _styles,
	          className: className,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onChange: readonly ? undefined : this.onChange,
	          placeholder: placeholder,
	          name: !!name ? name : placeholder,
	          value: value,
	          defaultValue: defaultValue,
	          readOnly: readonly
	        })),
	        addonSuffix ? React.createElement(InputAddon, { inputTheme: theme, content: addonSuffix, type: 'suffix' }) : null
	      );
	    }
	  }]);
	  return Input;
	}(_component2.default);
	
	Input.defaultProps = {
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {},
	  onEdited: function onEdited() {},
	  theme: 'default',
	  margin: 'none',
	  size: 'medium'
	};
	exports.default = Input;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.A = exports.InlineFlex = exports.Inline = exports.Block = exports.Flex = exports.Box = undefined;
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _emotion = __webpack_require__(94);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  flex-direction: column;\n  align-items: stretch;\n  flex-shrink: 0;\n  align-content: flex-start;\n  display: flex;\n  ', ';\n  ', ';\n'], ['\n  position: relative;\n  flex-direction: column;\n  align-items: stretch;\n  flex-shrink: 0;\n  align-content: flex-start;\n  display: flex;\n  ', ';\n  ', ';\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  ', ';\n  ', ';\n'], ['\n  display: flex;\n  ', ';\n  ', ';\n']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: block;\n  ', ';\n  ', ';\n'], ['\n  display: block;\n  ', ';\n  ', ';\n']),
	    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  vertical-align: bottom;\n  ', ';\n  ', ';\n'], ['\n  display: inline-block;\n  vertical-align: bottom;\n  ', ';\n  ', ';\n']),
	    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-flex;\n  ', ';\n  ', ';\n'], ['\n  display: inline-flex;\n  ', ';\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(37);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makePrimitive = function makePrimitive(name, DefaultComponent) {
	  var Primitive = function (_PureComponent) {
	    (0, _inherits3.default)(Primitive, _PureComponent);
	
	    function Primitive() {
	      (0, _classCallCheck3.default)(this, Primitive);
	      return (0, _possibleConstructorReturn3.default)(this, (Primitive.__proto__ || Object.getPrototypeOf(Primitive)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Primitive, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            _props$component = _props.component,
	            Component = _props$component === undefined ? DefaultComponent : _props$component,
	            elRef = _props.elRef,
	            propStyle = _props.style,
	            className = _props.className,
	            otherProps = (0, _objectWithoutProperties3.default)(_props, ['component', 'elRef', 'style', 'className']);
	
	        var _parseStyleProps = (0, _style.parseStyleProps)((0, _extends3.default)({}, otherProps)),
	            props = _parseStyleProps.props,
	            style = _parseStyleProps.style;
	
	        var cleanedProps = (0, _style.cleanProps)(props);
	
	        return _react2.default.createElement(Component, (0, _extends3.default)({
	          ref: elRef,
	          className: (0, _emotion.merge)((0, _emotion.css)((0, _extends3.default)({}, style), '\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */') + (' ' + (className ? (0, _reactEmotion.cx)(className) : null)), '\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */')
	        }, cleanedProps, {
	          style: (0, _extends3.default)({}, propStyle)
	        }));
	      }
	    }]);
	    return Primitive;
	  }(_component2.default);
	
	  Primitive.displayName = 'Primitive' + name;
	  return Primitive;
	};
	
	/** 
	 * Layout primitives
	 */
	
	var Box = /*#__PURE__*/exports.Box = (0, _reactEmotion2.default)(makePrimitive('Box', 'div'))(_templateObject, _style.spacing, _style.filterStyleProps);
	Box.displayName = 'Box';
	
	var Flex = /*#__PURE__*/exports.Flex = (0, _reactEmotion2.default)(makePrimitive('Flex', 'div'))(_templateObject2, _style.spacing, _style.filterStyleProps);
	Flex.displayName = 'Flex';
	
	var Block = /*#__PURE__*/exports.Block = (0, _reactEmotion2.default)(makePrimitive('Block', 'div'))(_templateObject3, _style.spacing, _style.filterStyleProps);
	Block.displayName = 'Block';
	
	var Inline = /*#__PURE__*/exports.Inline = (0, _reactEmotion2.default)(makePrimitive('Inline', 'span'))(_templateObject4, _style.spacing, _style.filterStyleProps);
	Inline.displayName = 'Inline';
	
	var InlineFlex = /*#__PURE__*/exports.InlineFlex = (0, _reactEmotion2.default)(makePrimitive('InlineFlex', 'span'))(_templateObject5, _style.spacing, _style.filterStyleProps);
	InlineFlex.displayName = 'InlineFlex';
	
	/**
	 * All of our html primitives should follow here so our api is consistent to the very root
	 * Eg. Button, Input, Select, Table etc.
	 */
	
	var A = /*#__PURE__*/exports.A = (0, _reactEmotion2.default)(makePrimitive('A', 'a'))(_templateObject5, _style.spacing, _style.filterStyleProps);
	A.displayName = 'A';

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _loadingSpinner = __webpack_require__(469);
	
	var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SPINNER_DIMENSIONS = {
	  small: 20,
	  medium: 30,
	  large: 50
	};
	
	var LoadingSpinner = function (_PureComponent) {
	  (0, _inherits3.default)(LoadingSpinner, _PureComponent);
	
	  function LoadingSpinner() {
	    (0, _classCallCheck3.default)(this, LoadingSpinner);
	    return (0, _possibleConstructorReturn3.default)(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoadingSpinner, [{
	    key: 'render',
	    value: function render() {
	      var _cx;
	
	      var size = this.props.size;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _loadingSpinner2.default.root, true), (0, _defineProperty3.default)(_cx, _loadingSpinner2.default[size], true), _cx))
	        },
	        _react2.default.createElement(
	          'svg',
	          {
	            width: SPINNER_DIMENSIONS[size] + 'px',
	            height: SPINNER_DIMENSIONS[size] + 'px',
	            viewBox: '0 0 20 20',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            d: 'M7.33335912,2.33334154 C7.33335912,3.62501275 8.37502945,4.66668308 9.66670066,4.66668308 C10.9583719,4.66668308 12.0000422,3.62501275 12.0000422,2.33334154 C12.0000422,1.04167033 10.9583719,0 9.66670066,0 C8.37502945,0 7.33335912,1.04167033 7.33335912,2.33334154 L7.33335912,2.33334154 Z M14.8542189,6.81252396 C16.1458901,6.81252396 17.1875604,5.77085363 17.1875604,4.47918242 C17.1875604,3.18751121 16.1458901,2.14584088 14.8542189,2.14584088 C13.5625477,2.14584088 12.5208774,3.18751121 12.5208774,4.47918242 C12.5208774,5.77085363 13.5625477,6.81252396 14.8542189,6.81252396 L14.8542189,6.81252396 Z M4.47918242,6.81252396 C5.77085363,6.81252396 6.81252396,5.77085363 6.81252396,4.47918242 C6.81252396,3.18751121 5.77085363,2.14584088 4.47918242,2.14584088 C3.18751121,2.14584088 2.14584088,3.18751121 2.14584088,4.47918242 C2.14584088,5.77085363 3.18751121,6.81252396 4.47918242,6.81252396 L4.47918242,6.81252396 Z M17.0000598,12.0000422 C18.291731,12.0000422 19.3334013,10.9583719 19.3334013,9.66670066 C19.3334013,8.37502945 18.291731,7.33335912 17.0000598,7.33335912 C15.7083886,7.33335912 14.6667182,8.37502945 14.6667182,9.66670066 C14.6667182,10.9583719 15.7083886,12.0000422 17.0000598,12.0000422 L17.0000598,12.0000422 Z M2.33334154,12.0000422 C3.62501275,12.0000422 4.66668308,10.9583719 4.66668308,9.66670066 C4.66668308,8.37502945 3.62501275,7.33335912 2.33334154,7.33335912 C1.04167033,7.33335912 0,8.37502945 0,9.66670066 C0,10.9583719 1.04167033,12.0000422 2.33334154,12.0000422 L2.33334154,12.0000422 Z M4.47918242,17.1875604 C5.77085363,17.1875604 6.81252396,16.1458901 6.81252396,14.8542189 C6.81252396,13.5625477 5.77085363,12.5208774 4.47918242,12.5208774 C3.18751121,12.5208774 2.14584088,13.5625477 2.14584088,14.8542189 C2.14584088,16.1458901 3.18751121,17.1875604 4.47918242,17.1875604 L4.47918242,17.1875604 Z M14.8542189,17.1875604 C16.1458901,17.1875604 17.1875604,16.1458901 17.1875604,14.8542189 C17.1875604,13.5625477 16.1458901,12.5208774 14.8542189,12.5208774 C13.5625477,12.5208774 12.5208774,13.5625477 12.5208774,14.8542189 C12.5208774,16.1458901 13.5625477,17.1875604 14.8542189,17.1875604 L14.8542189,17.1875604 Z M9.66670066,19.3334013 C10.9583719,19.3334013 12.0000422,18.291731 12.0000422,17.0000598 C12.0000422,15.7083886 10.9583719,14.6667182 9.66670066,14.6667182 C8.37502945,14.6667182 7.33335912,15.7083886 7.33335912,17.0000598 C7.33335912,18.291731 8.37502945,19.3334013 9.66670066,19.3334013 L9.66670066,19.3334013 Z',
	            stroke: 'none'
	          })
	        )
	      );
	    }
	  }]);
	  return LoadingSpinner;
	}(_component2.default);
	
	LoadingSpinner.propTypes = {
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
	};
	LoadingSpinner.defaultProps = {
	  size: 'medium'
	};
	exports.default = LoadingSpinner;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isString2 = __webpack_require__(61);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	exports.default = PaperMenuItem;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _layout = __webpack_require__(9);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _paperMenuItem = __webpack_require__(470);
	
	var _paperMenuItem2 = _interopRequireDefault(_paperMenuItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_HEIGHT = 52;
	
	/**
	 * Generic item container for use in paper menus
	 */
	
	function PaperMenuItem(props) {
	  var _cx;
	
	  var icon = props.icon,
	      children = props.children,
	      active = props.active,
	      disabled = props.disabled,
	      highlighted = props.highlighted,
	      name = props.name,
	      success = props.success,
	      className = props.className,
	      onClick = props.onClick,
	      _props$component = props.component,
	      component = _props$component === undefined ? _layout.Box : _props$component,
	      minWidth = props.minWidth,
	      iconAfter = props.iconAfter,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['icon', 'children', 'active', 'disabled', 'highlighted', 'name', 'success', 'className', 'onClick', 'component', 'minWidth', 'iconAfter']);
	
	
	  var _classNames = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.root, true), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.highlighted, highlighted), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.active, active), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.success, success), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.disabled, disabled), _cx), className);
	
	  return React.createElement(
	    _layout.Box,
	    (0, _extends3.default)({
	      className: _classNames,
	      flexDirection: 'row',
	      minHeight: DEFAULT_HEIGHT,
	      minWidth: minWidth ? minWidth : 'auto',
	      alignItems: 'center',
	      alignContent: 'center',
	      onClick: onClick,
	      name: name,
	      component: component
	    }, otherProps),
	    icon ? React.createElement(
	      _layout.Box,
	      { marginRight: 10 },
	      (0, _isString3.default)(icon) ? React.createElement(
	        _icon2.default,
	        { size: 16 },
	        String(icon)
	      ) : icon
	    ) : null,
	    React.createElement(
	      _layout.Box,
	      { flexDirection: 'row', className: _paperMenuItem2.default.content },
	      children
	    ),
	    iconAfter ? React.createElement(
	      _layout.Box,
	      { marginLeft: 10 },
	      (0, _isString3.default)(iconAfter) ? React.createElement(
	        _icon2.default,
	        { size: 16 },
	        String(iconAfter)
	      ) : iconAfter
	    ) : null
	  );
	}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(162);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _h = __webpack_require__(192);
	
	var _h2 = _interopRequireDefault(_h);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _paper = __webpack_require__(195);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _sticky = __webpack_require__(196);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _paperMenu = __webpack_require__(471);
	
	var _paperMenu2 = _interopRequireDefault(_paperMenu);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generic open/close popup paper styled menu
	 */
	
	var PaperMenu = function (_PureComponent) {
	  (0, _inherits3.default)(PaperMenu, _PureComponent);
	
	  function PaperMenu(props) {
	    (0, _classCallCheck3.default)(this, PaperMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PaperMenu.__proto__ || Object.getPrototypeOf(PaperMenu)).call(this));
	
	    _this.onWindowClick = _this.onWindowClick.bind(_this);
	
	    if (props.open) {
	      window.addEventListener('click', _this.onWindowClick);
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(PaperMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      // We only bind a window click event handler while the menu is open.
	      // We also wait for the animation to finish. This means that multiple
	      // paper menu’s will not stay open at the same time.
	      if (newProps.open && !this.props.open) {
	        setTimeout(function () {
	          return window.addEventListener('click', _this2.onWindowClick);
	        }, 300);
	      }
	      if (!newProps.open && this.props.open) {
	        window.removeEventListener('click', this.onWindowClick);
	      }
	    }
	  }, {
	    key: 'onWindowClick',
	    value: function onWindowClick(event) {
	      if (this.props.open && this.props.closeOnOutsideClick && this.props.onRequestClose) {
	        this.props.onRequestClose(event);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          children = _props.children,
	          origin = _props.origin,
	          paper = _props.paper,
	          root = _props.root,
	          heading = _props.heading,
	          anchor = _props.anchor,
	          offset = _props.offset,
	          zIndex = _props.zIndex,
	          sticky = _props.sticky,
	          optionIcons = _props.optionIcons;
	
	
	      return React.createElement(
	        _sticky2.default,
	        (0, _extends3.default)({ anchor: anchor, offset: offset, zIndex: zIndex }, sticky),
	        React.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionName: 't-scale',
	            transitionEnterTimeout: 300,
	            transitionLeaveTimeout: 300,
	            transitionAppearTimeout: 300
	          },
	          open ? React.createElement(
	            'div',
	            (0, _extends3.default)({}, root, {
	              className: _paperMenu2.default.root,
	              style: { transformOrigin: origin },
	              onClick: function onClick(event) {
	                return event.stopPropagation();
	              }
	            }),
	            React.createElement(
	              _paper2.default,
	              paper,
	              heading && React.createElement(
	                'div',
	                { className: _paperMenu2.default.header },
	                React.createElement(
	                  _h2.default,
	                  null,
	                  heading
	                ),
	                React.createElement(
	                  'div',
	                  { className: _paperMenu2.default.options },
	                  optionIcons,
	                  React.createElement(
	                    'div',
	                    {
	                      className: _paperMenu2.default.close,
	                      onClick: this.props.onRequestClose
	                    },
	                    React.createElement(
	                      _icon2.default,
	                      { size: 18 },
	                      'clear'
	                    )
	                  )
	                )
	              ),
	              children
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	  return PaperMenu;
	}(_component2.default);
	
	PaperMenu.defaultProps = {
	  children: '',
	  origin: 'top left',
	  open: false,
	  anchor: 'bottom',
	  zIndex: 100,
	  paper: {
	    rounded: true,
	    elevation: 2,
	    hoverElevation: 2
	  },
	  closeOnOutsideClick: true
	};
	exports.default = PaperMenu;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaperToolbar = PaperToolbar;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _layout = __webpack_require__(9);
	
	var _paperToolbar = __webpack_require__(472);
	
	var _paperToolbar2 = _interopRequireDefault(_paperToolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * @summary A basic toolbar container to display at the top of paper
	 */
	
	function PaperToolbar(props) {
	  var children = props.children;
	
	
	  return React.createElement(
	    _layout.Box,
	    { className: _paperToolbar2.default.root, padding: [0, 25] },
	    children
	  );
	}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = Paper;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _layout = __webpack_require__(9);
	
	var _paper = __webpack_require__(473);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @summary This is the kalo paper component.
	 * It is in charge of implementing the box-shadow around
	 * our cards and the focus/blur animations.
	 *
	 */
	function Paper(props) {
	  var _cx;
	
	  var focused = props.focused,
	      padded = props.padded,
	      _props$border = props.border,
	      border = _props$border === undefined ? true : _props$border,
	      children = props.children,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === undefined ? 1 : _props$elevation,
	      _props$hoverElevation = props.hoverElevation,
	      hoverElevation = _props$hoverElevation === undefined ? 1 : _props$hoverElevation,
	      className = props.className,
	      _props$rounded = props.rounded,
	      rounded = _props$rounded === undefined ? true : _props$rounded,
	      opaque = props.opaque,
	      wireframe = props.wireframe,
	      onClick = props.onClick,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['focused', 'padded', 'border', 'children', 'elevation', 'hoverElevation', 'className', 'rounded', 'opaque', 'wireframe', 'onClick']);
	
	
	  var zDepth = Math.min(elevation, 5);
	  var hoverZDept = Math.min(hoverElevation, 5);
	
	  var _classNames = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _paper2.default.root, true), (0, _defineProperty3.default)(_cx, _paper2.default.focused, focused), (0, _defineProperty3.default)(_cx, _paper2.default['level-' + zDepth], true), (0, _defineProperty3.default)(_cx, _paper2.default['hover-level-' + hoverZDept], true), (0, _defineProperty3.default)(_cx, _paper2.default.border, border), (0, _defineProperty3.default)(_cx, _paper2.default.rounded, rounded), (0, _defineProperty3.default)(_cx, _paper2.default.padded, padded), (0, _defineProperty3.default)(_cx, _paper2.default.opaque, opaque), (0, _defineProperty3.default)(_cx, _paper2.default.wireframe, wireframe), (0, _defineProperty3.default)(_cx, _paper2.default.interactive, !!onClick), _cx), className);
	
	  return React.createElement(
	    _layout.Box,
	    (0, _extends3.default)({ className: _classNames, onClick: onClick }, otherProps),
	    children
	  );
	}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RADIO_SIZES = undefined;
	
	var _enum = __webpack_require__(83);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RADIO_SIZES = exports.RADIO_SIZES = new _enum2.default({
	  SMALL: {
	    value: 'small',
	    size: 14
	  },
	  MEDIUM: {
	    value: 'medium',
	    size: 16
	  }
	});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _radio = __webpack_require__(348);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_radio).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isNull2 = __webpack_require__(626);
	
	var _isNull3 = _interopRequireDefault(_isNull2);
	
	exports.Radio = Radio;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(37);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(162);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _layout = __webpack_require__(9);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _constants = __webpack_require__(346);
	
	var _radio = __webpack_require__(474);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Radio(props) {
	  var _cx, _cx2;
	
	  var _props$checked = props.checked,
	      checked = _props$checked === undefined ? false : _props$checked,
	      _props$size = props.size,
	      size = _props$size === undefined ? 'medium' : _props$size,
	      disabled = props.disabled,
	      readonly = props.readonly,
	      label = props.label,
	      onClick = props.onClick,
	      name = props.name,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['checked', 'size', 'disabled', 'readonly', 'label', 'onClick', 'name']);
	
	
	  return _react2.default.createElement(
	    _layout.Flex,
	    {
	      alignItems: 'center',
	      justifyContent: 'start',
	      onClick: readonly || disabled ? null : onClick,
	      name: name,
	      role: 'radio',
	      'aria-checked': checked,
	      'aria-disabled': disabled,
	      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _radio2.default.root, true), (0, _defineProperty3.default)(_cx, _radio2.default.disabled, disabled), (0, _defineProperty3.default)(_cx, _radio2.default.readonly, readonly), _cx))
	    },
	    _react2.default.createElement(
	      _layout.Box,
	      (0, _extends3.default)({
	        position: 'relative',
	        width: _constants.RADIO_SIZES.properties[size].size,
	        height: _constants.RADIO_SIZES.properties[size].size,
	        className: (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, _radio2.default.radio, true), (0, _defineProperty3.default)(_cx2, _radio2.default.checked, checked), _cx2))
	      }, (0, _style.pickStyles)(otherProps), otherProps),
	      _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: 't-scale',
	          transitionEnterTimeout: 300,
	          transitionLeaveTimeout: 300
	        },
	        checked || (0, _isNull3.default)(checked) ? _react2.default.createElement(_layout.Inline, {
	          position: 'absolute',
	          className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _radio2.default.icon, true))
	        }) : null
	      )
	    ),
	    label ? _react2.default.createElement(
	      _text2.default,
	      { marginLeft: 10, size: 'small', color: 'navy700', component: 'label' },
	      label
	    ) : null
	  );
	}
	
	exports.default = Radio;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(351);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_select).default;
	  }
	});
	
	var _option = __webpack_require__(350);
	
	Object.defineProperty(exports, 'Option', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_option).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Option;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Option(props) {
	  return React.createElement(
	    'div',
	    null,
	    props.children
	  );
	}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  position: relative;\n  border: ', ';\n  border-radius: ', ';\n  background-color: ', ';\n  height: 40px;\n  text-align: ', ';\n  cursor: pointer;\n\n  &:hover {\n    border: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  position: relative;\n  border: ', ';\n  border-radius: ', ';\n  background-color: ', ';\n  height: 40px;\n  text-align: ', ';\n  cursor: pointer;\n\n  &:hover {\n    border: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      border-color: ', ';\n      background-color: ', ';\n    '], ['\n      border-color: ', ';\n      background-color: ', ';\n    ']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      cursor: default;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      cursor: default;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    ']),
	    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      cursor: not-allowed;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      cursor: not-allowed;\n      color: ', ';\n\n      &:hover {\n        border: ', ';\n      }\n    ']),
	    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  transform: rotate(90deg);\n\n  ', ';\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  width: 30px;\n  transform: rotate(90deg);\n\n  ', ';\n']),
	    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['transform: rotate(-90deg);'], ['transform: rotate(-90deg);']),
	    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  width: 28px;\n  background-color: ', ';\n  border-radius: ', ';\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 28px;\n  width: 28px;\n  background-color: ', ';\n  border-radius: ', ';\n']),
	    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: 4px;\n  background: ', ';\n  width: 100%;\n  display: none;\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 0px;\n  z-index: 300;\n  border: 1px solid ', ';\n  box-shadow: 0 3px 6px rgba(140, 140, 140, 0.08);\n\n  ', ';\n'], ['\n  border-radius: 4px;\n  background: ', ';\n  width: 100%;\n  display: none;\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 0px;\n  z-index: 300;\n  border: 1px solid ', ';\n  box-shadow: 0 3px 6px rgba(140, 140, 140, 0.08);\n\n  ', ';\n']),
	    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n      display: block;\n      width: calc(100% + 2px);\n      left: -1px;\n      top: calc(100% + 4px);\n      min-height: 200px;\n    '], ['\n      display: block;\n      width: calc(100% + 2px);\n      left: -1px;\n      top: calc(100% + 4px);\n      min-height: 200px;\n    ']),
	    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 8px 16px;\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border-radius: 0;\n    border: none;\n  }\n\n  ', ';\n'], ['\n  padding: 8px 16px;\n  cursor: pointer;\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border-radius: 0;\n    border: none;\n  }\n\n  ', ';\n']),
	    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n      color: ', ';\n      background: ', ';\n      border-radius: 0;\n      border: none;\n    '], ['\n      color: ', ';\n      background: ', ';\n      border-radius: 0;\n      border: none;\n    ']),
	    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['\n  transition: all 0.15s linear;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 10px;\n  height: 40px;\n'], ['\n  transition: all 0.15s linear;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 10px;\n  height: 40px;\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _layout = __webpack_require__(9);
	
	var _text = __webpack_require__(21);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _icon = __webpack_require__(25);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledSelect = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Block)(_templateObject, function (props) {
	  return props.theme.input.inputDefaultBorder;
	}, function (props) {
	  return props.theme.input.inputBorderRadius;
	}, function (props) {
	  return props.theme.colors.white;
	}, function (props) {
	  return props.center ? 'center' : 'left';
	}, function (props) {
	  return props.theme.input.inputHoverBorder;
	}, function (props) {
	  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.grey500, props.theme.colors.grey200);
	}, function (props) {
	  return props.readonly && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3, props.theme.input.inputReadonlyBackground, props.theme.input.inputReadonlyBorder, props.theme.input.inputReadonlyColor, props.theme.input.inputReadonlyBorder);
	}, function (props) {
	  return props.disabled && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4, props.theme.input.inputDisabledBackground, props.theme.input.inputDisabledBorder, props.theme.input.inputDisabledColor, props.theme.input.inputDisabledBorder);
	});
	
	var StyledIconChevron = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject5, function (props) {
	  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject6);
	});
	
	var StyledIconClear = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject7, function (props) {
	  return props.theme.colors.grey300;
	}, function (props) {
	  return props.theme.layout.borderRadius;
	});
	
	var StyledSelectOptions = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject8, function (props) {
	  return props.theme.colors.white;
	}, function (props) {
	  return props.theme.colors.grey400;
	}, function (props) {
	  return props.open && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject9);
	});
	
	var StyledOption = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject10, function (props) {
	  return props.theme.colors.navy700;
	}, function (props) {
	  return props.theme.colors.grey300;
	}, function (props) {
	  return props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject11, props.theme.colors.navy700, props.theme.colors.grey300);
	});
	
	var StyledSelectSelected = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject12);
	/**
	 * The kalo generic select component
	 */
	
	var Select = function (_PureComponent) {
	  (0, _inherits3.default)(Select, _PureComponent);
	
	  function Select(props) {
	    (0, _classCallCheck3.default)(this, Select);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
	    _this.state = {
	      open: false
	    };
	
	    _this.onToggle = _this.onToggle.bind(_this);
	    _this.onSelect = _this.onSelect.bind(_this);
	    _this.onClose = _this.onClose.bind(_this);
	    _this.onClear = _this.onClear.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Select, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('click', this.onClose);
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return window.addEventListener('click', _this2.onClose);
	      }, 300);
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      window.removeEventListener('click', this.onClose);
	      this.setState({ open: false });
	      if (this.props.onBlur) this.props.onBlur();
	    }
	  }, {
	    key: 'onToggle',
	    value: function onToggle() {
	      if (this.props.readonly) return;
	      if (this.state.open) {
	        this.close();
	      } else {
	        this.open();
	      }
	    }
	  }, {
	    key: 'onClose',
	    value: function onClose() {
	      this.close();
	    }
	  }, {
	    key: 'onClear',
	    value: function onClear(event) {
	      this.props.onSelect(undefined);
	      this.close();
	      event.stopPropagation();
	    }
	  }, {
	    key: 'onSelect',
	    value: function onSelect(value) {
	      this.props.onSelect(value);
	      this.close();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          selection = _props.selection,
	          placeholder = _props.placeholder,
	          nullable = _props.nullable,
	          formatSelection = _props.formatSelection,
	          readonly = _props.readonly,
	          empty = _props.empty,
	          disabled = _props.disabled,
	          _IGNORED = _props.editable,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'selection', 'placeholder', 'nullable', 'formatSelection', 'readonly', 'empty', 'disabled', 'editable']);
	      var open = this.state.open;
	
	
	      return React.createElement(
	        StyledSelect,
	        (0, _extends3.default)({
	          readonly: readonly,
	          disabled: disabled,
	          open: open
	        }, otherProps),
	        React.createElement(
	          StyledSelectSelected,
	          {
	            onClick: readonly || disabled ? undefined : this.onToggle
	          },
	          !!selection ? React.createElement(
	            _text2.default,
	            {
	              color: readonly || disabled ? 'navy500' : 'navy700',
	              weight: 'normal'
	            },
	            formatSelection(selection)
	          ) : React.createElement(
	            _text2.default,
	            {
	              color: readonly || disabled ? 'navy500' : 'navy700',
	              weight: 'normal'
	            },
	            placeholder
	          ),
	          (!readonly || !disabled) && !!selection && nullable ? React.createElement(
	            StyledIconClear,
	            null,
	            React.createElement(
	              _icon2.default,
	              {
	                size: 18,
	                onClick: this.onClear,
	                color: readonly || disabled ? 'grey500' : 'navy700'
	              },
	              'clear'
	            )
	          ) : null,
	          (!readonly || !disabled) && (!selection || !nullable) ? React.createElement(
	            StyledIconChevron,
	            { open: open },
	            React.createElement(
	              _icon2.default,
	              {
	                color: readonly || disabled ? 'grey500' : 'navy700',
	                size: 24
	              },
	              'chevron_right'
	            )
	          ) : null
	        ),
	        React.createElement(
	          StyledSelectOptions,
	          {
	            open: open,
	            onClick: function onClick(event) {
	              return event.stopPropagation();
	            }
	          },
	          React.Children.map(children, function (child) {
	            return child ? React.createElement(
	              StyledOption,
	              {
	                key: child.key,
	                name: child.key,
	                selected: child.props.selected,
	                onClick: function onClick() {
	                  return _this3.onSelect(child.props.value);
	                }
	              },
	              child
	            ) : null;
	          }),
	          !React.Children.count(children) ? React.createElement(
	            _text2.default,
	            null,
	            empty
	          ) : null
	        )
	      );
	    }
	  }]);
	  return Select;
	}(_component2.default);
	
	Select.defaultProps = {
	  onSelect: function onSelect() {},
	  center: false,
	  placeholder: 'Select…',
	  empty: 'No items',
	  nullable: true,
	  formatSelection: function formatSelection(selection) {
	    return selection;
	  },
	  readonly: false,
	  disabled: false
	};
	exports.default = Select;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _skeleton = __webpack_require__(353);
	
	Object.keys(_skeleton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _skeleton[key];
	    }
	  });
	});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(38);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.SkeletonShape = SkeletonShape;
	exports.SkeletonText = SkeletonText;
	exports.SkeletonButton = SkeletonButton;
	exports.SkeletonAvatar = SkeletonAvatar;
	exports.SkeletonPaper = SkeletonPaper;
	exports.SkeletonCard = SkeletonCard;
	exports.SkeletonListItem = SkeletonListItem;
	exports.SkeletonGrid = SkeletonGrid;
	exports.SkeletonList = SkeletonList;
	exports.SkeletonPage = SkeletonPage;
	exports.SkeletonPageHeader = SkeletonPageHeader;
	exports.SkeletonPageHeaderHeading = SkeletonPageHeaderHeading;
	exports.SkeletonPageHeaderToolbar = SkeletonPageHeaderToolbar;
	exports.SkeletonPageHeaderTabs = SkeletonPageHeaderTabs;
	exports.SkeletonContent = SkeletonContent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layout = __webpack_require__(9);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _skeleton = __webpack_require__(475);
	
	var _skeleton2 = _interopRequireDefault(_skeleton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Multiplier for textual content "size" */
	var TEXT_SIZE_MULTIPLIER = 10;
	
	/** Multiplier for an avatar diameter */
	var AVATAR_SIZE_MULTIPLIER = 20;
	
	/** Height of text */
	var TEXT_HEIGHT = 12;
	
	/** Height of a button */
	var BUTTON_HEIGHT = 36;
	
	/** A box which can space it's children */
	function SpacerBox(_ref) {
	  var _ref$spacing = _ref.spacing,
	      spacing = _ref$spacing === undefined ? 25 : _ref$spacing,
	      _ref$vertical = _ref.vertical,
	      vertical = _ref$vertical === undefined ? false : _ref$vertical,
	      _ref$center = _ref.center,
	      center = _ref$center === undefined ? true : _ref$center,
	      childFlex = _ref.childFlex,
	      children = _ref.children,
	      styleProps = (0, _objectWithoutProperties3.default)(_ref, ['spacing', 'vertical', 'center', 'childFlex', 'children']);
	
	  var alignItems = center ? 'center' : 'stretch';
	  var style = vertical ? { alignItems: alignItems, marginTop: -spacing } : { flexDirection: 'row', alignItems: alignItems, marginLeft: -spacing };
	
	  return _react2.default.createElement(
	    _layout.Box,
	    (0, _extends3.default)({}, style, styleProps),
	    _react2.default.Children.map(children, function (child) {
	      return _react2.default.createElement(
	        _layout.Box,
	        {
	          marginTop: vertical ? spacing : 0,
	          marginLeft: !vertical ? spacing : 0,
	          flex: childFlex
	        },
	        child
	      );
	    })
	  );
	}
	
	/** Skeleton representation of any arbitrary rectangular or circular shape */
	function SkeletonShape(_ref2) {
	  var _cx;
	
	  var _ref2$shape = _ref2.shape,
	      shape = _ref2$shape === undefined ? 'rect' : _ref2$shape,
	      styleProps = (0, _objectWithoutProperties3.default)(_ref2, ['shape']);
	
	  return _react2.default.createElement(_layout.Box, (0, _extends3.default)({
	    className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _skeleton2.default.circle, shape === 'circle'), (0, _defineProperty3.default)(_cx, _skeleton2.default.shape, true), _cx))
	  }, styleProps));
	}
	
	/**
	 * Skeleton representation of text content
	 * TODO: Allow multiline (with appropriate line spacing)
	 */
	function SkeletonText(_ref3) {
	  var _ref3$size = _ref3.size,
	      size = _ref3$size === undefined ? 7 : _ref3$size,
	      _ref3$heading = _ref3.heading,
	      heading = _ref3$heading === undefined ? false : _ref3$heading;
	
	  var width = size * TEXT_SIZE_MULTIPLIER;
	  var height = heading ? TEXT_HEIGHT * 2 : TEXT_HEIGHT;
	  return _react2.default.createElement(SkeletonShape, { height: height, width: width });
	}
	
	/** Skeleton representation of a button */
	function SkeletonButton(_ref4) {
	  var _ref4$size = _ref4.size,
	      size = _ref4$size === undefined ? 7 : _ref4$size,
	      square = _ref4.square;
	
	  var width = square ? BUTTON_HEIGHT : size * TEXT_SIZE_MULTIPLIER;
	  return _react2.default.createElement(SkeletonShape, { height: BUTTON_HEIGHT, width: width });
	}
	
	/** Skeleton representation of an avatar */
	function SkeletonAvatar(_ref5) {
	  var _ref5$size = _ref5.size,
	      size = _ref5$size === undefined ? 4 : _ref5$size;
	
	  var width = size * AVATAR_SIZE_MULTIPLIER;
	  return _react2.default.createElement(SkeletonShape, { shape: 'circle', height: width, width: width });
	}
	
	/** Skeleton representation of paper container */
	function SkeletonPaper(_ref6) {
	  var children = _ref6.children,
	      style = _ref6.style;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    { className: _skeleton2.default.paper, padding: 15, style: style },
	    children
	  );
	}
	
	/** Skeleton representation of an avatar */
	function SkeletonCard(_ref7) {
	  var children = _ref7.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    { className: _skeleton2.default.paper, paddingTop: 75, paddingBottom: 150 },
	    _react2.default.createElement(
	      SpacerBox,
	      { vertical: true },
	      children ? children : [_react2.default.createElement(SkeletonAvatar, { key: 'avatar' }), _react2.default.createElement(SkeletonText, { key: 'text' }), _react2.default.createElement(SkeletonText, { key: 'text-2', size: 14 })]
	    )
	  );
	}
	
	/** Skeleton representation of an avatar */
	function SkeletonListItem(_ref8) {
	  var children = _ref8.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    {
	      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.paper, true)),
	      padding: 25
	    },
	    _react2.default.createElement(
	      SpacerBox,
	      null,
	      children ? children : [_react2.default.createElement(SkeletonText, { size: 14, key: 0 }), _react2.default.createElement(SkeletonText, { key: 1 })]
	    )
	  );
	}
	
	/** Single row horizontal grid skeleton component */
	function SkeletonGrid(_ref9) {
	  var children = _ref9.children,
	      center = _ref9.center;
	
	  return _react2.default.createElement(
	    SpacerBox,
	    { childFlex: 1, center: center },
	    children
	  );
	}
	
	/** Vertical list layout skeleton component */
	function SkeletonList(_ref10) {
	  var children = _ref10.children,
	      center = _ref10.center;
	
	  return _react2.default.createElement(
	    SpacerBox,
	    {
	      vertical: true,
	      spacing: 10,
	      alignItems: 'stretch',
	      center: center
	    },
	    children
	  );
	}
	
	/** Skeleton page */
	function SkeletonPage(_ref11) {
	  var children = _ref11.children,
	      _ref11$width = _ref11.width,
	      width = _ref11$width === undefined ? 1180 : _ref11$width;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    null,
	    _react2.default.createElement(
	      _layout.Box,
	      { margin: [50, 'auto'], width: width },
	      children
	    )
	  );
	}
	
	/** Skeleton page header */
	function SkeletonPageHeader(_ref12) {
	  var children = _ref12.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    {
	      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.header, true))
	    },
	    children
	  );
	}
	
	/** Skeleton page header heading */
	function SkeletonPageHeaderHeading(_ref13) {
	  var _ref13$width = _ref13.width,
	      width = _ref13$width === undefined ? 1180 : _ref13$width,
	      children = _ref13.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    {
	      margin: [0, 'auto'],
	      width: width,
	      height: 80,
	      justifyContent: 'space-between',
	      flexDirection: 'row',
	      alignItems: 'center'
	    },
	    children
	  );
	}
	
	/** Skeleton page header heading */
	function SkeletonPageHeaderToolbar(_ref14) {
	  var _ref14$width = _ref14.width,
	      width = _ref14$width === undefined ? 1180 : _ref14$width,
	      children = _ref14.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    {
	      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.toolbar, true))
	    },
	    _react2.default.createElement(
	      _layout.Box,
	      { margin: [0, 'auto'], width: width },
	      _react2.default.createElement(
	        SpacerBox,
	        { height: 46 },
	        children
	      )
	    )
	  );
	}
	
	/** Skeleton page header heading */
	function SkeletonPageHeaderTabs(_ref15) {
	  var _ref15$width = _ref15.width,
	      width = _ref15$width === undefined ? 1180 : _ref15$width,
	      children = _ref15.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    { margin: [0, 'auto'], width: width },
	    _react2.default.createElement(
	      SpacerBox,
	      { height: 46 },
	      children
	    )
	  );
	}
	
	/** Generic content */
	function SkeletonContent(_ref16) {
	  var children = _ref16.children;
	
	  return _react2.default.createElement(
	    _layout.Box,
	    { padding: 15 },
	    children
	  );
	}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _omit2 = __webpack_require__(266);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(48);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dom = __webpack_require__(198);
	
	var _sticky = __webpack_require__(476);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function anchorTop(_ref, child) {
	  var x = _ref.x,
	      y = _ref.y,
	      offset = _ref.offset;
	
	  return {
	    x: x + offset.x,
	    y: y - child.height + offset.y
	  };
	}
	
	function anchorRight(_ref2) {
	  var x = _ref2.x,
	      y = _ref2.y,
	      width = _ref2.width,
	      offset = _ref2.offset;
	
	  return {
	    x: x + width + offset.x,
	    y: y + offset.y
	  };
	}
	
	function anchorBottom(_ref3) {
	  var x = _ref3.x,
	      y = _ref3.y,
	      height = _ref3.height,
	      offset = _ref3.offset;
	
	  return {
	    x: x + offset.x,
	    y: y + height + offset.y
	  };
	}
	
	function anchorBottomCenter(_ref4, child) {
	  var x = _ref4.x,
	      y = _ref4.y,
	      height = _ref4.height,
	      width = _ref4.width,
	      offset = _ref4.offset;
	
	  return {
	    x: x + offset.x + width / 2 - child.width / 2,
	    y: y + height + offset.y
	  };
	}
	
	function anchorLeft(_ref5, child) {
	  var x = _ref5.x,
	      y = _ref5.y,
	      offset = _ref5.offset;
	
	  return {
	    x: x - child.width + offset.x,
	    y: y + offset.y
	  };
	}
	
	function anchorNone(_ref6) {
	  var x = _ref6.x,
	      y = _ref6.y,
	      offset = _ref6.offset;
	
	  return {
	    x: x + offset.x,
	    y: y + offset.y
	  };
	}
	
	/** map of prop friendly names to anchor functions */
	var anchors = {
	  top: anchorTop,
	  right: anchorRight,
	  bottom: anchorBottom,
	  'bottom center': anchorBottomCenter,
	  left: anchorLeft,
	  none: anchorNone
	};
	
	/**
	 * Determine if a specific axis should be fixed or not
	 * @param {object|boolean|undefined} fixed See Sticky component `fixed` prop
	 * @param {string} axis x/y
	 * @returns {boolean}
	 */
	function isFixed(fixed, axis) {
	  if (fixed === true) {
	    return true;
	  }
	
	  if (!fixed) {
	    return false;
	  }
	
	  return !!fixed[axis];
	}
	
	/**
	 * The Sticky component positions its children absolutely against
	 * the border of the parent element. You can configure which
	 * border (top, left, bottom, right) to stick to as well as a
	 * margin.
	 *
	 * @class  {component} Sticky
	 * @exports Sticky
	 * @extends {React.Component}
	 */
	
	var Sticky = function (_React$Component) {
	  (0, _inherits3.default)(Sticky, _React$Component);
	
	  function Sticky() {
	    (0, _classCallCheck3.default)(this, Sticky);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this));
	
	    _this.updatePosition = _this.updatePosition.bind(_this);
	    return _this;
	  }
	
	  /**
	    When the component has mounted and we have a reference to our root element
	    We can create a new 'wormhole' element to mount into.
	   */
	
	
	  (0, _createClass3.default)(Sticky, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.el = document.createElement('div');
	      this.el.style.position = 'absolute';
	      this.el.style.transition = this.props.transition ? this.props.transition : '';
	      document.body.appendChild(this.el);
	      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this.el, function () {
	        return _this2.updatePosition();
	      });
	      window.addEventListener('resize', this.updatePosition);
	      window.addEventListener('lys:z-scroll', this.updatePosition);
	    }
	
	    /**
	      When the component updates we need to also re-render into our wormhole
	      as well as update its absolute position.
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this3 = this;
	
	      // only update if we aren’t forcing this sticky to be static
	      if (!this.props.static) {
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this.el, function () {
	          return _this3.updatePosition();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // TODO - keep an eye on this react issue
	      // https://github.com/facebook/react/issues/2410
	      if (!this.el) return;
	
	      _reactDom2.default.unmountComponentAtNode(this.el);
	      document.body.removeChild(this.el);
	      window.removeEventListener('resize', this.updatePosition);
	      window.removeEventListener('lys:z-scroll', this.updatePosition);
	    }
	
	    /*
	      We update the position of our 'wormhole' mount based around the current
	      fixed offset position of the parent and the current dimensions of our
	      child.
	     */
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _props = this.props,
	          anchor = _props.anchor,
	          offset = _props.offset,
	          width = _props.width,
	          safeZone = _props.safeZone,
	          zIndex = _props.zIndex,
	          fixed = _props.fixed,
	          noPointerEvents = _props.noPointerEvents;
	      var root = this.refs.root;
	
	      var parent = _reactDom2.default.findDOMNode(root).parentNode;
	      if (!parent) return;
	      var position = (0, _dom.getFixedOffset)(parent);
	      var child = this.el.children[0];
	
	      var anchoredPosition = anchors[anchor]({
	        x: position.left,
	        y: position.top,
	        height: parent.clientHeight,
	        width: parent.clientWidth,
	        offset: offset
	      }, {
	        height: child.clientHeight,
	        width: child.clientWidth
	      });
	
	      // Fit into window
	      var windowTop = window.scrollY + safeZone.y;
	      var windowRight = window.scrollX + window.innerWidth - safeZone.x;
	      var windowBottom = window.scrollY + window.innerHeight - safeZone.y;
	      var windowLeft = window.scrollX + safeZone.x;
	      var childRight = anchoredPosition.x + child.clientWidth;
	      var childbottom = anchoredPosition.y + child.clientHeight;
	
	      // TODO: All these anchor/offset/contain calculations could be nicely abstracted into some math/layout utils
	      if (!isFixed(fixed, 'x') && childRight > windowRight) {
	        anchoredPosition.x -= childRight - windowRight;
	      }
	
	      if (!isFixed(fixed, 'y') && childbottom > windowBottom) {
	        anchoredPosition.y -= childbottom - windowBottom;
	      }
	
	      // top left is favoured (ie. we don’t adjust size of sticky just ensure top left is in view)
	      if (!isFixed(fixed, 'x')) {
	        anchoredPosition.x = Math.max(windowLeft, anchoredPosition.x);
	      }
	      if (!isFixed(fixed, 'y')) {
	        anchoredPosition.y = Math.max(windowTop, anchoredPosition.y);
	      }
	
	      this.el.style.zIndex = zIndex;
	      this.el.style.left = anchoredPosition.x + 'px';
	      this.el.style.top = anchoredPosition.y + 'px';
	      if (width) {
	        this.el.style.width = parent.clientWidth / 100 * width + 'px';
	      }
	      if (noPointerEvents) {
	        this.el.style.pointerEvents = 'none';
	      }
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _props2 = this.props,
	          children = _props2.children,
	          _IGNORED = _props2.offset,
	          __IGNORED = _props2.anchor,
	          ___IGNORED = _props2.zIndex,
	          ____IGNORED = _props2.safeZone,
	          _____IGNORED = _props2.transition,
	          _______IGNORED = _props2.fixed,
	          ________IGNORED = _props2.static,
	          noPointerEvents = _props2.noPointerEvents,
	          otherProps = (0, _objectWithoutProperties3.default)(_props2, ['children', 'offset', 'anchor', 'zIndex', 'safeZone', 'transition', 'fixed', 'static', 'noPointerEvents']);
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          className: noPointerEvents ? _sticky2.default.transparent : null
	        }, (0, _omit3.default)(otherProps, ['offset'])),
	        children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { className: _sticky2.default.root, ref: 'root' });
	    }
	  }]);
	  return Sticky;
	}(_react2.default.Component);
	
	Sticky.propTypes = {
	  children: _propTypes2.default.any,
	  anchor: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'bottom center', 'right', 'none']),
	  transition: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  safeZone: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  zIndex: _propTypes2.default.number,
	  fixed: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  static: _propTypes2.default.bool,
	  noPointerEvents: _propTypes2.default.bool
	};
	Sticky.defaultProps = {
	  anchor: 'right',
	  width: null,
	  offset: { x: 0, y: 0 },
	  safeZone: { x: 30, y: 30 },
	  transition: '',
	  zIndex: 0,
	  fixed: { x: false, y: true },
	  static: false,
	  noPointerEvents: false
	};
	exports.default = Sticky;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-family: \'WebFaktSoftPro\', sans-serif;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: ', ';\n  text-align: ', ';\n  text-decoration: ', ';\n  font-weight: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n\n  ', ';\n\n  strong {\n    font-weight: ', ';\n  }\n'], ['\n  font-family: \'WebFaktSoftPro\', sans-serif;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  cursor: ', ';\n  text-align: ', ';\n  text-decoration: ', ';\n  font-weight: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  &:hover {\n    color: ', ';\n    text-decoration: ', ';\n  }\n\n  ', ';\n\n  strong {\n    font-weight: ', ';\n  }\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      white-space: normal;\n      text-overflow: initial;\n      overflow: visible;\n      white-space: pre-wrap;\n      word-break: break-word;\n    '], ['\n      white-space: normal;\n      text-overflow: initial;\n      overflow: visible;\n      white-space: pre-wrap;\n      word-break: break-word;\n    ']);
	
	exports.default = Text;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _layout = __webpack_require__(9);
	
	var _theme = __webpack_require__(116);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _constants = __webpack_require__(197);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledText = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Inline)(_templateObject, function (props) {
	  return props.interactive ? 'pointer' : props.notInteractive ? 'default' : 'inherit';
	}, function (props) {
	  return props.align;
	}, function (props) {
	  return props.noUnderline ? 'none' : 'inherit';
	}, function (props) {
	  return _constants.WEIGHT_MAP[props.weight];
	}, function (props) {
	  return _constants.SIZE_MAP[props.size];
	}, function (props) {
	  return props.theme.colors[props.color];
	}, function (props) {
	  return props.theme.colors[props.hoverColor];
	}, function (props) {
	  return props.onClick ? props.noUnderline ? 'none' : 'underline' : 'inherit';
	}, function (props) {
	  return props.multiline && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2);
	}, function (props) {
	  return props.theme.typography.fontWeightMedium;
	});
	
	function Text(props) {
	  var _props$weight = props.weight,
	      weight = _props$weight === undefined ? 'normal' : _props$weight,
	      _props$size = props.size,
	      size = _props$size === undefined ? 'small' : _props$size,
	      _props$align = props.align,
	      align = _props$align === undefined ? 'unset' : _props$align,
	      _props$color = props.color,
	      color = _props$color === undefined ? 'navy600' : _props$color,
	      _props$hoverColor = props.hoverColor,
	      hoverColor = _props$hoverColor === undefined ? 'none' : _props$hoverColor,
	      interactive = props.interactive,
	      noUnderline = props.noUnderline,
	      onClick = props.onClick,
	      children = props.children,
	      _props$theme = props.theme,
	      theme = _props$theme === undefined ? _theme2.default : _props$theme,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['weight', 'size', 'align', 'color', 'hoverColor', 'interactive', 'noUnderline', 'onClick', 'children', 'theme']);
	
	
	  return React.createElement(
	    StyledText,
	    (0, _extends3.default)({
	      onClick: onClick,
	      weight: weight,
	      color: color,
	      hoverColor: hoverColor,
	      align: align,
	      interactive: interactive || onClick,
	      noUnderline: noUnderline,
	      size: size,
	      theme: theme
	    }, otherProps),
	    children
	  );
	}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _textarea = __webpack_require__(357);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_textarea).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(22);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _omit2 = __webpack_require__(266);
	
	var _omit3 = _interopRequireDefault(_omit2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: transparent;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.6em;\n  padding: 8px 16px;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:readonly {\n    background-color: ', ';\n    border: ', ';\n    cursor: default;\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  background: transparent;\n  width: 100%;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.6em;\n  padding: 8px 16px;\n  color: ', ';\n\n  &::placeholder {\n    color: ', ';\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    background-color: ', ';\n    border: ', ';\n    cursor: not-allowed;\n    color: ', ';\n  }\n\n  &:readonly {\n    background-color: ', ';\n    border: ', ';\n    cursor: default;\n    color: ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n      border: ', ';\n      border-radius: ', ';\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n    '], ['\n      background-color: ', ';\n      border: ', ';\n      border-radius: ', ';\n\n      &:not(:read-only):not(:disabled):hover {\n        border: ', ';\n      }\n\n      &:not(:read-only):not(:disabled):focus {\n        border: ', ';\n      }\n    ']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: transparent;\n      border: 0;\n    '], ['\n      background-color: transparent;\n      border: 0;\n    ']),
	    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['transition: height 0.2s ease-in-out;'], ['transition: height 0.2s ease-in-out;']),
	    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n      overflow: hidden;\n      resize: none;\n    '], ['\n      overflow: hidden;\n      resize: none;\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(48);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _component = __webpack_require__(35);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(198);
	
	var _style = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Escape any html markup from user input values to ensure correct
	 * text measurement
	 */
	
	var escapeTags = function escapeTags(str) {
	  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br />');
	};
	
	var StyledTextarea = /*#__PURE__*/(0, _reactEmotion2.default)('textarea')(_templateObject, function (props) {
	  return props.theme.colors.navy700;
	}, function (props) {
	  return props.theme.colors.grey500;
	}, function (props) {
	  return props.theme.input.inputDisabledBackground;
	}, function (props) {
	  return props.theme.input.inputDisabledBorder;
	}, function (props) {
	  return props.theme.input.inputDisabledColor;
	}, function (props) {
	  return props.theme.input.inputReadonlyBackground;
	}, function (props) {
	  return props.theme.input.inputReadonlyBorder;
	}, function (props) {
	  return props.theme.input.inputReadonlyColor;
	}, function (props) {
	  return props.textareaTheme === 'default' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.white, props.theme.input.inputDefaultBorder, props.theme.input.inputBorderRadius, props.theme.input.inputHoverBorder, props.theme.input.inputActiveBorder);
	}, function (props) {
	  return props.textareaTheme === 'transparent' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject3);
	}, function (props) {
	  return props.animate && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject4);
	}, function (props) {
	  return props.expand && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject5);
	});
	
	/**
	 * Render a textarea which can expand vertically
	 * - The "autogrow/expand" logic looks horrible but, hey, there’s no better way
	 *   in the web to get precise text measurements with linebreaking etc.
	 *   - It works by mirroring styles into a dummy div and calculating the height from
	 *     the mirror
	 *   Current known drawbacks:
	 *   - .setup() only gets called once so if styles are updater later the mirror might be
	 *     out of sync
	 */
	
	var Textarea = function (_PureComponent) {
	  (0, _inherits3.default)(Textarea, _PureComponent);
	
	  function Textarea(props) {
	    (0, _classCallCheck3.default)(this, Textarea);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.onKeyUp = _this.onKeyUp.bind(_this);
	    _this.onScroll = _this.onScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Textarea, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setup();
	      this.update();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _dom.removeNode)(this.mirror);
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      if (!!this.props.onReturn && event.which === 13 && event.shiftKey === false) {
	        event.preventDefault();
	        this.props.onReturn(event);
	      }
	    }
	
	    /**
	     * Key up is hooked to watch for content changes
	     * @param {Event} event
	     */
	
	  }, {
	    key: 'onKeyUp',
	    value: function onKeyUp(event) {
	      this.update();
	
	      if (this.props.onKeyUp) {
	        this.props.onKeyUp(event);
	      }
	    }
	
	    /**
	     * Hook into scroll event to prevent jumping while height is updated
	     * to fit content
	     * @param {Event} event
	     */
	
	  }, {
	    key: 'onScroll',
	    value: function onScroll(event) {
	      if (this.props.expand) {
	        event.preventDefault();
	        var el = _reactDom2.default.findDOMNode(this);
	        // $FlowFixMe
	        if (el) el.scrollTop = 0;
	      }
	    }
	
	    /**
	     * Update will calculate heights using input contents taking into account
	     * the min number of rows provided via props
	     */
	
	  }, {
	    key: 'update',
	    value: function update() {
	      if (this.props.expand) {
	        var textarea = _reactDom2.default.findDOMNode(this);
	        // $FlowFixMe
	        var value = textarea ? textarea.value : null;
	
	        // If the value hasn’t changed we don’t need to do anything
	        if (this.__lastUpdatedValue__ === value) {
	          return false;
	        }
	
	        var mirror = this.mirror;
	        var html = '';
	
	        mirror.style.display = 'block';
	
	        for (var i = 0; i < this.props.minRows; i++) {
	          html += '<br/>';
	        }
	
	        mirror.innerHTML = html;
	        var minMirrorHeight = mirror.clientHeight;
	
	        html = escapeTags(String(value));
	
	        for (var _i = 0; _i < this.props.lineBuffer; _i++) {
	          html += '<br/>';
	        }
	        mirror.innerHTML = html; // Ensure we are always a line ahead for smoother expanding
	
	        var mirrorHeight = Math.max(minMirrorHeight, mirror.clientHeight);
	
	        mirror.style.display = 'none';
	
	        if (!this.state || this.state.height !== mirrorHeight) {
	          this.setState({ height: mirrorHeight });
	        }
	
	        this.__lastUpdatedValue__ = value;
	      }
	      return true;
	    }
	
	    /**
	     * Setup will configure the dummy "mirror element" to match the input
	     * styles as best as possible
	     */
	
	  }, {
	    key: 'setup',
	    value: function setup() {
	      if (this.props.expand) {
	        // Create a new mirror if we do not have one
	        if (!this.mirror) {
	          this.mirror = document.createElement('div');
	          // $FlowFixMe
	          document.body.appendChild(this.mirror);
	        }
	
	        var textarea = _reactDom2.default.findDOMNode(this);
	        var mirror = this.mirror;
	        var style = window.getComputedStyle(textarea);
	
	        mirror.style.display = 'none';
	        mirror.style.wordWrap = 'break-word';
	        mirror.style.whiteSpace = 'normal';
	        mirror.style.paddingTop = style.getPropertyValue('padding-top');
	        mirror.style.paddingBottom = style.getPropertyValue('padding-bottom');
	        mirror.style.paddingLeft = style.getPropertyValue('padding-left');
	        mirror.style.paddingRight = style.getPropertyValue('padding-right');
	        mirror.style.width = style.getPropertyValue('width');
	        mirror.style.fontFamily = style.getPropertyValue('font-family');
	        mirror.style.fontWeight = style.getPropertyValue('font-weight');
	        mirror.style.fontSize = style.getPropertyValue('font-size');
	        mirror.style.lineHeight = style.getPropertyValue('line-height');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref = this.state || {},
	          _ref$height = _ref.height,
	          height = _ref$height === undefined ? undefined : _ref$height;
	
	      var _props = this.props,
	          animate = _props.animate,
	          style = _props.style,
	          className = _props.className,
	          theme = _props.theme,
	          readonly = _props.readonly,
	          disabled = _props.disabled,
	          onChange = _props.onChange,
	          expand = _props.expand,
	          otherProps = (0, _objectWithoutProperties3.default)(_props, ['animate', 'style', 'className', 'theme', 'readonly', 'disabled', 'onChange', 'expand']);
	
	
	      var filteredProps = (0, _extends3.default)({}, (0, _omit3.default)(otherProps, ['editable', 'lineBuffer', 'minRows', 'onReturn']));
	
	      var styleProps = (0, _style.parseStyleProps)(filteredProps);
	
	      return _react2.default.createElement(StyledTextarea, (0, _extends3.default)({
	        animate: animate,
	        expand: expand,
	        textareaTheme: theme,
	        onChange: !readonly && onChange,
	        className: className,
	        disabled: disabled,
	        readOnly: readonly,
	        onKeyUp: this.onKeyUp,
	        onKeyDown: this.onKeyDown,
	        style: (0, _extends3.default)({
	          height: height
	        }, styleProps.style, style),
	        onScroll: this.onScroll
	      }, styleProps.props, filteredProps));
	    }
	  }]);
	  return Textarea;
	}(_component2.default);
	
	Textarea.defaultProps = {
	  minRows: 2,
	  lineBuffer: 2,
	  animate: true,
	  theme: 'default',
	  onReturn: null
	};
	exports.default = Textarea;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _tokensTheme = __webpack_require__(361);
	
	var _tokensTheme2 = _interopRequireDefault(_tokensTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * ThemeProvider Kalo Theme
	 * 
	 * This is the core CSS-in-JS theme that is passed in to the
	 * global ThemeProvider. It is mainly composed of our core
	 * design tokens.
	 */
	
	var theme = (0, _extends3.default)({
	  space: [0, 8, 16, 32, 64],
	  breakpoints: []
	}, _tokensTheme2.default);
	
	exports.default = theme;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toggleButton = __webpack_require__(360);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toggleButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _taggedTemplateLiteral2 = __webpack_require__(26);
	
	var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
	
	var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: 20px;\n  transition: all 0.25s ease-out;\n  width: 56px;\n  height: 26px;\n  cursor: pointer;\n  padding: 3px 0 3px ', ';\n  background-color: transparent;\n  border: 2px solid ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  border-radius: 20px;\n  transition: all 0.25s ease-out;\n  width: 56px;\n  height: 26px;\n  cursor: pointer;\n  padding: 3px 0 3px ', ';\n  background-color: transparent;\n  border: 2px solid ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
	    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: ', ';\n    '], ['\n      background-color: ', ';\n    ']),
	    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background-color: ', ';\n'], ['\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background-color: ', ';\n']);
	
	exports.default = ToggleButton;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _layout = __webpack_require__(9);
	
	var _fieldLabel = __webpack_require__(82);
	
	var _fieldLabel2 = _interopRequireDefault(_fieldLabel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * ToggleButton
	 *
	 * A standard toggle button for toggling between two states
	 */
	
	var StyledToggleButton = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject, function (props) {
	  return props.selected ? '32px' : '3px';
	}, function (props) {
	  return props.theme.colors.grey300;
	}, function (props) {
	  return props.toggleButtonTheme === 'default' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.blue500);
	}, function (props) {
	  return props.toggleButtonTheme === 'green' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.green500);
	}, function (props) {
	  return props.toggleButtonTheme === 'orangeToGreen' && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.selected ? props.theme.colors.green500 : props.theme.colors.orange500);
	}, function (props) {
	  return props.toggleButtonTheme === 'orange' && props.selected && /*#__PURE__*/(0, _reactEmotion.css)(_templateObject2, props.theme.colors.orange500);
	});
	
	var StyledButton = /*#__PURE__*/(0, _reactEmotion2.default)('div')(_templateObject3, function (props) {
	  return props.toggleButtonTheme === 'orangeToGreen' ? props.theme.colors.white : props.selected ? props.theme.colors.white : props.theme.colors.grey500;
	});
	
	function ToggleButton(props) {
	  var _props$value = props.value,
	      value = _props$value === undefined ? false : _props$value,
	      _props$theme = props.theme,
	      theme = _props$theme === undefined ? 'default' : _props$theme,
	      onChange = props.onChange,
	      label = props.label,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ['value', 'theme', 'onChange', 'label']);
	
	
	  return React.createElement(
	    _layout.Box,
	    (0, _extends3.default)({
	      flexDirection: 'row',
	      alignItems: 'center',
	      id: 'toggle-button',
	      onClick: function onClick() {
	        return onChange(!value);
	      }
	    }, otherProps),
	    React.createElement(
	      StyledToggleButton,
	      { selected: value, toggleButtonTheme: theme },
	      React.createElement(StyledButton, { toggleButtonTheme: theme, selected: value })
	    ),
	    label ? React.createElement(
	      _fieldLabel2.default,
	      { marginLeft: 'medium', marginBottom: 0 },
	      label
	    ) : null
	  );
	}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports = {"colors":{"navy600":"rgb(84, 103, 137)","pink600":"rgb(224, 88, 103)","navy700":"rgb(55, 69, 97)","pink700":"rgb(195, 74, 87)","snow":"rgb(249, 250, 252)","green":"rgb(62, 179, 138)","orange300":"rgb(255, 237, 180)","orange400":"rgb(255, 206, 94)","orange500":"rgb(253, 184, 28)","orange600":"rgb(246, 175, 13)","white":"rgb(255, 255, 255)","orange700":"rgb(216, 145, 24)","platinum":"rgb(238, 244, 250)","charcoal":"rgb(55, 69, 97)","silver":"rgb(176, 186, 195)","orange":"rgb(253, 184, 28)","green300":"rgb(216, 240, 232)","red":"rgb(234, 95, 110)","green400":"rgb(79, 210, 164)","green500":"rgb(62, 179, 138)","grey200":"rgb(249, 250, 252)","green600":"rgb(56, 160, 124)","grey300":"rgb(238, 244, 250)","green700":"rgb(41, 134, 101)","grey400":"rgb(208, 216, 223)","pink":"rgb(234, 95, 110)","grey500":"rgb(176, 186, 195)","navy":"rgb(147, 166, 193)","purple300":"rgb(232, 226, 242)","grey600":"rgb(137, 146, 155)","grey700":"rgb(112, 125, 138)","none":"","purple400":"rgb(159, 129, 218)","slate":"rgb(84, 103, 137)","blue300":"rgb(193, 244, 255)","purple500":"rgb(138, 112, 189)","blue":"rgb(84, 195, 219)","blue400":"rgb(101, 210, 234)","purple600":"rgb(119, 95, 168)","inherit":"inherit","blue500":"rgb(84, 195, 219)","purple700":"rgb(96, 78, 131)","blue600":"rgb(77, 184, 207)","purple":"rgb(138, 112, 189)","pink300":"rgb(251, 223, 226)","currentColor":"currentColor","blue700":"rgb(43, 167, 194)","navy300":"rgb(249, 250, 252)","navy400":"rgb(198, 199, 216)","pink400":"rgb(253, 179, 200)","navy500":"rgb(147, 166, 193)","grey":"rgb(137, 146, 155)","pink500":"rgb(234, 95, 110)","black":"rgb(0, 0, 0)"},"typography":{"fontSizeHeadingLarge":"32px","fontSizeHeadingMedium":"24px","fontSizeHeadingSmall":"16px","fontSizeHeadingXSmall":"12px","fontSizeTextLarge":"18px","fontSizeTextMedium":"16px","fontSizeTextSmall":"14px","fontSizeTextXSmall":"12px","fontWeightLight":"300","fontWeightNormal":"400","fontWeightMedium":"500","fontWeightSemibold":"600"},"layout":{"borderRadius":"4px","borderRadiusInput":"4px","borderRadiusButton":"4px"},"input":{"inputHoverBorder":"1px solid #B0BAC3","inputBorderRadius":"4px","inputActiveBorder":"1px solid #54C3DB","inputReadonlyBorder":"1px dashed #D0D8DF","inputDisabledColor":"#546789","inputReadonlyBackground":"#F9FAFC","inputDisabledBorder":"1px solid #D0D8DF","inputReadonlyColor":"#546789","inputDisabledBackground":"#F9FAFC","inputDefaultBorder":"1px solid #D0D8DF"},"alerts":{"info":"rgb(232, 250, 252)","confirmation":"rgb(229, 247, 241)","error":"rgb(255, 235, 238)","warning":"rgb(255, 246, 216)"}}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/** Checks if a value is an array, if not, returns the value wrapped in one */
	var returnArray = exports.returnArray = function returnArray(value) {
	  return Array.isArray(value) ? value : [value];
	};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusOnMount = focusOnMount;
	exports.selectOnMount = selectOnMount;
	
	var _reactDom = __webpack_require__(48);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Focus a ref’d react input when it is mounted
	 * @param ref
	 */
	function focusOnMount(ref) {
	  var el = _reactDom2.default.findDOMNode(ref);
	
	  if (el) {
	    // Give focus and put the cursor at the end of
	    // the value.
	    el.focus();
	    el.value = el.value;
	  }
	}
	
	/**
	 * Select the text of a ref’d react input when it is mounted
	 * @param ref
	 */
	function selectOnMount(ref) {
	  if (ref && ref.select) {
	    ref.select();
	  }
	}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 *  
	 * 
	 * Lookup to determine what props we allow through to the DOM
	 * - Taken from react-emotion/src/props.js
	 */
	var props = {
	  // react props
	  // https://github.com/facebook/react/blob/5495a7f24aef85ba6937truetrue1ce962673ca9f5fde6/src/renderers/dom/shared/hooks/ReactDOMUnknownPropertyHook.js
	  children: true,
	  dangerouslySetInnerHTML: true,
	  key: true,
	  ref: true,
	  autoFocus: true,
	  defaultValue: true,
	  defaultChecked: true,
	  innerHTML: true,
	  suppressContentEditableWarning: true,
	
	  // https://github.com/facebook/react/blob/d7157651f7b72d9888ctrue123e191f9b88cd8f41e9/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
	  /**
	   * Standard Properties
	   */
	
	  accept: true,
	  acceptCharset: true,
	  accessKey: true,
	  action: true,
	  allowFullScreen: true,
	  allowTransparency: true,
	  alt: true,
	  // specifies target context for links with `preload` type
	  // as: true,
	  async: true,
	  autoComplete: true,
	  // autoFocus is polyfilled/normalized by AutoFocusUtils
	  // autoFocus: true,
	  autoPlay: true,
	  capture: true,
	  cellPadding: true,
	  cellSpacing: true,
	  charSet: true,
	  // challenge: true,
	  checked: true,
	  cite: true,
	  classID: true,
	  className: true,
	  cols: true,
	  colSpan: true,
	  content: true,
	  contentEditable: true,
	  contextMenu: true,
	  controls: true,
	  controlsList: true,
	  coords: true,
	  crossOrigin: true,
	  data: true, // For `<object />` acts as `src`.
	  dateTime: true,
	  default: true,
	  defer: true,
	  dir: true,
	  disabled: true,
	  download: true,
	  draggable: true,
	  encType: true,
	  form: true,
	  formAction: true,
	  formEncType: true,
	  formMethod: true,
	  formNoValidate: true,
	  formTarget: true,
	  frameBorder: true,
	  headers: true,
	  height: true,
	  hidden: true,
	  high: true,
	  href: true,
	  hrefLang: true,
	  htmlFor: true,
	  httpEquiv: true,
	  id: true,
	  inputMode: true,
	  integrity: true,
	  is: true,
	  keyParams: true,
	  keyType: true,
	  kind: true,
	  label: true,
	  lang: true,
	  list: true,
	  loop: true,
	  low: true,
	  // manifest: true,
	  marginHeight: true,
	  marginWidth: true,
	  max: true,
	  maxLength: true,
	  media: true,
	  mediaGroup: true,
	  method: true,
	  min: true,
	  minLength: true,
	  // Caution; `option.selected` is not updated if `select.multiple` is
	  // disabled with `removeAttribute`.
	  multiple: true,
	  muted: true,
	  name: true,
	  nonce: true,
	  noValidate: true,
	  open: true,
	  optimum: true,
	  pattern: true,
	  placeholder: true,
	  playsInline: true,
	  poster: true,
	  preload: true,
	  profile: true,
	  radioGroup: true,
	  readOnly: true,
	  referrerPolicy: true,
	  rel: true,
	  required: true,
	  reversed: true,
	  role: true,
	  rows: true,
	  rowSpan: true,
	  sandbox: true,
	  scope: true,
	  scoped: true,
	  scrolling: true,
	  seamless: true,
	  selected: true,
	  shape: true,
	  size: true,
	  sizes: true,
	  // support for projecting regular DOM Elements via V1 named slots ( shadow dom )
	  slot: true,
	  span: true,
	  spellCheck: true,
	  src: true,
	  srcDoc: true,
	  srcLang: true,
	  srcSet: true,
	  start: true,
	  step: true,
	  style: true,
	  summary: true,
	  tabIndex: true,
	  target: true,
	  title: true,
	  // Setting .type throws on non-<input> tags
	  type: true,
	  useMap: true,
	  value: true,
	  width: true,
	  wmode: true,
	  wrap: true,
	
	  /**
	   * RDFa Properties
	   */
	  about: true,
	  datatype: true,
	  inlist: true,
	  prefix: true,
	  // property is also supported for OpenGraph in meta tags.
	  property: true,
	  resource: true,
	  typeof: true,
	  vocab: true,
	
	  /**
	   * Non-standard Properties
	   */
	  // autoCapitalize and autoCorrect are supported in Mobile Safari for
	  // keyboard hints.
	  autoCapitalize: true,
	  autoCorrect: true,
	  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	  autoSave: true,
	  // color is for Safari mask-icon link
	  color: true,
	  // itemProp, itemScope, itemType are for
	  // Microdata support. See http://schema.org/docs/gs.html
	  itemProp: true,
	  itemScope: true,
	  itemType: true,
	  // itemID and itemRef are for Microdata support as well but
	  // only specified in the WHATWG spec document. See
	  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	  itemID: true,
	  itemRef: true,
	  // results show looking glass icon and recent searches on input
	  // search fields in WebKit/Blink
	  results: true,
	  // IE-only attribute that specifies security restrictions on an iframe
	  // as an alternative to the sandbox attribute on IE<1true
	  security: true,
	  // IE-only attribute that controls focus behavior
	  unselectable: true,
	  //
	  // SVG properties: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
	  // The following "onX" events have been omitted:
	  //
	  //  onabort
	  //  onactivate
	  //  onbegin
	  //  onclick
	  //  onend
	  //  onerror
	  //  onfocusin
	  //  onfocusout
	  //  onload
	  //  onmousedown
	  //  onmousemove
	  //  onmouseout
	  //  onmouseover
	  //  onmouseup
	  //  onrepeat
	  //  onresize
	  //  onscroll
	  //  onunload
	  accentHeight: true,
	  accumulate: true,
	  additive: true,
	  alignmentBaseline: true,
	  allowReorder: true,
	  alphabetic: true,
	  amplitude: true,
	  arabicForm: true,
	  ascent: true,
	  attributeName: true,
	  attributeType: true,
	  autoReverse: true,
	  azimuth: true,
	  baseFrequency: true,
	  baselineShift: true,
	  baseProfile: true,
	  bbox: true,
	  begin: true,
	  bias: true,
	  by: true,
	  calcMode: true,
	  capHeight: true,
	  clip: true,
	  clipPathUnits: true,
	  clipPath: true,
	  clipRule: true,
	  colorInterpolation: true,
	  colorInterpolationFilters: true,
	  colorProfile: true,
	  colorRendering: true,
	  contentScriptType: true,
	  contentStyleType: true,
	  cursor: true,
	  cx: true,
	  cy: true,
	  d: true,
	  decelerate: true,
	  descent: true,
	  diffuseConstant: true,
	  direction: true,
	  display: true,
	  divisor: true,
	  dominantBaseline: true,
	  dur: true,
	  dx: true,
	  dy: true,
	  edgeMode: true,
	  elevation: true,
	  enableBackground: true,
	  end: true,
	  exponent: true,
	  externalResourcesRequired: true,
	  fill: true,
	  fillOpacity: true,
	  fillRule: true,
	  filter: true,
	  filterRes: true,
	  filterUnits: true,
	  floodColor: true,
	  floodOpacity: true,
	  focusable: true,
	  fontFamily: true,
	  fontSize: true,
	  fontSizeAdjust: true,
	  fontStretch: true,
	  fontStyle: true,
	  fontVariant: true,
	  fontWeight: true,
	  format: true,
	  from: true,
	  fr: true, // valid SVG element but React will ask for removal
	  fx: true,
	  fy: true,
	  g1: true,
	  g2: true,
	  glyphName: true,
	  glyphOrientationHorizontal: true,
	  glyphOrientationVertical: true,
	  glyphRef: true,
	  gradientTransform: true,
	  gradientUnits: true,
	  hanging: true,
	  horizAdvX: true,
	  horizOriginX: true,
	  ideographic: true,
	  imageRendering: true,
	  in: true,
	  in2: true,
	  intercept: true,
	  k: true,
	  k1: true,
	  k2: true,
	  k3: true,
	  k4: true,
	  kernelMatrix: true,
	  kernelUnitLength: true,
	  kerning: true,
	  keyPoints: true,
	  keySplines: true,
	  keyTimes: true,
	  lengthAdjust: true,
	  letterSpacing: true,
	  lightingColor: true,
	  limitingConeAngle: true,
	  local: true,
	  markerEnd: true,
	  markerMid: true,
	  markerStart: true,
	  markerHeight: true,
	  markerUnits: true,
	  markerWidth: true,
	  mask: true,
	  maskContentUnits: true,
	  maskUnits: true,
	  mathematical: true,
	  mode: true,
	  numOctaves: true,
	  offset: true,
	  opacity: true,
	  operator: true,
	  order: true,
	  orient: true,
	  orientation: true,
	  origin: true,
	  overflow: true,
	  overlinePosition: true,
	  overlineThickness: true,
	  panose1: true,
	  paintOrder: true,
	  pathLength: true,
	  patternContentUnits: true,
	  patternTransform: true,
	  patternUnits: true,
	  pointerEvents: true,
	  points: true,
	  pointsAtX: true,
	  pointsAtY: true,
	  pointsAtZ: true,
	  preserveAlpha: true,
	  preserveAspectRatio: true,
	  primitiveUnits: true,
	  r: true,
	  radius: true,
	  refX: true,
	  refY: true,
	  renderingIntent: true,
	  repeatCount: true,
	  repeatDur: true,
	  requiredExtensions: true,
	  requiredFeatures: true,
	  restart: true,
	  result: true,
	  rotate: true,
	  rx: true,
	  ry: true,
	  scale: true,
	  seed: true,
	  shapeRendering: true,
	  slope: true,
	  spacing: true,
	  specularConstant: true,
	  specularExponent: true,
	  speed: true,
	  spreadMethod: true,
	  startOffset: true,
	  stdDeviation: true,
	  stemh: true,
	  stemv: true,
	  stitchTiles: true,
	  stopColor: true,
	  stopOpacity: true,
	  strikethroughPosition: true,
	  strikethroughThickness: true,
	  string: true,
	  stroke: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeLinecap: true,
	  strokeLinejoin: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true,
	  surfaceScale: true,
	  systemLanguage: true,
	  tableValues: true,
	  targetX: true,
	  targetY: true,
	  textAnchor: true,
	  textDecoration: true,
	  textRendering: true,
	  textLength: true,
	  to: true,
	  transform: true,
	  u1: true,
	  u2: true,
	  underlinePosition: true,
	  underlineThickness: true,
	  unicode: true,
	  unicodeBidi: true,
	  unicodeRange: true,
	  unitsPerEm: true,
	  vAlphabetic: true,
	  vHanging: true,
	  vIdeographic: true,
	  vMathematical: true,
	  values: true,
	  vectorEffect: true,
	  version: true,
	  vertAdvY: true,
	  vertOriginX: true,
	  vertOriginY: true,
	  viewBox: true,
	  viewTarget: true,
	  visibility: true,
	  widths: true,
	  wordSpacing: true,
	  writingMode: true,
	  x: true,
	  xHeight: true,
	  x1: true,
	  x2: true,
	  xChannelSelector: true,
	  xlinkActuate: true,
	  xlinkArcrole: true,
	  xlinkHref: true,
	  xlinkRole: true,
	  xlinkShow: true,
	  xlinkTitle: true,
	  xlinkType: true,
	  xmlBase: true,
	  xmlns: true,
	  xmlnsXlink: true,
	  xmlLang: true,
	  xmlSpace: true,
	  y: true,
	  y1: true,
	  y2: true,
	  yChannelSelector: true,
	  z: true,
	  zoomAndPan: true,
	
	  //
	  // react-router specific
	  //
	  query: true,
	  activeClassName: true,
	  params: true
	};
	
	exports.default = new RegExp('^((' + Object.keys(props).join('|') + ')|(on[A-Z].*)|((data|aria)-.*))$');

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 
	 * 
	 * Lookup to determine what props we include in style
	 *
	 * For now this is limited purely to style rules dealing with
	 * layout and sizing (cur. box & text layout).
	 */
	exports.default = {
	  alignItems: true,
	  alignContent: true,
	  alignSelf: true,
	  borderWidth: true,
	  borderTopWidth: true,
	  borderRightWidth: true,
	  borderBottomWidth: true,
	  borderLeftWidth: true,
	  display: true,
	  cursor: true,
	  flex: true,
	  flexBasis: true,
	  flexDirection: true,
	  flexFlow: true,
	  flexGrow: true,
	  flexShrink: true,
	  flexWrap: true,
	  justifyContent: true,
	  order: true,
	  padding: true,
	  paddingTop: true,
	  paddingRight: true,
	  paddingBottom: true,
	  paddingLeft: true,
	  margin: true,
	  marginTop: true,
	  marginRight: true,
	  marginBottom: true,
	  marginLeft: true,
	  position: true,
	  top: true,
	  right: true,
	  bottom: true,
	  left: true,
	  width: true,
	  height: true,
	  minWidth: true,
	  minHeight: true,
	  maxWidth: true,
	  maxHeight: true,
	  float: true,
	  zIndex: true,
	  overflow: true,
	  overflowX: true,
	  overflowY: true,
	  tableLayout: true,
	  verticalAlign: true,
	  textAlign: true,
	  textAlignLast: true,
	  textIndent: true,
	  textOverflow: true,
	  textTransform: true,
	  whiteSpace: true,
	  wordBreak: true,
	  wordSpacing: true,
	  wordWrap: true,
	  lineHeight: true,
	  boxSizing: true
	};

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(376);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(143);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 260px;\n  background-color: ', ';\n  height: 100%;\n  min-height: 100vh;\n  position: sticky;\n  top: 0;\n'], ['\n  width: 260px;\n  background-color: ', ';\n  height: 100%;\n  min-height: 100vh;\n  position: sticky;\n  top: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 14px;\n  font-weight: 500;\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  padding: 16px 32px;\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n'], ['\n  font-size: 14px;\n  font-weight: 500;\n  color: ', ';\n  background-color: ', ';\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  padding: 16px 32px;\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 16px 0 0;\n  padding: 0;\n'], ['\n  margin: 16px 0 0;\n  padding: 0;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 0;\n  width: 100%;\n  padding: 8px 8px 8px 32px;\n  font-size: 16px;\n  font-weight: 500;\n  color: ', ';\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n'], ['\n  margin: 0;\n  width: 100%;\n  padding: 8px 8px 8px 32px;\n  font-size: 16px;\n  font-weight: 500;\n  color: ', ';\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyLink = __webpack_require__(497);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledAside = (0, _reactEmotion2.default)('aside')(_templateObject, function (props) {
	  return props.theme.colors.navy700;
	});
	
	var StyledAsideHeader = (0, _reactEmotion2.default)('div')(_templateObject2, function (props) {
	  return props.theme.colors.navy300;
	}, function (props) {
	  return props.theme.colors.navy600;
	});
	
	var StyledList = (0, _reactEmotion2.default)('ul')(_templateObject3);
	
	var StyledListItem = (0, _reactEmotion2.default)('li')(_templateObject4, function (props) {
	  return props.theme.colors.white;
	});
	
	var BrandLogo = function BrandLogo() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: 60,
	      style: { marginBottom: 8 },
	      viewBox: '0 0 368 161'
	    },
	    _react2.default.createElement('path', {
	      fill: '#fff',
	      fillRule: 'evenodd',
	      d: 'M31.4925825,84.3854667 C35.6191845,84.3854667 39.0919612,82.6216222 42.3503689,79.3175444 L76.0152233,44.0657 C79.2736311,40.5398 82.9643495,38.7759556 87.3106796,38.7759556 C100.340738,38.7759556 105.553476,55.0798889 97.7343689,63.0154 L63.199534,97.6053556 L96.648233,132.8572 C102.51301,139.245322 102.947107,148.059178 97.0841165,154.449089 C94.4759612,157.3131 90.9996117,158.856911 86.6568544,158.856911 C82.0979417,158.856911 78.4036505,157.093067 75.5811262,153.7872 L42.3503689,117.4334 C39.3134757,114.129322 35.8353398,112.367267 31.9266796,112.367267 L29.1041553,112.367267 L29.1041553,143.873178 C29.1041553,152.467 23.0214369,159.078733 14.5502913,159.078733 C6.73297087,159.078733 0,152.026933 0,143.873178 L0,15.2019778 C-3.17329765e-15,6.60994444 6.51502913,0 14.5502913,0 C22.5891262,0 29.1041553,6.60994444 29.1041553,15.2019778 L29.1041553,84.3854667 L31.4925825,84.3854667 Z M205.013515,137.265022 C205.013515,141.891089 203.277126,145.195167 199.80435,147.6209 C188.074796,155.772867 172.87068,159.737044 153.975845,159.737044 C124.221437,159.737044 108.149126,143.214867 108.149126,120.961089 C108.149126,100.469367 122.701204,85.0473556 152.889709,85.0473556 C159.840621,85.0473556 167.87767,86.1493111 176.999068,88.3532222 L176.999068,82.4033778 C176.999068,70.7255111 171.134291,65.2157333 156.366058,65.2157333 C150.068971,65.2157333 143.116272,66.5395111 135.515107,68.9634556 C123.571184,72.7093889 115.534136,66.9777889 115.534136,57.5056222 C115.534136,51.1157111 118.790757,46.7096778 125.091417,44.0657 C133.562563,40.3197667 144.202408,38.5559222 157.016311,38.5559222 C188.94299,38.5559222 205.013515,53.5396556 205.013515,83.2835111 L205.013515,137.265022 L205.013515,137.265022 Z M176.999068,128.893022 L176.999068,109.059611 C169.178175,106.637456 162.011107,105.5355 155.278136,105.5355 C143.768311,105.5355 136.383301,111.263522 136.383301,119.857344 C136.383301,129.3313 143.768311,134.619256 155.930175,134.619256 C163.96901,134.619256 171.132505,132.633589 176.999068,128.889444 L176.999068,128.893022 Z M248.178485,144.821289 C248.178485,153.413322 242.095767,160.023267 233.624621,160.023267 C225.807301,160.023267 219.07433,152.973256 219.07433,144.821289 L219.07433,16.3683333 C219.07433,7.7763 225.589359,0.948111111 233.624621,0.948111111 C241.663456,0.948111111 248.178485,7.7763 248.178485,16.3683333 L248.178485,144.821289 L248.178485,144.821289 Z M350.920155,147.252389 C341.366447,155.626178 329.420738,159.810389 315.084816,159.810389 C300.966835,159.810389 289.022913,155.626178 279.249476,147.252389 C269.476039,138.880389 264.045359,128.084444 262.96101,115.084589 C262.308971,104.7305 262.308971,94.1545889 262.96101,83.5786778 C264.045359,70.357 269.258097,59.5610556 279.031534,51.1890556 C288.806757,42.8170556 300.968621,38.6310556 315.086602,38.6310556 C329.420738,38.6310556 341.36466,42.8170556 350.921942,51.1890556 C360.477437,59.5610556 365.908117,70.357 366.994252,83.5786778 C367.646291,93.9345556 367.646291,104.508678 366.994252,114.862767 C365.908117,128.084444 360.477437,138.882178 350.920155,147.252389 L350.920155,147.252389 Z M338.108039,88.2029556 C337.459573,75.6449556 328.766913,66.8328889 315.086602,66.8328889 C301.836816,66.8328889 292.931573,75.2048889 291.845437,88.2029556 C291.193978,95.5336484 291.193978,102.907796 291.845437,110.238489 C292.931573,123.236556 301.836816,131.608556 315.086602,131.608556 C328.334602,131.608556 337.238058,123.236556 338.108039,110.238489 C338.760979,102.907862 338.760979,95.5335824 338.108039,88.2029556 L338.108039,88.2029556 Z'
	    })
	  );
	};
	
	exports.default = function (_ref) {
	  var pages = _ref.pages;
	
	  return _react2.default.createElement(
	    StyledAside,
	    null,
	    _react2.default.createElement(
	      StyledAsideHeader,
	      null,
	      _react2.default.createElement(BrandLogo, null),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'API Documentation'
	      )
	    ),
	    _react2.default.createElement(
	      StyledList,
	      null,
	      pages.edges.map(function (page) {
	        return _react2.default.createElement(
	          StyledListItem,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: page.node.fields.slug },
	            page.node.frontmatter.title
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  padding: 8px 0;\n  border-top: 1px solid ', ';\n  margin-top: 32px;\n  font-size: 14px;\n  color: ', ';\n  font-weight: 400;\n'], ['\n  width: 100%;\n  padding: 8px 0;\n  border-top: 1px solid ', ';\n  margin-top: 32px;\n  font-size: 14px;\n  color: ', ';\n  font-weight: 400;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledFooter = (0, _reactEmotion2.default)('footer')(_templateObject, function (props) {
	  return props.theme.colors.grey300;
	}, function (props) {
	  return props.theme.colors.navy500;
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    StyledFooter,
	    null,
	    '\xA9 2018 - Kalo Industries, Inc.'
	  );
	};
	
	module.exports = exports['default'];

/***/ }),
/* 375 */,
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  display: flex;\n'], ['\n  width: 100%;\n  display: flex;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 100%;\n  max-width: 920px;\n  padding: 40px;\n'], ['\n  position: relative;\n  width: 100%;\n  max-width: 920px;\n  padding: 40px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 300;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n      url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 400;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 500;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 600;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  body {\n    font-family: \'WebFaktSoftPro\', sans-serif;\n    color: #546789;\n  }\n\n  code[class*=\'language-\'],\n  pre[class*=\'language-\'] {\n    font-family: Consolas, Menlo, Monaco, \'Andale Mono WT\', \'Andale Mono\',\n      \'Lucida Console\', \'Lucida Sans Typewriter\', \'DejaVu Sans Mono\',\n      \'Bitstream Vera Sans Mono\', \'Liberation Mono\', \'Nimbus Mono L\',\n      \'Courier New\', Courier, monospace;\n    font-size: 14px;\n    line-height: 1.375;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    tab-size: 4;\n    -ms-hyphens: none;\n    hyphens: none;\n    background-color: #f4f7fd;\n    color: #586e75;\n    border-radius: 4px;\n  }\n  pre[class*=\'language-\']::-moz-selection,\n  pre[class*=\'language-\'] ::-moz-selection,\n  code[class*=\'language-\']::-moz-selection,\n  code[class*=\'language-\'] ::-moz-selection {\n    text-shadow: none;\n    background: #eee8d5;\n  }\n  pre[class*=\'language-\']::selection,\n  pre[class*=\'language-\'] ::selection,\n  code[class*=\'language-\']::selection,\n  code[class*=\'language-\'] ::selection {\n    text-shadow: none;\n    background: #eee8d5;\n  }\n  pre[class*=\'language-\'] {\n    padding: 1em;\n    margin: 0.5em 0;\n    overflow: auto;\n  }\n  :not(pre) > code[class*=\'language-\'] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n  }\n  .token.comment,\n  .token.prolog,\n  .token.doctype,\n  .token.cdata {\n    color: #839496;\n  }\n  .token.punctuation {\n    color: #586e75;\n  }\n  .token.namespace {\n    opacity: 0.7;\n  }\n  .token.operator,\n  .token.boolean,\n  .token.number {\n    color: #cb4b16;\n  }\n  .token.property {\n    color: #b58900;\n  }\n  .token.tag {\n    color: #268bd2;\n  }\n  .token.string {\n    color: #2aa198;\n  }\n  .token.selector {\n    color: #6c71c4;\n  }\n  .token.attr-name {\n    color: #cb4b16;\n  }\n  .token.entity,\n  .token.url,\n  .language-css .token.string,\n  .style .token.string {\n    color: #2aa198;\n  }\n  .token.attr-value,\n  .token.keyword,\n  .token.control,\n  .token.directive,\n  .token.unit {\n    color: #859900;\n  }\n  .token.statement,\n  .token.regex,\n  .token.atrule {\n    color: #2aa198;\n  }\n  .token.placeholder,\n  .token.variable {\n    color: #268bd2;\n  }\n  .token.deleted {\n    text-decoration: line-through;\n  }\n  .token.inserted {\n    border-bottom: 1px dotted #002b36;\n    text-decoration: none;\n  }\n  .token.italic {\n    font-style: italic;\n  }\n  .token.important,\n  .token.bold {\n    font-weight: bold;\n  }\n  .token.important {\n    color: #dc322f;\n  }\n  .token.entity {\n    cursor: help;\n  }\n  pre > code.highlight {\n    outline: 0.4em solid #dc322f;\n    outline-offset: 0.4em;\n  }'], ['\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 300;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n      url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 400;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 500;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  @font-face {\n    font-family: \'WebFaktSoftPro\';\n    font-weight: 600;\n    font-style: normal;\n    src: url(', ') format(\'woff\'),\n    url(', ') format(\'woff2\');\n  }\n\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  body {\n    font-family: \'WebFaktSoftPro\', sans-serif;\n    color: #546789;\n  }\n\n  code[class*=\'language-\'],\n  pre[class*=\'language-\'] {\n    font-family: Consolas, Menlo, Monaco, \'Andale Mono WT\', \'Andale Mono\',\n      \'Lucida Console\', \'Lucida Sans Typewriter\', \'DejaVu Sans Mono\',\n      \'Bitstream Vera Sans Mono\', \'Liberation Mono\', \'Nimbus Mono L\',\n      \'Courier New\', Courier, monospace;\n    font-size: 14px;\n    line-height: 1.375;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    tab-size: 4;\n    -ms-hyphens: none;\n    hyphens: none;\n    background-color: #f4f7fd;\n    color: #586e75;\n    border-radius: 4px;\n  }\n  pre[class*=\'language-\']::-moz-selection,\n  pre[class*=\'language-\'] ::-moz-selection,\n  code[class*=\'language-\']::-moz-selection,\n  code[class*=\'language-\'] ::-moz-selection {\n    text-shadow: none;\n    background: #eee8d5;\n  }\n  pre[class*=\'language-\']::selection,\n  pre[class*=\'language-\'] ::selection,\n  code[class*=\'language-\']::selection,\n  code[class*=\'language-\'] ::selection {\n    text-shadow: none;\n    background: #eee8d5;\n  }\n  pre[class*=\'language-\'] {\n    padding: 1em;\n    margin: 0.5em 0;\n    overflow: auto;\n  }\n  :not(pre) > code[class*=\'language-\'] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n  }\n  .token.comment,\n  .token.prolog,\n  .token.doctype,\n  .token.cdata {\n    color: #839496;\n  }\n  .token.punctuation {\n    color: #586e75;\n  }\n  .token.namespace {\n    opacity: 0.7;\n  }\n  .token.operator,\n  .token.boolean,\n  .token.number {\n    color: #cb4b16;\n  }\n  .token.property {\n    color: #b58900;\n  }\n  .token.tag {\n    color: #268bd2;\n  }\n  .token.string {\n    color: #2aa198;\n  }\n  .token.selector {\n    color: #6c71c4;\n  }\n  .token.attr-name {\n    color: #cb4b16;\n  }\n  .token.entity,\n  .token.url,\n  .language-css .token.string,\n  .style .token.string {\n    color: #2aa198;\n  }\n  .token.attr-value,\n  .token.keyword,\n  .token.control,\n  .token.directive,\n  .token.unit {\n    color: #859900;\n  }\n  .token.statement,\n  .token.regex,\n  .token.atrule {\n    color: #2aa198;\n  }\n  .token.placeholder,\n  .token.variable {\n    color: #268bd2;\n  }\n  .token.deleted {\n    text-decoration: line-through;\n  }\n  .token.inserted {\n    border-bottom: 1px dotted #002b36;\n    text-decoration: none;\n  }\n  .token.italic {\n    font-style: italic;\n  }\n  .token.important,\n  .token.bold {\n    font-weight: bold;\n  }\n  .token.important {\n    color: #dc322f;\n  }\n  .token.entity {\n    cursor: help;\n  }\n  pre > code.highlight {\n    outline: 0.4em solid #dc322f;\n    outline-offset: 0.4em;\n  }']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _emotionTheming = __webpack_require__(463);
	
	var _ui = __webpack_require__(337);
	
	var _reactEmotion = __webpack_require__(11);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _aside = __webpack_require__(373);
	
	var _aside2 = _interopRequireDefault(_aside);
	
	var _footer = __webpack_require__(374);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _FaktSoftProBlond = __webpack_require__(489);
	
	var _FaktSoftProBlond2 = _interopRequireDefault(_FaktSoftProBlond);
	
	var _FaktSoftProBlond3 = __webpack_require__(490);
	
	var _FaktSoftProBlond4 = _interopRequireDefault(_FaktSoftProBlond3);
	
	var _FaktSoftProNormal = __webpack_require__(493);
	
	var _FaktSoftProNormal2 = _interopRequireDefault(_FaktSoftProNormal);
	
	var _FaktSoftProNormal3 = __webpack_require__(494);
	
	var _FaktSoftProNormal4 = _interopRequireDefault(_FaktSoftProNormal3);
	
	var _FaktSoftProMedium = __webpack_require__(491);
	
	var _FaktSoftProMedium2 = _interopRequireDefault(_FaktSoftProMedium);
	
	var _FaktSoftProMedium3 = __webpack_require__(492);
	
	var _FaktSoftProMedium4 = _interopRequireDefault(_FaktSoftProMedium3);
	
	var _FaktSoftProSemiBold = __webpack_require__(495);
	
	var _FaktSoftProSemiBold2 = _interopRequireDefault(_FaktSoftProSemiBold);
	
	var _FaktSoftProSemiBold3 = __webpack_require__(496);
	
	var _FaktSoftProSemiBold4 = _interopRequireDefault(_FaktSoftProSemiBold3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledFlexContainer = (0, _reactEmotion2.default)('div')(_templateObject);
	
	var Main = (0, _reactEmotion2.default)('main')(_templateObject2);
	
	(0, _reactEmotion.injectGlobal)(_templateObject3, _FaktSoftProBlond2.default, _FaktSoftProBlond4.default, _FaktSoftProNormal2.default, _FaktSoftProNormal4.default, _FaktSoftProMedium2.default, _FaktSoftProMedium4.default, _FaktSoftProSemiBold2.default, _FaktSoftProSemiBold4.default);
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  var pages = data.allMarkdownRemark;
	
	
	  return _react2.default.createElement(
	    _emotionTheming.ThemeProvider,
	    { theme: _ui.theme },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        StyledFlexContainer,
	        null,
	        _react2.default.createElement(_aside2.default, { pages: pages }),
	        _react2.default.createElement(
	          Main,
	          null,
	          children(),
	          ' ',
	          _react2.default.createElement(_footer2.default, null)
	        )
	      )
	    )
	  );
	};
	
	exports.default = TemplateWrapper;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(391), __esModule: true };

/***/ }),
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(393), __esModule: true };

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(396), __esModule: true };

/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(743);


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(416);
	module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(418);
	var $Object = __webpack_require__(18).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(419);
	var $Object = __webpack_require__(18).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(420);
	module.exports = __webpack_require__(18).Object.freeze;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(421);
	module.exports = __webpack_require__(18).Object.keys;


/***/ }),
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(71);
	var gOPS = __webpack_require__(123);
	var pIE = __webpack_require__(85);
	var toObject = __webpack_require__(128);
	var IObject = __webpack_require__(207);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(50)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(40);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(408) });


/***/ }),
/* 417 */,
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(40);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperties: __webpack_require__(210) });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(40);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperty: __webpack_require__(45).f });


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(52);
	var meta = __webpack_require__(209).onFreeze;
	
	__webpack_require__(214)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(128);
	var $keys = __webpack_require__(71);
	
	__webpack_require__(214)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(92);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(455);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(93);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 462 */,
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(4));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(235));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    for (var key in listeners) {
	      // $FlowFixMe
	      var listener = listeners[key];
	
	      if (listener === undefined) {
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	};
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	// adapted from styled-components' ThemeProvider
	// https://github.com/styled-components/styled-components/blob/4503cab5b86aa9ef8314c5baa360a2fbb4812485/src/models/ThemeProvider.js
	var isPlainObject = function isPlainObject(test) {
	  return Object.prototype.toString.call(test) === '[object Object]';
	};
	
	function _componentWillMount() {
	  var _this2 = this;
	
	  function _ref2(theme) {
	    _this2.outerTheme = theme;
	
	    if (_this2.broadcast !== undefined) {
	      _this2.publish(_this2.props.theme);
	    }
	  }
	
	  // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	  // with the outer theme
	  if (this.context[channel] !== undefined) {
	    this.unsubscribeToOuterId = this.context[channel].subscribe(_ref2);
	  }
	
	  this.broadcast = createBroadcast(this.getTheme(this.props.theme));
	}
	
	function _getChildContext() {
	  var _ref;
	
	  return _ref = {}, _ref[channel] = {
	    subscribe: this.broadcast.subscribe,
	    unsubscribe: this.broadcast.unsubscribe
	  }, _ref;
	}
	
	function _componentWillReceive(nextProps) {
	  if (this.props.theme !== nextProps.theme) {
	    this.publish(nextProps.theme);
	  }
	}
	
	function _componentWillUnmount() {
	  var themeContext = this.context[channel];
	
	  if (themeContext !== undefined) {
	    themeContext.unsubscribe(this.unsubscribeToOuterId);
	  }
	}
	
	function _getTheme(theme) {
	  if (typeof theme === 'function') {
	    var mergedTheme = theme(this.outerTheme);
	
	    if (!isPlainObject(mergedTheme)) {
	      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	    }
	
	    return mergedTheme;
	  }
	
	  if (!isPlainObject(theme)) {
	    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	  }
	
	  if (this.outerTheme === undefined) {
	    return theme;
	  }
	
	  return _extends({}, this.outerTheme, theme);
	}
	
	function _publish(theme) {
	  this.broadcast.publish(this.getTheme(theme));
	}
	
	function _render() {
	  if (!this.props.children) {
	    return null;
	  }
	
	  return React.Children.only(this.props.children);
	}
	
	var ThemeProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    var _this;
	
	    _this = _Component.call(this) || this;
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  var _proto = ThemeProvider.prototype;
	  _proto.componentWillMount = _componentWillMount;
	  _proto.getChildContext = _getChildContext;
	  _proto.componentWillReceiveProps = _componentWillReceive;
	  _proto.componentWillUnmount = _componentWillUnmount; // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	  _proto.getTheme = _getTheme;
	  _proto.publish = _publish;
	  _proto.render = _render;
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextTypes;
	ThemeProvider.contextTypes = contextTypes;
	
	function _componentWillMount$1() {
	  var _this = this;
	
	  var themeContext = this.context[channel];
	
	  if (themeContext === undefined) {
	    // eslint-disable-next-line no-console
	    console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	    return;
	  }
	
	  this.unsubscribeId = themeContext.subscribe(function (theme) {
	    _this.setState({
	      theme: theme
	    });
	  });
	}
	
	function _componentWillUnmount$1() {
	  if (this.unsubscribeId !== -1) {
	    this.context[channel].unsubscribe(this.unsubscribeId);
	  }
	}
	
	var withTheme = function withTheme(Component$$1) {
	  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
	
	  function _render() {
	    return React.createElement(Component$$1, _extends({
	      theme: this.state.theme
	    }, this.props));
	  }
	
	  var WithTheme =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(WithTheme, _React$Component);
	
	    function WithTheme() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = WithTheme.prototype;
	    _proto.componentWillMount = _componentWillMount$1;
	    _proto.componentWillUnmount = _componentWillUnmount$1;
	    _proto.render = _render;
	    return WithTheme;
	  }(React.Component);
	
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  WithTheme.contextTypes = contextTypes;
	  return hoistNonReactStatics(WithTheme, Component$$1);
	};
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.channel = channel;
	exports.contextTypes = contextTypes;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Blond.bbabd485.woff";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Blond.6cfc3d88.woff2";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Medium.3550ddb5.woff";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Medium.e5abd3fc.woff2";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Normal.c7d0206b.woff";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-Normal.4406e575.woff2";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-SemiBold.dd14bd25.woff";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FaktSoftPro-SemiBold.e906b628.woff2";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(384);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(8);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(115);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(234);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (true) {
	  pathPrefix = ("/publicapi-docs");
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.path);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.path);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.path);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.path);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(pathname) {
	  window.___navigateTo(pathname);
	};

/***/ }),
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(29);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(584),
	    hashDelete = __webpack_require__(585),
	    hashGet = __webpack_require__(586),
	    hashHas = __webpack_require__(587),
	    hashSet = __webpack_require__(588);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(29);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(29);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(145),
	    setCacheAdd = __webpack_require__(611),
	    setCacheHas = __webpack_require__(612);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(29);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(46),
	    keys = __webpack_require__(62);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(46),
	    keysIn = __webpack_require__(109);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(97),
	    arrayEach = __webpack_require__(238),
	    assignValue = __webpack_require__(98),
	    baseAssign = __webpack_require__(535),
	    baseAssignIn = __webpack_require__(536),
	    cloneBuffer = __webpack_require__(245),
	    copyArray = __webpack_require__(247),
	    copySymbols = __webpack_require__(571),
	    copySymbolsIn = __webpack_require__(572),
	    getAllKeys = __webpack_require__(252),
	    getAllKeysIn = __webpack_require__(151),
	    getTag = __webpack_require__(254),
	    initCloneArray = __webpack_require__(589),
	    initCloneByTag = __webpack_require__(590),
	    initCloneObject = __webpack_require__(255),
	    isArray = __webpack_require__(13),
	    isBuffer = __webpack_require__(108),
	    isObject = __webpack_require__(23),
	    keys = __webpack_require__(62);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(243),
	    createBaseEach = __webpack_require__(574);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(147),
	    isFlattenable = __webpack_require__(591);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(97),
	    equalArrays = __webpack_require__(250),
	    equalByTag = __webpack_require__(577),
	    equalObjects = __webpack_require__(578),
	    getTag = __webpack_require__(254),
	    isArray = __webpack_require__(13),
	    isBuffer = __webpack_require__(108),
	    isTypedArray = __webpack_require__(160);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(97),
	    baseIsEqual = __webpack_require__(148);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(156),
	    isMasked = __webpack_require__(594),
	    isObject = __webpack_require__(23),
	    toSource = __webpack_require__(263);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isLength = __webpack_require__(157),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(104),
	    nativeKeys = __webpack_require__(606);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23),
	    isPrototype = __webpack_require__(104),
	    nativeKeysIn = __webpack_require__(607);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(544),
	    getMatchData = __webpack_require__(580),
	    matchesStrictComparable = __webpack_require__(258);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(148),
	    get = __webpack_require__(623),
	    hasIn = __webpack_require__(624),
	    isKey = __webpack_require__(154),
	    isStrictComparable = __webpack_require__(256),
	    matchesStrictComparable = __webpack_require__(258),
	    toKey = __webpack_require__(59);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(97),
	    assignMergeValue = __webpack_require__(241),
	    baseFor = __webpack_require__(242),
	    baseMergeDeep = __webpack_require__(552),
	    isObject = __webpack_require__(23),
	    keysIn = __webpack_require__(109);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(241),
	    cloneBuffer = __webpack_require__(245),
	    cloneTypedArray = __webpack_require__(246),
	    copyArray = __webpack_require__(247),
	    initCloneObject = __webpack_require__(255),
	    isArguments = __webpack_require__(107),
	    isArray = __webpack_require__(13),
	    isArrayLikeObject = __webpack_require__(625),
	    isBuffer = __webpack_require__(108),
	    isFunction = __webpack_require__(156),
	    isObject = __webpack_require__(23),
	    isPlainObject = __webpack_require__(158),
	    isTypedArray = __webpack_require__(160),
	    toPlainObject = __webpack_require__(636);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(101),
	    baseSet = __webpack_require__(557),
	    castPath = __webpack_require__(58);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(101);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(106),
	    overRest = __webpack_require__(260),
	    setToString = __webpack_require__(262);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(98),
	    castPath = __webpack_require__(58),
	    isIndex = __webpack_require__(103),
	    isObject = __webpack_require__(23),
	    toKey = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(621),
	    defineProperty = __webpack_require__(249),
	    identity = __webpack_require__(106);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57),
	    arrayMap = __webpack_require__(146),
	    isArray = __webpack_require__(13),
	    isSymbol = __webpack_require__(159);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(58),
	    last = __webpack_require__(628),
	    parent = __webpack_require__(610),
	    toKey = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(106);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(150);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(530),
	    arrayReduce = __webpack_require__(240),
	    mapToArray = __webpack_require__(257);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(531),
	    arrayReduce = __webpack_require__(240),
	    setToArray = __webpack_require__(261);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(46),
	    getSymbols = __webpack_require__(153);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(46),
	    getSymbolsIn = __webpack_require__(253);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(29);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(60);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(158);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57),
	    Uint8Array = __webpack_require__(237),
	    eq = __webpack_require__(75),
	    equalArrays = __webpack_require__(250),
	    mapToArray = __webpack_require__(257),
	    setToArray = __webpack_require__(261);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(252);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(622),
	    overRest = __webpack_require__(260),
	    setToString = __webpack_require__(262);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(256),
	    keys = __webpack_require__(62);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(58),
	    isArguments = __webpack_require__(107),
	    isArray = __webpack_require__(13),
	    isIndex = __webpack_require__(103),
	    isLength = __webpack_require__(157),
	    toKey = __webpack_require__(59);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(105);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(105);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(105);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(105);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(150),
	    cloneDataView = __webpack_require__(566),
	    cloneMap = __webpack_require__(567),
	    cloneRegExp = __webpack_require__(568),
	    cloneSet = __webpack_require__(569),
	    cloneSymbol = __webpack_require__(570),
	    cloneTypedArray = __webpack_require__(246);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(57),
	    isArguments = __webpack_require__(107),
	    isArray = __webpack_require__(13);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(75),
	    isArrayLike = __webpack_require__(60),
	    isIndex = __webpack_require__(103),
	    isObject = __webpack_require__(23);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(573);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(99);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(99);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(99);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(99);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(525),
	    ListCache = __webpack_require__(96),
	    Map = __webpack_require__(144);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(102);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(102);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(102);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(102);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(630);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(259);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 607 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(101),
	    baseSlice = __webpack_require__(559);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 615 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    Map = __webpack_require__(144),
	    MapCache = __webpack_require__(145);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(605);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(98),
	    copyObject = __webpack_require__(46),
	    createAssigner = __webpack_require__(248),
	    isArrayLike = __webpack_require__(60),
	    isPrototype = __webpack_require__(104),
	    keys = __webpack_require__(62);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(540);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(101);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(541),
	    hasPath = __webpack_require__(583);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(60),
	    isObjectLike = __webpack_require__(30);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(33),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 628 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(100),
	    baseForOwn = __webpack_require__(243),
	    baseIteratee = __webpack_require__(149);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(145);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(551),
	    createAssigner = __webpack_require__(248);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(149),
	    negate = __webpack_require__(632),
	    pickBy = __webpack_require__(267);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(554),
	    basePropertyDeep = __webpack_require__(555),
	    isKey = __webpack_require__(154),
	    toKey = __webpack_require__(59);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 635 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(46),
	    keysIn = __webpack_require__(109);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(561);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 638 */,
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.1
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(453);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(48);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FocusTrap = __webpack_require__(292);
	
	var _FocusTrap2 = _interopRequireDefault(_FocusTrap);
	
	var _HotKeyMapMixin = __webpack_require__(293);
	
	var _HotKeyMapMixin2 = _interopRequireDefault(_HotKeyMapMixin);
	
	var _isBoolean = __webpack_require__(155);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _isArray = __webpack_require__(13);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isObject = __webpack_require__(23);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _forEach = __webpack_require__(264);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isEqual = __webpack_require__(265);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function getSequencesFromMap(hotKeyMap, hotKeyName) {
	  var sequences = hotKeyMap[hotKeyName];
	
	  // If no sequence is found with this name we assume
	  // the user is passing a hard-coded sequence as a key
	  if (!sequences) {
	    return [hotKeyName];
	  }
	
	  if ((0, _isArray2.default)(sequences)) {
	    return sequences;
	  }
	
	  return [sequences];
	}
	
	var HotKeys = (0, _createReactClass2.default)({
	  displayName: 'HotKeys',
	  mixins: [(0, _HotKeyMapMixin2.default)()],
	
	  propTypes: {
	    children: _propTypes2.default.node,
	    onFocus: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    keyMap: _propTypes2.default.object,
	    handlers: _propTypes2.default.object,
	    focused: _propTypes2.default.bool, // externally controlled focus
	    attach: _propTypes2.default.any // dom element to listen for key events
	  },
	
	  contextTypes: {
	    hotKeyParent: _propTypes2.default.any
	  },
	
	  childContextTypes: {
	    hotKeyParent: _propTypes2.default.any
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      hotKeyParent: this
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    // import is here to support React's server rendering as Mousetrap immediately
	    // calls itself with window and it fails in Node environment
	    var Mousetrap = __webpack_require__(639);
	    // Not optimal - imagine hundreds of this component. We need a top level
	    // delegation point for mousetrap
	    this.__mousetrap__ = new Mousetrap(this.props.attach || _reactDom2.default.findDOMNode(this));
	
	    this.updateHotKeys(true);
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    this.updateHotKeys(false, prevProps);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.context.hotKeyParent) {
	      this.context.hotKeyParent.childHandledSequence(null);
	    }
	
	    if (this.__mousetrap__) {
	      this.__mousetrap__.reset();
	    }
	  },
	  updateHotKeys: function updateHotKeys() {
	    var _this = this;
	
	    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _props$handlers = this.props.handlers,
	        handlers = _props$handlers === undefined ? {} : _props$handlers;
	    var _prevProps$handlers = prevProps.handlers,
	        prevHandlers = _prevProps$handlers === undefined ? handlers : _prevProps$handlers;
	
	    // Ensure map is up-to-date to begin with
	    // We will only bother continuing if the map was actually updated
	
	    if (!force && !this.updateMap() && (0, _isEqual2.default)(handlers, prevHandlers)) {
	      return;
	    }
	
	    var hotKeyMap = this.getMap();
	    var sequenceHandlers = [];
	    var mousetrap = this.__mousetrap__;
	
	    // Group all our handlers by sequence
	    (0, _forEach2.default)(handlers, function (handler, hotKey) {
	      var handlerSequences = getSequencesFromMap(hotKeyMap, hotKey);
	
	      // Could be optimized as every handler will get called across every bound
	      // component - imagine making a node a focus point and then having hundreds!
	      (0, _forEach2.default)(handlerSequences, function (sequence) {
	        var action = void 0;
	
	        var callback = function callback(event, sequence) {
	          // Check we are actually in focus and that a child hasn't already handled this sequence
	          var isFocused = (0, _isBoolean2.default)(_this.props.focused) ? _this.props.focused : _this.__isFocused__;
	
	          if (isFocused && sequence !== _this.__lastChildSequence__) {
	            if (_this.context.hotKeyParent) {
	              _this.context.hotKeyParent.childHandledSequence(sequence);
	            }
	
	            return handler(event, sequence);
	          }
	        };
	
	        if ((0, _isObject2.default)(sequence)) {
	          action = sequence.action;
	          sequence = sequence.sequence;
	        }
	
	        sequenceHandlers.push({ callback: callback, action: action, sequence: sequence });
	      });
	    });
	
	    // Hard reset our handlers (probably could be more efficient)
	    mousetrap.reset();
	    (0, _forEach2.default)(sequenceHandlers, function (handler) {
	      return mousetrap.bind(handler.sequence, handler.callback, handler.action);
	    });
	  },
	  childHandledSequence: function childHandledSequence() {
	    var sequence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    this.__lastChildSequence__ = sequence;
	
	    // Traverse up any hot key parents so everyone is aware a child has handled a certain sequence
	    if (this.context.hotKeyParent) {
	      this.context.hotKeyParent.childHandledSequence(sequence);
	    }
	  },
	  onFocus: function onFocus() {
	    this.__isFocused__ = true;
	
	    if (this.props.onFocus) {
	      var _props;
	
	      (_props = this.props).onFocus.apply(_props, arguments);
	    }
	  },
	  onBlur: function onBlur() {
	    this.__isFocused__ = false;
	
	    if (this.props.onBlur) {
	      var _props2;
	
	      (_props2 = this.props).onBlur.apply(_props2, arguments);
	    }
	    if (this.context.hotKeyParent) {
	      this.context.hotKeyParent.childHandledSequence(null);
	    }
	  },
	  render: function render() {
	    var _props3 = this.props,
	        children = _props3.children,
	        keyMap = _props3.keyMap,
	        handlers = _props3.handlers,
	        focused = _props3.focused,
	        attach = _props3.attach,
	        props = _objectWithoutProperties(_props3, ['children', 'keyMap', 'handlers', 'focused', 'attach']);
	
	    return _react2.default.createElement(
	      _FocusTrap2.default,
	      _extends({}, props, { onFocus: this.onFocus, onBlur: this.onBlur }),
	      children
	    );
	  }
	});
	
	exports.default = HotKeys;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HotKeys = __webpack_require__(706);
	
	Object.defineProperty(exports, 'HotKeys', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HotKeys).default;
	  }
	});
	
	var _FocusTrap = __webpack_require__(292);
	
	Object.defineProperty(exports, 'FocusTrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FocusTrap).default;
	  }
	});
	
	var _HotKeyMapMixin = __webpack_require__(293);
	
	Object.defineProperty(exports, 'HotKeyMapMixin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HotKeyMapMixin).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(709);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(729);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(728);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(454);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(456);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(227);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(461);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(48);
	
	var _PropTypes = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(389);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(730);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(744);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 744 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ })
]);


// WEBPACK FOOTER //
// component---src-layouts-index-js-80771f89286da030fe35.js